import { copiarCondicoesPrazo, aplicarDescontoPrazo, precoNegociadoSemFator, revalidarDescontoAoTrocarPrazo } from '../../core/tools/desconto-prazo';
import { PrecoAntesDoPrazo, aplicarPrecoNegociadoNoPrazo, capturarPrecosAntesDoPrazo, haPrecoParaReduzir, prazoReduzFator } from '../../core/tools/preco-negociado-prazo';
import { Component, OnInit, AfterViewInit, Input, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';
import { CurrencyPipe } from '@angular/common';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { NgbModal, NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Animacao } from '../../core/tools/animacao';
import { ToastrService } from 'ngx-toastr';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { PedidoItensCatalogoComponent } from './catalogo/pedido-itens-catalogo.component';
import { PedidoItensToolbarComponent } from './toolbar/pedido-itens-toolbar.component';
import { PedidoItensIaPainelComponent } from './ia-painel/pedido-itens-ia-painel.component';

/* Services */

import { FormatacaoService } from '../../core/tools/formatacao.service';
import { IaService } from '../../core/services/ia/ia.service';
import { PrazoMedioService } from '../../core/services/prazos-medio/prazo-medio.service';
import { ProdutoService } from '../../core/services/produtos/produto.service';

/* Models */

import { Cliente } from '../../core/models/clientes/cliente';
import { Configuracao } from '../../core/models/configuracoes/configuracao';
import { FormaPagamento } from '../../core/models/formas-pagamento/forma-pagamento';
import { Pedido } from '../../core/models/pedidos/pedido';
import { PrazoMedio } from '../../core/models/prazos-medio/prazo-medio';
import { PrazoMedioDesconto } from '../../core/models/prazos-medio/prazo-medio-desconto';
import { PrazoPagamento } from '../../core/models/prazos-pagamento/prazo-pagamento';
import { ProdutoDesconto } from '../../core/models/produtos/produto-desconto';
import { ProdutoFichaTecnica } from '../../core/models/produtos/produto-ficha-tecnica';
import { ProdutoFoto } from '../../core/models/produtos/produto-foto';
import { ProdutoLocal } from '../../core/models/produtos/produto-local';
import { ProdutoLote } from '../../core/models/produtos/produto-lote';
import { ProdutoPromocional } from '../../core/models/produtos/produto-promocional';
import { EstadoPreco, OpcoesEstadoPreco, OrigemPreco } from '../../core/models/produtos/estado-preco';
import { ProdutoPromocionalAgrupado } from '../../core/models/produtos/produto-promocional-agrupado';
import { ProdutoTabela } from '../../core/models/produtos/produto-tabela';
import { TipoPedido } from '../../core/models/tipos/tipo-pedido';
import { Vendedor } from '../../core/models/vendedores/vendedor';
import { IaChatHistorico, IaConfiguracaoCliente, IaResposta } from '../../core/models/ia/ia';

interface IaChatMensagem {
  origem: "USUARIO" | "IA";
  texto: string;
  tipo?: string;
  mensagem?: string;
  sucesso?: boolean;
  data?: Date;
}

@Component({
    selector: 'app-pedido-adicionar-itens-modal',
    templateUrl: './pedido-adicionar-itens-modal.component.html',
    styleUrls: ['./pedido-adicionar-itens-modal.component.scss'],
    preserveWhitespaces: false,
    animations: [Animacao],
    standalone: false
})

export class PedidoAdicionarItensModalComponent implements OnInit, AfterViewInit {
  /* Categorias (Fixas) */

  campanhas: string = "CAMPANHAS";
  combo: string = "COMBO";

  /* Inputs (do componente pai) */

  @Input() produtos: ProdutoPromocional[] = [];
  @Input() produtosAdicionados: ProdutoPromocional[] = [];
  @Input() produtosAdicionadosOriginal: ProdutoPromocional[] = [];
  @Input() produtosComErro: ProdutoPromocional[] = [];
  @Input() configuracao: Configuracao = null;

  /* Setters para produtosOriginal e clienteSelecionado com logging */
  private _produtosOriginal: ProdutoPromocional[] = [];
  private _clienteSelecionado: Cliente = null;

  @Input()
  set produtosOriginal(value: ProdutoPromocional[]) {
    this._produtosOriginal = value || [];
    // Sempre que a lista base mudar, reiniciar lista exibida
    this.reiniciarProdutosDoModal('produtosOriginal');
  }

  get produtosOriginal(): ProdutoPromocional[] {
    return this._produtosOriginal;
  }

  @Input()
  set clienteSelecionado(value: Cliente) {
    this._clienteSelecionado = value;
    // ao trocar cliente, reset visual e espera o pai passar nova lista
    this.produtoSelecionado = null;
    this.enviadoProduto = false;
    this.filtrandoProduto = false;
  }

  get clienteSelecionado(): Cliente {
    return this._clienteSelecionado;
  }
  @Input() vendedorSelecionado: Vendedor = null;
  @Input() tiposPedidoSelecionado: TipoPedido = null;
  @Input() prazoPagamentoSelecionado: PrazoPagamento = null;
  @Input() prazosPagamentoIniciais: PrazoPagamento[] = [];
  @Input() prazosPagamentoEspeciais: PrazoPagamento[] = [];
  @Input() prazosPagamentoOriginal: PrazoPagamento[] = [];
  @Input() tipoOrdenacaoItensPedido: number = 0;
  @Input() contaCorrenteSaldoDisponivel: number = 0;
  @Input() saldoGeradoValorParcial: number = 0;
  @Input() saldoGeradoValorFinal: number = 0;
  @Input() saldoGeradoErro: boolean = false;
  @Input() porcentagemDescontoAplicado: number = null;
  @Input() porcentagemDescontoAplicadoErro: boolean = false;
  @Input() valorTotalPontuacaoProdutosAdicionados: number = 0;
  @Input() is_master: boolean = false;
  @Input() is_manager: boolean = false;
  @Input() is_master_seller: boolean = false;

  /** Contexto de edição: ao abrir o modal para alterar um item já adicionado,
   *  o pai passa o id/id_campanha para que o modal filtre e expanda automaticamente.
   *  Usa getter/setter para chamar aplicarFiltroEdicao() mesmo quando a propriedade
   *  é definida APÓS produtosOriginal (que já reconstruiu this.produtos). */
  private _filtroEdicao: { id?: number; id_campanha?: number } | null = null;

  @Input()
  set filtroEdicao(value: { id?: number; id_campanha?: number } | null) {
    this._filtroEdicao = value;
    if (value != null) {
      // Desliga filtro de promoções para não esconder o item em edição
      this.somentePromocoes = false;
    }
    // Se produtos já foram carregados (setter de produtosOriginal já rodou), aplica imediatamente
    if (value != null && this.produtos && this.produtos.length > 0) {
      this.reiniciarProdutosDoModal('filtroEdicao');
    }
  }

  get filtroEdicao(): { id?: number; id_campanha?: number } | null {
    return this._filtroEdicao;
  }
  @Input() is_diretor: boolean = false;
  @Input() calculando: boolean = false;
  @Input() pedido: Pedido = null;
  @Input() tiposPedidoErro: boolean = false;
  @Input() formaPagamentoSelecionada: FormaPagamento = null;
  @Input() obs_gerais: string = "";
  @Input() pedidoOrcamentoSelecionado: number = 1; /* 1 = Pedido, 0 = Orçamento */

  /* Estado local */

  exibirFatorFinanceiro: boolean = false;

  prazoMedio: PrazoMedio = null;
  prazoMedioDesconto: PrazoMedioDesconto = null;
  prazoPagamentoInvalido: boolean = false;

  produtosAgrupados: ProdutoPromocionalAgrupado[] = [];

  valorParcialProdutosAdicionados: number = 0;
  valorTotalPesoProdutosAdicionados: number = 0;
  valorTotalProdutosAdicionados: number = 0;
  valorTotalProdutosAdicionadosFatorFinanceiro: number = 0;
  valorTotalProdutosAdicionadosImposto: number = 0;

  produtoCampanhaSelecionado: ProdutoPromocional = null;
  produtoSelecionado: ProdutoPromocional = null;

  /** Modo edição: true quando o modal foi aberto para editar um item já adicionado */
  isEditMode: boolean = false;
  /** Produto em edição (referência ao item de this.produtos) */
  itemEmEdicao: ProdutoPromocional | null = null;

  produtoFichasTecnicas: ProdutoFichaTecnica[] = [];

  produtoFotos: ProdutoFoto[] = [];
  produtoFotosSelecionado: ProdutoPromocional = null;

  produtoInformacoesSelecionado: ProdutoPromocional = null;

  produtoLocais: ProdutoLocal[] = [];

  produtoLotes: ProdutoLote[] = [];
  produtoLotesSelecionado: ProdutoPromocional = null;

  produtoTabelas: ProdutoTabela[] = [];
  produtoTabelasSelecionado: ProdutoPromocional = null;

  produtoSemImagem: string = "assets/produto_sem_imagem.png";

  tamanhoProdutos: string = "";

  produtosComposicoes: ProdutoPromocional[] = [];

  produtosSimilares: any[] = [];

  bonificacaoInvalida: boolean = false;

  porcentagemDescontoTemporario: number = null;

  simulacaoResultado: string = "0%";
  porcentagemMarkupPedido: number = 0;

  modalReferenciaSelecionarLote: NgbModalRef = null;
  modalReferenciaTabelasProdutos: NgbModalRef = null;

  /* Filtro (Produtos) */

  formFiltroProduto: UntypedFormGroup;

  filtroProdutos: any[] = [
    { texto: "Campanha", valor: "0" },
    { texto: "Código", valor: "1" },
    { texto: "Descrição", valor: "2" },
    { texto: "Marca", valor: "3" },
    { texto: "Referência", valor: "4" }
  ];

  enviadoProduto: boolean = false;

  filtrandoProduto: boolean = false;

  somentePromocoes: boolean = false;

  menuMobileExpandido: boolean = false;
  filtroMobileExpandido: boolean = false;

  filtroProdutoSelecionado: string = "2";

  /* Filtro (Produtos (Campanhas)) */

  formFiltroProdutoCampanha: UntypedFormGroup;

  enviadoProdutoCampanha: boolean = false;

  filtrandoProdutoCampanha: boolean = false;

  /* Filtro (Status) */

  filtroStatus: any[] = [
    { texto: "Todos", valor: "0" },
    { texto: "Novo Item", valor: "1" },
    { texto: "Item Reposição", valor: "2" }
  ];

  /* IA Napis */

  iaPainelAberto: boolean = false;
  iaProdutosPainelAberto: boolean = false;
  iaCarregando: boolean = false;
  iaPergunta: string = "";
  iaResposta: IaResposta = null;
  iaSugestao: IaResposta = null;
  iaHistoricoCarregando: boolean = false;
  iaHistoricoClienteId: number = null;
  iaMensagens: IaChatMensagem[] = [];
  iaProdutoAberto: number = null;
  iaConfiguracao: IaConfiguracaoCliente = null;
  iaConfiguracaoCarregando: boolean = false;

  /* ViewChild */

  @ViewChild("adicionarItensFiltro") adicionarItensFiltro: ElementRef;
  /**
   * Fix round 2 (Task 5 review): `#adicionarItensProdutos` vivia no
   * `<cdk-virtual-scroll-viewport>` que a Task 5 moveu para dentro de
   * `app-pedido-itens-catalogo`, deixando este `@ViewChild` permanentemente `undefined`
   * (silenciosamente — os ~8 call sites no arquivo já eram todos guardados por
   * `if (this.adicionarItensProdutos)`, então nada lançava exceção; checkViewportSize()/
   * scrollToIndex() só deixavam de rodar). Reconectado via o `viewport` público exposto
   * pelo componente filho (mesmo `CdkVirtualScrollViewport`, sem duplicar nenhuma lógica
   * de scroll/resize — essa lógica continua 100% aqui, inalterada). Mantido como getter
   * com o MESMO nome/tipo do campo original para que nenhum dos ~8 call sites precisasse
   * ser tocado.
   */
  @ViewChild(PedidoItensCatalogoComponent) private catalogoComponent: PedidoItensCatalogoComponent;
  private get adicionarItensProdutos(): CdkVirtualScrollViewport {
    return this.catalogoComponent ? this.catalogoComponent.viewport : undefined;
  }
  /**
   * Task 6: `#adicionarItensDados` (usado em `recalcularViewportHeight()`, ts ~925-934,
   * para medir `offsetHeight`) vivia na raiz do bloco de toolbar que esta task moveu para
   * `app-pedido-itens-toolbar`. Mesma classe de bug do `adicionarItensProdutos` acima —
   * reconectado via o `toolbarRoot` público exposto pelo componente filho, mantendo o
   * MESMO nome/tipo do campo original.
   */
  @ViewChild(PedidoItensToolbarComponent) private toolbarComponent: PedidoItensToolbarComponent;
  private get adicionarItensDados(): ElementRef {
    return this.toolbarComponent ? this.toolbarComponent.toolbarRoot : undefined;
  }
  @ViewChild("adicionarItensCampanha") adicionarItensCampanhaTemplate: any;
  @ViewChild("adicionarItensEstoqueLocal") adicionarItensEstoqueLocalTemplate: any;
  @ViewChild("adicionarItensFotos") adicionarItensFotosTemplate: any;
  @ViewChild("adicionarItensInformacoes") adicionarItensInformacoesTemplate: any;
  @ViewChild("adicionarItensLotes") adicionarItensLotesTemplate: any;
  @ViewChild("adicionarItensTabelas") adicionarItensTabelasTemplate: any;
  /**
   * Task 7: `#iaChatLista` (usado em `rolarChatIa()`, ts ~679-685, para medir
   * `scrollTop`/`scrollHeight`) vivia dentro do painel "IA Napis" que esta task moveu para
   * `app-pedido-itens-ia-painel`. Mesma classe de bug já corrigida duas vezes (Tasks 5/6) —
   * reconectado via o `iaChatLista` público exposto pelo componente filho, mantendo o MESMO
   * nome/tipo do campo original para que os 2 call sites guardados não precisassem mudar.
   */
  @ViewChild(PedidoItensIaPainelComponent) private iaPainelComponent: PedidoItensIaPainelComponent;
  private get iaChatLista(): ElementRef {
    return this.iaPainelComponent ? this.iaPainelComponent.iaChatLista : undefined;
  }

  /* Pendência */

  get usaPendencia(): boolean {
    return this.configuracao != null
      && this.configuracao.flag_usa_pendencia === true
      && this.pedidoOrcamentoSelecionado === 1; /* Orçamento nunca gera pendência */
  }

  /* Pontuação */

  get exibirPontuacao(): boolean {
    return this.configuracao != null && (this.configuracao.usa_pontuacao === true || this.configuracao.usa_pontuacao_cliente === true);
  }

  get usaPontuacaoCliente(): boolean {
    return this.configuracao != null && this.configuracao.usa_pontuacao_cliente === true;
  }

  viewportHeight: number = 600;
  produtoExpandidoMobileId: number = null;

  get virtualScrollItemSize(): number {
    if (!this.ehTelaMobileAdicionarItens()) {
      return 48;
    }

    return this.produtoExpandidoMobileId != null ? 820 : 48;
  }

  get produtosExibidos(): ProdutoPromocional[] {
    const produtosVisiveis = (this.produtos || []).filter(produto => produto.exibir !== false);
    if (this.ehTelaMobileAdicionarItens() && this.produtoExpandidoMobileId != null) {
      return produtosVisiveis.filter(produto => produto.id == this.produtoExpandidoMobileId);
    }

    return produtosVisiveis;
  }

  get fp() {
    return this.formFiltroProduto ? this.formFiltroProduto.controls : {} as any;
  }

  constructor(
    public activeModal: NgbActiveModal,
    private currencyPipe: CurrencyPipe,
    private formBuilder: UntypedFormBuilder,
    private modalService: NgbModal,
    private toastr: ToastrService,
    private formatacaoService: FormatacaoService,
    private iaService: IaService,
    private prazoMedioService: PrazoMedioService,
    private produtoService: ProdutoService,
    private changeDetectorRef: ChangeDetectorRef
  ) { }

  ngOnInit() {
    /* Filtro (Produtos) */

    this.formFiltroProduto = this.formBuilder.group({
      filtro: [this.filtroProdutoSelecionado],
      codigo: ["", Validators.required],
      descricao: ["", Validators.required],
      marca: ["", Validators.required],
      referencia: ["", Validators.required],
      status: ["0"]
    });

    /* Filtro (Produtos (Campanhas)) */

    this.formFiltroProdutoCampanha = this.formBuilder.group({
      descricao: ["", Validators.required]
    });

    this.organizarFiltroProduto();

    if (!this.filtroEdicao) {
      this.somentePromocoes = false;
      this.aplicarFiltroPorPromocao();
    }
  }

  fechar() {
    this.activeModal.close('Cancelar');
  }

  salvar() {
    if (this.revalidandoPrazo) { this.toastr.warning("", "Aguarde a revalidação do prazo."); return; }
    /* Verificação 1: erro_valor já marcado reativamente */
    const produtosComErroFlag = this.produtos.filter(p =>
      (p.qtde > 0 || p.qtde_bonificada > 0) && p.erro_valor === true
    );
    if (produtosComErroFlag.length > 0) {
      produtosComErroFlag.forEach((p) => {
        p.exibir = true;
        p.expandido = true;
      });

      const identificacao: string = produtosComErroFlag
        .map(p => p.name || p.codigo)
        .join(', ');

      this.toastr.error("", "Itens com valor inválido ou acima do desconto máximo: " + identificacao);
      return;
    }

    /* Verificação 2 (independente): checar desconto diretamente — cobre casos
     * em que erro_valor não foi atualizado (ex.: edição via campo Unitário R$,
     * ou abertura do modal sem disparar o evento (input)). */
    const todasListas = [...this.produtos, ...this.produtosAdicionados];
    const idsVistos = new Set<number>();
    for (const p of todasListas) {
      if (idsVistos.has(p.id)) { continue; }
      idsVistos.add(p.id);

      if ((p.qtde > 0 || p.qtde_bonificada > 0)) {
        if (p.requer_aprovacao_prazo && p.valor === p.valor_validado_prazo) continue;
        const maxDescSalvar = this.obterDescontoMaximoProduto(p);
        if (maxDescSalvar != null) {
          /* 2a: porcentagem digitada maior que o máximo */
          if (p.porcentagem_desconto_temporaria != null && p.porcentagem_desconto_temporaria > maxDescSalvar) {
            p.erro_valor = true;
            this.toastr.error("", "Desconto máximo permitido: " + maxDescSalvar + "% (" + (p.name || p.codigo) + ")");
            return;
          }
          /* 2b: valor unitário abaixo do mínimo calculado */
          if (p.valor != null && p.valor > 0) {
            const baseCalc = this.obterBaseValidacaoDescontoMaximo(p);
            if (baseCalc > 0) {
              const valorMinimo = baseCalc * (1 - maxDescSalvar / 100);
              if (p.valor < valorMinimo - 0.001) {
                p.erro_valor = true;
                this.toastr.error("", "Desconto máximo permitido: " + maxDescSalvar + "% (" + (p.name || p.codigo) + ")");
                return;
              }
            }
          }
        }
      }
    }

    /* Verificação 3: quantidade mínima de tabela especial */
    const todasListasQtdeMin = [...this.produtos, ...this.produtosAdicionados];
    const idsVistosQtdeMin = new Set<number>();
    for (const p of todasListasQtdeMin) {
      if (idsVistosQtdeMin.has(p.id)) { continue; }
      idsVistosQtdeMin.add(p.id);

      const qtdeMinTabSalvar: number = p.qtde_minima_tabela;
      if (qtdeMinTabSalvar != null && qtdeMinTabSalvar > 0 && p.qtde != null && p.qtde > 0 && p.qtde < qtdeMinTabSalvar) {
        p.erro_qtde = true;
        this.toastr.error("", "Qtde mínima da tabela: " + qtdeMinTabSalvar + " (" + (p.name || p.codigo) + ")");
        return;
      }
    }

    /* Incluir a lista de trabalho do modal no resultado para que o pai
     * possa sincronizar this.produtos antes de chamar repassarDadosProduto.
     * Sem isso, o pai lê sua própria cópia velha e o filter(qtde > 0)
     * não retorna nenhum item, zerando produtosAdicionados. */
    this.activeModal.close({
      action: 'Salvar',
      prazoMedio: this.prazoMedio,
      prazoMedioDesconto: this.prazoMedioDesconto,
      prazoPagamentoSelecionado: this.prazoPagamentoSelecionado,
      produtos: this.produtos,
      produtosAdicionados: this.produtosAdicionados
    });
  }

  /* Stubs: operações que só fazem sentido no contexto pai */

  alternarPainelIa() {
    if (this.clienteSelecionado == null || this.clienteSelecionado.client_id_app == null) {
      this.toastr.warning("", "Selecione um cliente para usar a IA.");
      return;
    }

    this.iaPainelAberto = !this.iaPainelAberto;
    this.iaProdutosPainelAberto = false;

    if (this.iaPainelAberto) {
      this.carregarConfiguracaoIa();
    }
  }

  fecharPainelIa() {
    this.iaPainelAberto = false;
    this.iaProdutosPainelAberto = false;
  }

  iaModuloHabilitado(): boolean {
    return this.iaConfiguracao != null && this.iaConfiguracao.is_configurada == true && this.iaConfiguracao.ia_ativa == true;
  }

  carregarConfiguracaoIa() {
    this.iaConfiguracaoCarregando = true;
    this.iaService.getConfiguration().subscribe(
      configuracao => {
        this.iaConfiguracao = configuracao || new IaConfiguracaoCliente();
        this.iaConfiguracaoCarregando = false;
        if (this.iaModuloHabilitado()) {
          this.carregarHistoricoIa();
        }
      },
      () => {
        this.iaConfiguracao = new IaConfiguracaoCliente();
        this.iaConfiguracaoCarregando = false;
      }
    );
  }

  perguntarIa() {
    if (this.clienteSelecionado == null || !this.iaPergunta || this.iaPergunta.trim() == "") return;

    const pergunta = this.iaPergunta.trim();
    this.iaMensagens.push({ origem: "USUARIO", texto: pergunta, tipo: "CHAT", data: new Date() });
    this.iaPergunta = "";
    this.rolarChatIa();

    this.iaCarregando = true;
    this.iaService.chatCliente(this.clienteSelecionado.client_id_app, pergunta, null, "PEDIDO_ITENS").subscribe(
      resposta => {
        this.iaResposta = resposta;
        if (resposta != null) {
          this.iaMensagens.push({
            origem: "IA",
            texto: resposta.resposta,
            tipo: resposta.tipo || "CHAT",
            mensagem: resposta.mensagem || "Resposta da IA",
            sucesso: resposta.sucesso,
            data: new Date()
          });
          this.rolarChatIa();
        }
        this.iaCarregando = false;
      },
      () => this.iaCarregando = false
    );
  }

  enviarPerguntaIaPorEnter(event: KeyboardEvent) {
    if (event.shiftKey) return;
    event.preventDefault();
    this.perguntarIa();
  }

  sugerirProdutosIa() {
    if (this.clienteSelecionado == null || this.clienteSelecionado.client_id_app == null) {
      this.toastr.warning("", "Selecione um cliente para sugerir produtos.");
      return;
    }

    this.iaPainelAberto = true;
    this.iaProdutosPainelAberto = false;

    if (this.iaConfiguracao == null) {
      this.iaConfiguracaoCarregando = true;
      this.iaService.getConfiguration().subscribe(
        configuracao => {
          this.iaConfiguracao = configuracao || new IaConfiguracaoCliente();
          this.iaConfiguracaoCarregando = false;
          if (this.iaModuloHabilitado()) {
            this.abrirSugestaoProdutosIa();
          }
        },
        () => {
          this.iaConfiguracao = new IaConfiguracaoCliente();
          this.iaConfiguracaoCarregando = false;
        }
      );
      return;
    }

    if (!this.iaModuloHabilitado()) return;
    this.abrirSugestaoProdutosIa();
  }

  abrirSugestaoProdutosIa() {
    this.iaCarregando = true;
    this.iaProdutosPainelAberto = true;
    this.iaService.getUltimaSugestaoProdutos(this.clienteSelecionado.client_id_app, null, "PEDIDO_ITENS").subscribe(
      resposta => {
        if (resposta != null && resposta.sucesso && resposta.produtos_sugeridos != null && resposta.produtos_sugeridos.length > 0) {
          this.iaSugestao = resposta;
          this.iaProdutoAberto = null;
          this.iaCarregando = false;
        } else {
          this.atualizarSugestaoProdutosIa();
        }
      },
      () => this.atualizarSugestaoProdutosIa()
    );
  }

  atualizarSugestaoProdutosIa() {
    if (this.clienteSelecionado == null || this.clienteSelecionado.client_id_app == null) return;
    this.iaCarregando = true;
    this.iaProdutosPainelAberto = true;
    this.iaService.sugerirProdutosCliente(this.clienteSelecionado.client_id_app, null, "PEDIDO_ITENS").subscribe(
      resposta => {
        this.iaSugestao = resposta;
        this.iaProdutoAberto = null;
        this.iaCarregando = false;
      },
      () => this.iaCarregando = false
    );
  }

  copiarTextoIa(texto: string) {
    if (texto == null || texto == "") return;
    if (navigator != null && navigator.clipboard != null) {
      navigator.clipboard.writeText(texto).then(() => this.toastr.success("", "Texto copiado."));
    } else {
      this.toastr.info("", "Selecione e copie o texto da sugestao.");
    }
  }

  carregarHistoricoIa(force: boolean = false) {
    if (this.clienteSelecionado == null || this.clienteSelecionado.client_id_app == null) return;
    if (!force && this.iaHistoricoClienteId == this.clienteSelecionado.client_id_app && this.iaMensagens.length > 0) {
      this.rolarChatIa();
      return;
    }

    this.iaHistoricoCarregando = true;
    this.iaService.getChatHistorico(this.clienteSelecionado.client_id_app, null, "PEDIDO_ITENS").subscribe(
      historico => {
        this.iaMensagens = this.montarMensagensHistorico(historico || []);
        this.iaHistoricoClienteId = this.clienteSelecionado.client_id_app;
        this.iaHistoricoCarregando = false;
        this.rolarChatIa();
      },
      () => this.iaHistoricoCarregando = false
    );
  }

  fecharProdutosIa() {
    this.iaPainelAberto = false;
    this.iaProdutosPainelAberto = false;
  }

  produtosIaClienteCompra(): any[] {
    if (this.iaSugestao == null || this.iaSugestao.produtos_sugeridos == null) return [];
    return this.iaSugestao.produtos_sugeridos.filter(p => p.motivo == "historico_compra");
  }

  produtosIaSegmentoNaoCompra(): any[] {
    if (this.iaSugestao == null || this.iaSugestao.produtos_sugeridos == null) return [];
    return this.iaSugestao.produtos_sugeridos.filter(p => p.motivo != "historico_compra");
  }

  alternarProdutoIa(produto: any) {
    if (produto == null) return;
    this.iaProdutoAberto = this.iaProdutoAberto == produto.product_id ? null : produto.product_id;
  }

  condicoesProdutoIa(produto: any): any[] {
    if (produto == null || produto.condicoes_especiais == null) return [];
    return produto.condicoes_especiais;
  }

  private montarMensagensHistorico(historico: IaChatHistorico[]): IaChatMensagem[] {
    let mensagens: IaChatMensagem[] = [];

    historico
      .filter(item => item.tipo != "SUGESTAO_PRODUTOS")
      .forEach(item => {
        const data = item.data_criacao != null ? new Date(item.data_criacao) : null;
        if (item.pergunta != null && item.pergunta.trim() != "") {
          mensagens.push({ origem: "USUARIO", texto: item.pergunta, tipo: item.tipo, data: data });
        }

        if (item.resposta != null && item.resposta.trim() != "") {
          mensagens.push({
            origem: "IA",
            texto: item.resposta,
            tipo: item.tipo,
            mensagem: "Resposta da IA",
            sucesso: true,
            data: data
          });
        }
      });

    return mensagens;
  }

  private rolarChatIa() {
    setTimeout(() => {
      if (this.iaChatLista != null && this.iaChatLista.nativeElement != null) {
        this.iaChatLista.nativeElement.scrollTop = this.iaChatLista.nativeElement.scrollHeight;
      }
    }, 50);
  }

  ngAfterViewInit() {
    this.ajustarElementos();
    setTimeout(() => this.recalcularViewportHeight(), 0);
  }

  alternarFiltroMobile() {
    this.filtroMobileExpandido = !this.filtroMobileExpandido;
    setTimeout(() => this.recalcularViewportHeight(), 0);
  }

  alternarMenuMobile() {
    this.menuMobileExpandido = !this.menuMobileExpandido;
    setTimeout(() => this.recalcularViewportHeight(), 0);
  }



  /**
   * Reinicializa a lista de produtos do modal, garantindo que exibir=true
   * e reaplica configurações de filtro atuais.
   */
  private reiniciarProdutosDoModal(origem: string): void {
    // Resetar estado de UI do modal
    this.produtoSelecionado = null;
    this.enviadoProduto = false;
    this.filtrandoProduto = false;
    this.isEditMode = false;
    this.itemEmEdicao = null;
    this.produtoExpandidoMobileId = null;

    // Se `this.produtos` depende da base, re-criar com flags
    const base = (this._produtosOriginal || []).map(p => {
      const clone: any = { ...p };

      // GARANTIR renderização
      clone.exibir = true;
      clone.expandido = !!clone.expandido;

      return clone;
    });

    this.produtos = base;

    // Ajustar viewport
    setTimeout(() => {
      try {
        if (this.adicionarItensProdutos) {
          this.adicionarItensProdutos.checkViewportSize();
        }
      } catch (e) {
        // viewport pode não estar pronto
      }
    }, 0);

    // Reaplicar a configuração do filtro atual (se existir)
    if (this.formFiltroProduto) {
      this.organizarFiltroProduto();
    }

    // Reaplicar filtro de promoção se ativo (exceto em modo edição)
    if (this.somentePromocoes && !this.filtroEdicao) {
      this.aplicarFiltroPorPromocao();
    }

    // Aplicar filtro de edição, se o pai abriu o modal para alterar um item específico
    this.aplicarFiltroEdicao();
  }

  /**
   * Filtra a lista de produtos ao editar um item já adicionado.
   * Exibe SOMENTE o item-alvo (modo edição), evitando a rolagem quebrada
   * que ocorria ao mostrar o grupo inteiro no Virtual Scroll com itemSize fixo.
   * Ativa isEditMode e itemEmEdicao para que o HTML exiba a barra "Voltar".
   */
  private aplicarFiltroEdicao(): void {
    if (!this.filtroEdicao || !this.produtos || this.produtos.length === 0) { return; }

    const { id, id_campanha } = this.filtroEdicao;
    if ((id == null || id === 0) && (id_campanha == null || id_campanha === 0)) { return; }

    this.filtrandoProduto = true;
    this.enviadoProduto = true;

    // Localizar o item-alvo
    const alvo = this.produtos.find(p =>
      (id != null && id !== 0 && p.id == id) ||
      (id_campanha != null && id_campanha !== 0 && p.id_campanha == id_campanha)
    );

    // Ativar modo edição — o HTML ocultará o filtro e exibirá só este item
    this.isEditMode = true;
    this.itemEmEdicao = alvo || null;

    // Marcar todos os itens: apenas o alvo fica exibido e expandido
    let idxAlvo = -1;
    this.produtos.forEach((p, idx) => {
      const matchAlvo =
        (id != null && id !== 0 && p.id == id) ||
        (id_campanha != null && id_campanha !== 0 && p.id_campanha == id_campanha);

      p.exibir = matchAlvo;
      (p as any).emEdicao = matchAlvo;
      if (matchAlvo) {
        p.expandido = true;
        idxAlvo = idx;
      }
    });

    if (this.itemEmEdicao) {
      this.garantirEstadoPreco(this.itemEmEdicao);
    }

    // Mover o item-alvo para o índice 0 do array.
    // O Virtual Scroll usa itemSize fixo de 48px: se o item estivesse no índice N,
    // precisaria scrollar N*48px para chegar a ele. Movendo para índice 0 ele
    // fica imediatamente visível no topo, independente de quanto valha idxAlvo.
    if (idxAlvo > 0) {
      const [itemAlvo] = this.produtos.splice(idxAlvo, 1);
      this.produtos.unshift(itemAlvo);
    }

    setTimeout(() => {
      try {
        if (this.adicionarItensProdutos) {
          this.adicionarItensProdutos.checkViewportSize();
          this.adicionarItensProdutos.scrollToIndex(0, 'smooth');
        }
      } catch (e) { /* viewport ainda não pronto */ }
    }, 100);
  }

  /**
   * Sai do modo edição e retorna à listagem normal de produtos.
   */
  sairModoEdicao(): void {
    this.isEditMode = false;
    this.itemEmEdicao = null;
    this.filtrandoProduto = false;
    this.enviadoProduto = false;

    // Restaurar a ordem original (que foi alterada ao mover o item para índice 0)
    const originalIds = this._produtosOriginal.map(p => p.id);
    this.produtos.sort((a, b) => {
      const ia = originalIds.indexOf(a.id);
      const ib = originalIds.indexOf(b.id);
      return (ia === -1 ? 99999 : ia) - (ib === -1 ? 99999 : ib);
    });

    // Reexibir todos os produtos e remover destaque
    this.produtos.forEach(p => {
      p.exibir = true;
      p.expandido = false;
      (p as any).emEdicao = false;
    });

    setTimeout(() => {
      try {
        if (this.adicionarItensProdutos) {
          this.adicionarItensProdutos.checkViewportSize();
        }
      } catch (e) { /* viewport ainda não pronto */ }
    }, 50);
  }

  /**
   * Task 5 (wiring do shell responsivo catálogo + painel de detalhe): wrapper adicionado
   * em torno de `expandirProduto()` (inalterado). `expandirProduto()` já alterna
   * `produto.expandido`, mas nenhum método existente populava `produtoSelecionado`
   * (campo declarado em ts:162, porém nunca atribuído com um produto real em nenhum
   * lugar do código pré-existente) — necessário para alimentar o novo
   * `app-pedido-itens-detalhe-painel` no layout de duas colunas. Não duplica nem altera
   * a lógica de negócio de `expandirProduto()`, apenas lê o resultado dela.
   *
   * Fix round 1 (Critical 1): `expandirProduto()` só reseta o `expandido` de outros
   * itens dentro do seu ramo mobile (`ehTelaMobileAdicionarItens()`, ts:1027-1037,
   * ≤576px) — em telas ≥577px é um toggle puro em `produto.expandido`, sem resetar os
   * demais. Sem o reset abaixo, selecionar A depois B deixava `A.expandido` preso em
   * `true`; clicar A de novo então alternava para `false` e o painel "falhava" ao abrir
   * na 3ª vez. O novo layout é seleção única em qualquer largura, então replicamos aqui
   * (para todas as larguras) o mesmo reset que o próprio `expandirProduto()` já faz só
   * para mobile. Depois, forçamos `expandido = true` no alvo em vez de confiar no
   * toggle — não desfaz nenhum efeito colateral que `expandirProduto()` já tenha feito
   * (scroll, `produtoExpandidoMobileId`, etc.), só garante que o booleano final reflita
   * "este produto está selecionado agora".
   *
   * Escopo verificado: `produtosExibidos` (o que o catálogo renderiza) deriva somente
   * de `this.produtos` — `produtosOriginal`/`produtosAdicionados` também têm seus
   * próprios usos de `.expandido`, mas pertencem a fluxos de erro não relacionados
   * (`agruparProdutosComErro`, `validarErrosProdutosAdicionados`), não ao estado de
   * seleção por clique. Por isso o reset abaixo fica restrito a `this.produtos`, igual
   * ao escopo do próprio `expandirProduto()`.
   */
  selecionarProdutoDoCatalogo(id_produto: number, index: number): void {
    this.produtos.forEach(p => { if (p.id !== id_produto) { p.expandido = false; } });
    this.expandirProduto(id_produto, index);
    const produto = this.produtos.find(p => p.id == id_produto);
    if (produto != null) {
      produto.expandido = true;
    }
    this.produtoSelecionado = produto ?? null;
  }

  /**
   * Task 5: fecha o painel de detalhe (botão "Voltar" do drawer mobile em <992px, e
   * disponível também no desktop). Mantém `produto.expandido` sincronizado com
   * `produtoSelecionado` para não deixar o card da listagem com destaque "preso".
   * Seleção-clear trivial, sem lógica de negócio nova.
   *
   * Fix round 1 (Critical 2): `produtosExibidos` (ts:298-305, inalterado) filtra a lista
   * para mostrar só um produto sempre que `ehTelaMobileAdicionarItens() &&
   * produtoExpandidoMobileId != null`. `expandirProduto()` seta esse id ao abrir em
   * mobile, mas só o limpa via `reiniciarProdutosDoModal()` (reset completo do modal) ou
   * alternando o mesmo produto de novo enquanto em mobile — nunca ao fechar pelo botão
   * "Voltar" do novo painel. Sem a linha abaixo, um celular real ficaria com o catálogo
   * permanentemente filtrado para o único produto visto, sem volta à listagem completa.
   */
  fecharDetalhePainel(): void {
    if (this.produtoSelecionado != null) {
      this.produtoSelecionado.expandido = false;
    }
    this.produtoSelecionado = null;
    this.produtoExpandidoMobileId = null;
  }

  /** TrackBy estável por id de produto — evita recriação desnecessária de DOM no Virtual Scroll. */
  trackByProdutoId(_index: number, item: any): any {
    return item != null ? item.id : _index;
  }

  /**
   * Obtém o código do produto tentando campos mais prováveis
   */
  private obterCodigoProduto(p: any): string {
    // tenta campos mais prováveis
    if (!p) return '';
    const v = p.codigo || p.codprod || p.CODPROD || p.cod_prod || p.code || p.id;
    return v != null ? String(v).trim() : '';
  }

  carregarDadosPorCliente(_full: boolean) { /* no-op no modal */ }

  ajustarElementos() {
    // Com layout flex, não precisa mais calcular altura dinâmica
  }

  private ehTelaMobileAdicionarItens(): boolean {
    return typeof window !== 'undefined' && window.innerWidth <= 576;
  }

  private recalcularViewportHeight(): void {
    const vh = window.innerHeight;
    const dadosEl = this.adicionarItensDados && this.adicionarItensDados.nativeElement as HTMLElement;
    const filtroEl = this.adicionarItensFiltro && this.adicionarItensFiltro.nativeElement as HTMLElement;
    const dadosPx = dadosEl ? dadosEl.offsetHeight : 100;
    const filtroPx = filtroEl ? filtroEl.offsetHeight : 80;
    const margemModal = this.ehTelaMobileAdicionarItens() ? 64 : 120;
    const margemInterna = this.ehTelaMobileAdicionarItens() ? 28 : 60;
    this.viewportHeight = Math.max(this.ehTelaMobileAdicionarItens() ? 280 : 200, vh - margemModal - dadosPx - filtroPx - margemInterna);
  }

  calcularSimulacaoResultado() {
    let valorTotalCusto: number = this.produtosAdicionados.reduce((sum, current) => (sum + (current.custo * current.qtde)), 0);

    this.produtosAdicionados.forEach((item) => {
      if (item.produtos_vinculados != null) {
        /* Produtos Vinculados */

        let qtdeCampanha: number = item.qtde != null && item.qtde > 0 ? item.qtde : 0;

        item.produtos_vinculados.forEach((subItem) => {
          let qtdeProduto: number = subItem.qtde != null && subItem.qtde > 0 ? subItem.qtde : 0;

          valorTotalCusto = (valorTotalCusto + ((subItem.custo * qtdeProduto) * qtdeCampanha));
        });
      }
    });

    let valorTotal: number = this.produtosAdicionados.reduce((sum, current) => sum + current.valor_total, 0);

    if (this.configuracao == null || valorTotalCusto == 0 || valorTotal == 0) {
      this.porcentagemMarkupPedido = 0;
      this.simulacaoResultado = "0%";
    } else {
      this.porcentagemMarkupPedido = (1 - (valorTotalCusto / valorTotal)) * 100;

      this.porcentagemMarkupPedido = Math.round(this.porcentagemMarkupPedido * 100) / 100;

      if (this.porcentagemMarkupPedido <= this.configuracao.margem_lucratividade_vermelha) {
        this.simulacaoResultado = "0%";
      } else if (this.porcentagemMarkupPedido >= this.configuracao.margem_lucratividade_verde) {
        this.simulacaoResultado = "98%";
      } else {
        this.simulacaoResultado = ((((this.porcentagemMarkupPedido - this.configuracao.margem_lucratividade_vermelha) * 100) / (this.configuracao.margem_lucratividade_verde - this.configuracao.margem_lucratividade_vermelha)) + "%").toString();
      }
    }
  }

  excluirItemAdicionado(indice: number, id_produto: number, id_campanha: number) {
    if (this.validarErrosProdutosAdicionados(true) > 0) {
      return;
    }

    if (id_campanha != null) {
      /* Campanha */

      this.produtosAdicionados.splice(indice, 1);

      this.produtosAdicionados = [...this.produtosAdicionados];

      this.excluirProdutoCampanha(id_campanha);
    } else {
      /* Produto */

      let produtoAdicionado = this.produtosOriginal.find(produtoAdicionado => produtoAdicionado.id == id_produto);

      if (produtoAdicionado.id_kit_combo == null) {
        this.produtosAdicionados.splice(indice, 1);

        this.produtosAdicionados = [...this.produtosAdicionados];

        let produtoOriginal = this.produtosOriginal.find(produtoOriginal => produtoOriginal.id == id_produto);

        if (produtoOriginal != null) {
          produtoOriginal.erro_lote = false;
          produtoOriginal.erro_qtde = false;
          produtoOriginal.erro_valor = false;

          produtoOriginal.valor_tabela = 0;
                produtoOriginal.estado_preco = null;
                produtoOriginal.preco_base_api = null;

          produtoOriginal.qtde = null;
          produtoOriginal.valor = null;

          produtoOriginal.valor_total = 0;
          produtoOriginal.porcentagem_desconto = 0;
          produtoOriginal.descritivo_desconto = null;
          produtoOriginal.observacao_item = null;

          produtoOriginal.saldo_gerado = 0;

          /* Lote */

          produtoOriginal.id_lote = null;
          produtoOriginal.nome_lote = null;
          produtoOriginal.cod_lote = null;
          produtoOriginal.estoque_lote = null;
          produtoOriginal.validade_lote = null;
          produtoOriginal.preco_lote = null;

          /* Ordem */

          produtoOriginal.ordem = 0;

          /* Qtde (Bonificada) */

          produtoOriginal.qtde_bonificada = null;

          /* Total Fracionado */

          produtoOriginal.valor_unitario_fracionado = null;
          produtoOriginal.valor_unitario_imposto_fracionado = null;

          /* Porcentagem Desconto Temporária */

          produtoOriginal.porcentagem_desconto_temporaria = null;
        }
      } else {
        this.toastr.warning("", "Produto originado de campanha...");

        return;
      }
    }

    this.ordenarProdutosAdicionados();
    this.totalizarProdutosAdicionados();

    if (this.configuracao != null && !this.configuracao.prazo_pagamento_antes_itenspedido) {
      this.organizarPrazoPagamento(false, false);
    } else {
      this.calcularFatorFinanceiro();
    }

    this.calcularSimulacaoResultado();
    this.totalizarSaldoGerado();

    /* Produtos Original p/ Produtos */

    this.produtos = JSON.parse(JSON.stringify(this.produtosOriginal));
  }

  expandirProduto(id_produto: number, index: number = 0) {
    let produto = this.produtos.find(produto => produto.id == id_produto);

    if (produto != null) {
      const vaiExpandir = (produto.qtde != 0 && produto.qtde != null) && (produto.valor != 0 && produto.valor != null)
        ? true
        : !produto.expandido;

      if (vaiExpandir && this.ehTelaMobileAdicionarItens()) {
        this.produtos.forEach(item => {
          if (item.id != produto.id) {
            item.expandido = false;
          }
        });
        this.produtoExpandidoMobileId = produto.id;
        index = 0;
      } else if (!vaiExpandir && this.ehTelaMobileAdicionarItens()) {
        this.produtoExpandidoMobileId = null;
      }

      if ((produto.qtde != 0 && produto.qtde != null) && (produto.valor != 0 && produto.valor != null)) {
        produto.expandido = true;
      } else {
        produto.expandido = !produto.expandido;
      }

      if (produto.expandido) {
        setTimeout(() => {
          try {
            if (this.adicionarItensProdutos) {
              this.adicionarItensProdutos.checkViewportSize();
              if (this.ehTelaMobileAdicionarItens()) {
                this.adicionarItensProdutos.scrollToIndex(0, 'auto');
              }
            }
          } catch (e) { /* viewport ainda nÃ£o pronto */ }
        }, 0);
        this.scrollParaItemExpandido(index);
      } else if (this.ehTelaMobileAdicionarItens()) {
        this.produtoExpandidoMobileId = null;
        setTimeout(() => {
          try {
            if (this.adicionarItensProdutos) {
              this.adicionarItensProdutos.checkViewportSize();
              this.adicionarItensProdutos.scrollToIndex(0, 'auto');
            }
          } catch (e) { /* viewport ainda nÃ£o pronto */ }
        }, 0);
      }
    }
  }

  private scrollParaItemExpandido(index: number): void {
    setTimeout(() => {
      try {
        if (!this.adicionarItensProdutos) { return; }

        if (this.ehTelaMobileAdicionarItens()) {
          this.adicionarItensProdutos.checkViewportSize();
          this.adicionarItensProdutos.scrollToIndex(0, 'auto');
          const mobileViewportEl = this.adicionarItensProdutos.elementRef.nativeElement as HTMLElement;
          mobileViewportEl.scrollTop = 0;
          return;
        }

        const viewportEl = this.adicionarItensProdutos.elementRef.nativeElement as HTMLElement;
        const spacer = viewportEl.querySelector('.cdk-virtual-scroll-spacer') as HTMLElement;
        const contentWrapper = viewportEl.querySelector('.cdk-virtual-scroll-content-wrapper') as HTMLElement;

        // Aumenta o spacer para o tamanho real do conteúdo expandido,
        // permitindo que o scroll interno do CDK chegue até o final do item.
        if (spacer && contentWrapper) {
          const realHeight = contentWrapper.scrollHeight;
          const currentSpacer = parseFloat(spacer.style.height) || 0;
          if (realHeight > currentSpacer) {
            spacer.style.height = `${realHeight + 80}px`;
          }
        }

        this.adicionarItensProdutos.scrollToIndex(index, 'smooth');

        // Segunda passagem: usa scrollIntoView para revelar o final do item expandido
        setTimeout(() => {
          try {
            if (!this.adicionarItensProdutos) { return; }
            const wrapper = (this.adicionarItensProdutos.elementRef.nativeElement as HTMLElement)
              .querySelector('.cdk-virtual-scroll-content-wrapper') as HTMLElement;
            if (wrapper) {
              const rows = wrapper.querySelectorAll('tr');
              const target = rows[index] || rows[rows.length - 1];
              if (target) {
                target.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
              }
            }
          } catch (e) { /* ok */ }
        }, 200);
      } catch (e) { /* viewport não pronto */ }
    }, 50);
  }

  formatarProdutosAdicionados() {
    this.produtosAdicionados.forEach((item) => {
      if (item.produtos_vinculados != null) {
        /* Produtos Vinculados */

        item.produtos_vinculados.forEach((subItem) => {
          /* Imposto */

          subItem.valor_imposto = this.formatacaoService.quatroCasasDecimais(subItem.valor_imposto);
          subItem.valor_imposto_unitario = this.formatacaoService.quatroCasasDecimais(subItem.valor_imposto_unitario);
          subItem.valor_imposto_produto = this.formatacaoService.quatroCasasDecimais(subItem.valor_imposto_produto);
          subItem.valor_imposto_total = parseFloat(subItem.valor_imposto_total.toFixed(2));

          subItem.valor_imposto_total_final = subItem.valor_imposto_total;

          subItem.valor_unitario_final = this.formatacaoService.quatroCasasDecimais(subItem.valor_unitario_final);

          /* Fator Financeiro */

          /* Processado */

          subItem.valor_fator_financeiro = this.formatacaoService.quatroCasasDecimais(subItem.valor_fator_financeiro);
          subItem.valor_fator_financeiro_unitario = this.formatacaoService.quatroCasasDecimais(subItem.valor_fator_financeiro_unitario);
          subItem.valor_fator_financeiro_produto = this.formatacaoService.quatroCasasDecimais(subItem.valor_fator_financeiro_produto);
          subItem.valor_fator_financeiro_total = parseFloat(subItem.valor_fator_financeiro_total.toFixed(2));
        });
      }

      /* Imposto */

      item.valor_imposto = this.formatacaoService.quatroCasasDecimais(item.valor_imposto);
      item.valor_imposto_unitario = this.formatacaoService.quatroCasasDecimais(item.valor_imposto_unitario);
      item.valor_imposto_produto = this.formatacaoService.quatroCasasDecimais(item.valor_imposto_produto);
      item.valor_imposto_total = parseFloat(item.valor_imposto_total.toFixed(2));

      item.valor_imposto_total_final = item.valor_imposto_total;

      item.valor_unitario_final = this.formatacaoService.quatroCasasDecimais(item.valor_unitario_final);

      /* Fator Financeiro */

      /* Processado */

      item.valor_fator_financeiro = this.formatacaoService.quatroCasasDecimais(item.valor_fator_financeiro);
      item.valor_fator_financeiro_unitario = this.formatacaoService.quatroCasasDecimais(item.valor_fator_financeiro_unitario);
      item.valor_fator_financeiro_produto = this.formatacaoService.quatroCasasDecimais(item.valor_fator_financeiro_produto);
      item.valor_fator_financeiro_total = parseFloat(item.valor_fator_financeiro_total.toFixed(2));
    });
  }

  ordenarProdutosAdicionados() {
    switch (this.tipoOrdenacaoItensPedido) {
      case 1:
        /* Ordenar = Inclusão */

        this.produtosAdicionados.sort((a, b) => {
          const compare = (v1, v2) => v1 == null ? -1 : v1 < v2 ? -1 : v1 > v2 ? 1 : 0;

          return compare(a["ordem"], b["ordem"]);
        });

        break;
      default:
        /* Ordernar = Alfabética */

        this.produtosAdicionados.sort((a, b) => {
          const compare = (v1, v2) => v1 == null ? -1 : v1 < v2 ? -1 : v1 > v2 ? 1 : 0;

          return compare(a["name"], b["name"]);
        });
    }

    this.produtosAdicionadosOriginal = JSON.parse(JSON.stringify(this.produtosAdicionados));
  }

  reiniciarDadosProduto() {
    this.produtos = JSON.parse(JSON.stringify(this.produtosOriginal));
  }

  totalizarProdutosAdicionados() {
    this.formatarProdutosAdicionados();

    this.valorParcialProdutosAdicionados = this.produtosAdicionados.filter(produtoAdicionado => produtoAdicionado.qtde > 0).reduce((sum, current) => sum + current.valor_imposto_total, 0);

    /* Peso */

    this.valorTotalPesoProdutosAdicionados = this.produtosAdicionados.filter(produtoAdicionado => produtoAdicionado.qtde > 0).reduce((sum, current) => (sum + ((current.peso != null ? current.peso : 0) * current.qtde)), 0);
    this.valorTotalPesoProdutosAdicionados = this.valorTotalPesoProdutosAdicionados + this.produtosAdicionados.filter(produtoAdicionado => produtoAdicionado.qtde_bonificada > 0).reduce((sum, current) => (sum + ((current.peso != null ? current.peso : 0) * current.qtde_bonificada)), 0);

    this.produtosAdicionados.forEach((item) => {
      if (item.categoria == this.campanhas) {
        item.produtos_vinculados.forEach((subItem) => {
          this.valorTotalPesoProdutosAdicionados = this.valorTotalPesoProdutosAdicionados + (((subItem.peso != null ? subItem.peso : 0) * subItem.qtde) * item.qtde);
        });
      }
    });

    this.valorTotalProdutosAdicionados = this.produtosAdicionados.filter(produtoAdicionado => produtoAdicionado.qtde > 0).reduce((sum, current) => sum + current.valor_imposto_total_final, 0);
    this.valorTotalProdutosAdicionadosFatorFinanceiro = this.produtosAdicionados.filter(produtoAdicionado => produtoAdicionado.qtde > 0).reduce((sum, current) => sum + current.valor_fator_financeiro, 0);
    this.valorTotalProdutosAdicionadosImposto = this.produtosAdicionados.filter(produtoAdicionado => produtoAdicionado.qtde > 0).reduce((sum, current) => sum + current.valor_imposto, 0);

    if (this.exibirPontuacao) {
      /* Pontuação total: produtosAdicionados + novos no modal ainda não confirmados */
      let totalPontuacao = this.produtosAdicionados.filter(produtoAdicionado => produtoAdicionado.qtde > 0).reduce(function(sum, current) { return sum + (current.pontuacao_calculada != null ? current.pontuacao_calculada : 0); }, 0);
      if (this.produtos != null) {
        this.produtos.forEach((p) => {
          const jaAdicionado = this.produtosAdicionados.find(function(a) { return a.id == p.id; });
          if (jaAdicionado == null && p.pontuacao_calculada != null && p.pontuacao_calculada > 0) {
            totalPontuacao += p.pontuacao_calculada;
          }
        });
      }
      this.valorTotalPontuacaoProdutosAdicionados = totalPontuacao;
    }
  }

  /* Adicionar Itens (Campanha) */

  atualizarDadosCampanha(id_campanha: number) {
    let produtoOriginal = this.produtosOriginal.find(produtoOriginal => produtoOriginal.id_campanha == id_campanha);

    if (produtoOriginal != null) {
      let produto = this.produtos.find(produto => produto.id_campanha == id_campanha);

      if (produto != null) {
        /* Produtos Original p/ Produtos */

        if (produtoOriginal.produtos_vinculados != null) {
          /* Qtde Mínima */

          if (produtoOriginal.grupo_estoque == this.combo) {
            produto.qtde_minima_atual = produtoOriginal.qtde_minima_atual;
          }

          produto.qtde_bonificacao_multiplicavel = produtoOriginal.qtde_bonificacao_multiplicavel;

          /* Produtos Vinculados */

          produto.produtos_vinculados = JSON.parse(JSON.stringify(produtoOriginal.produtos_vinculados));
        }

        produto.erro_qtde = false;

        produto.qtde = produtoOriginal.qtde;
        produto.valor = produtoOriginal.valor;

        if (produtoOriginal.grupo_estoque == this.combo) {
          produto.valor_total = produtoOriginal.valor_total;
          produto.valor_total_produtos_vinculados = produtoOriginal.valor_total_produtos_vinculados;
        }

        /* Imposto */

        produto.valor_imposto = produtoOriginal.valor_imposto;
        produto.valor_imposto_unitario = produtoOriginal.valor_imposto_unitario;
        produto.valor_imposto_produto = produtoOriginal.valor_imposto_produto;
        produto.valor_imposto_total = produtoOriginal.valor_imposto_total;

        produto.valor_imposto_total_final = produto.valor_imposto_total;

        produto.valor_unitario_final = produtoOriginal.valor_unitario_final;

        /* Fator Financeiro */

        /* Processado */

        produto.porcentagem_fator = produtoOriginal.porcentagem_fator;
        produto.valor_fator_financeiro = produtoOriginal.valor_fator_financeiro;
        produto.valor_fator_financeiro_unitario = produtoOriginal.valor_fator_financeiro_unitario;
        produto.valor_fator_financeiro_produto = produtoOriginal.valor_fator_financeiro_produto;
        produto.valor_fator_financeiro_total = produtoOriginal.valor_fator_financeiro_total;

        /* Pontuação */

        produto.pontuacao_calculada = produtoOriginal.pontuacao_calculada;

        /* Ordem */

        produto.ordem = produtoOriginal.ordem;
      }
    }
  }

  decrementarQtdeCampanha() {
    if (this.produtoCampanhaSelecionado != null) {
      if (this.produtoCampanhaSelecionado.qtde_minima_atual < this.produtoCampanhaSelecionado.qtde_minima) {
        this.toastr.error("", "Qtde Mínima de Itens inválida!");

        this.produtoCampanhaSelecionado.qtde = null;

        return;
      } else {
        this.produtoCampanhaSelecionado.qtde--;

        if (this.produtoCampanhaSelecionado.qtde < 1) {
          this.produtoCampanhaSelecionado.qtde = null;
        }

        /* Bonificação */

        this.definirQtdeBonificacaoMultiplicavel(false);
      }

      /* Totalizar */

      this.totalizarProdutoCampanhaSelecionado();

      this.calcularImpostoCampanha();
      this.validarCampanhaQtde();
    }
  }

  decrementarQtdeCampanhaProduto(id_produto: number) {
    if (this.produtoCampanhaSelecionado != null) {
      let produtoVinculado = this.produtoCampanhaSelecionado.produtos_vinculados.find(produtosVinculados => produtosVinculados.id == id_produto);

      if (produtoVinculado != null) {
        let qtde: number = produtoVinculado.qtde;

        if (produtoVinculado.multiplo != null && produtoVinculado.multiplo != 0 && produtoVinculado.multiplo != 1) {
          /* C/ Múltiplo */

          if (qtde <= 1) {
            qtde = 0;
          } else {
            let qtdeFutura: number = qtde - produtoVinculado.multiplo;

            if (qtdeFutura == 0 || qtdeFutura % produtoVinculado.multiplo != 0) {
              qtde = 0;
            } else {
              qtde = qtdeFutura;
            }
          }
        } else {
          /* S/ Múltiplo */

          if (qtde <= 1) {
            qtde = 0;
          } else {
            qtde--;
          }
        }

        produtoVinculado.qtde = qtde;

        this.validarCampanhaProdutoQtde(id_produto);
      }
    }
  }

  excluirProdutoCampanha(id_campanha: number) {
    let produtoCampanhaSelecionado: ProdutoPromocional = this.produtosOriginal.find(produtoOriginal => produtoOriginal.id_campanha == id_campanha);

    if (produtoCampanhaSelecionado != null) {
      /* Produto Inicial */

      if (produtoCampanhaSelecionado.grupo_estoque == this.combo) {
        if (produtoCampanhaSelecionado.produtos_vinculados != null) {
          /* Produtos Vinculados */

          produtoCampanhaSelecionado.produtos_vinculados.forEach((item) => {
            if (!item.bonificacao) {
              item.qtde = null;
            }

            if (produtoCampanhaSelecionado.grupo_estoque == this.combo) {
              item.valor_total = 0;
            }
          });
        }
      }

      produtoCampanhaSelecionado.qtde = null;
      produtoCampanhaSelecionado.valor = null;

      if (produtoCampanhaSelecionado.grupo_estoque == this.combo) {
        produtoCampanhaSelecionado.valor_total = 0;
        produtoCampanhaSelecionado.valor_total_produtos_vinculados = 0;
      }

      this.calcularFatorFinanceiro();
      this.atualizarDadosCampanha(id_campanha);
    }
  }

  incrementarQtdeCampanha() {
    if (this.produtoCampanhaSelecionado != null) {
      if (this.produtoCampanhaSelecionado.qtde_minima_atual < this.produtoCampanhaSelecionado.qtde_minima) {
        this.toastr.error("", "Qtde Mínima de Itens inválida!");

        this.produtoCampanhaSelecionado.qtde = null;

        return;
      } else {
        this.produtoCampanhaSelecionado.qtde++;

        /* Bonificação */

        this.definirQtdeBonificacaoMultiplicavel(false);
      }

      /* Totalizar */

      this.totalizarProdutoCampanhaSelecionado();

      this.calcularImpostoCampanha();
      this.validarCampanhaQtde();
    }
  }

  incrementarQtdeCampanhaProduto(id_produto: number) {
    if (this.produtoCampanhaSelecionado != null) {
      let produtoVinculado = this.produtoCampanhaSelecionado.produtos_vinculados.find(produtosVinculados => produtosVinculados.id == id_produto);

      if (produtoVinculado != null) {
        let qtde: number = produtoVinculado.qtde;

        if (produtoVinculado.multiplo != null && produtoVinculado.multiplo != 0 && produtoVinculado.multiplo != 1) {
          /* C/ Múltiplo */

          if (qtde <= 0 || qtde == null) {
            qtde = produtoVinculado.multiplo;
          } else {
            let qtdeFutura: number = qtde + produtoVinculado.multiplo;

            if (qtdeFutura % produtoVinculado.multiplo != 0) {
              qtde = produtoVinculado.multiplo;
            } else {
              qtde = qtdeFutura;
            }
          }
        } else {
          /* S/ Múltiplo */

          if (qtde <= 0 || qtde == null) {
            qtde = 1;
          } else {
            qtde++;
          }
        }

        produtoVinculado.qtde = qtde;

        this.validarCampanhaProdutoQtde(id_produto);
      }
    }
  }

  repassarDadosCampanha(cancelando: boolean) {
    let retorno = new Promise<void>((resolver) => {
      if (this.produtoCampanhaSelecionado != null) {
        let produtoAdicionado = this.produtosAdicionados.find(produtoAdicionado => produtoAdicionado.id_campanha == this.produtoCampanhaSelecionado.id_campanha);

        if (cancelando) {
          let produtoOriginal = this.produtosOriginal.find(produtoOriginal => produtoOriginal.id_campanha == this.produtoCampanhaSelecionado.id_campanha);

          if (produtoAdicionado != null) {
            /* Produtos Adicionados p/ Produtos Original */

            if (produtoOriginal.produtos_vinculados != null) {
              /* Qtde Mínima */

              if (produtoOriginal.grupo_estoque == this.combo) {
                produtoOriginal.qtde_minima_atual = produtoAdicionado.qtde_minima_atual;
              }

              produtoOriginal.qtde_bonificacao_multiplicavel = produtoAdicionado.qtde_bonificacao_multiplicavel;

              /* Produtos Vinculados */

              produtoOriginal.produtos_vinculados = JSON.parse(JSON.stringify(produtoAdicionado.produtos_vinculados));
            }

            produtoOriginal.erro_qtde = false;

            produtoOriginal.qtde = produtoAdicionado.qtde;
            produtoOriginal.valor = produtoAdicionado.valor;

            if (produtoOriginal.grupo_estoque == this.combo) {
              produtoOriginal.valor_total = produtoAdicionado.valor_total;
              produtoOriginal.valor_total_produtos_vinculados = produtoAdicionado.valor_total_produtos_vinculados;
            }

            /* Imposto */

            produtoOriginal.valor_imposto = produtoAdicionado.valor_imposto;
            produtoOriginal.valor_imposto_unitario = produtoAdicionado.valor_imposto_unitario;
            produtoOriginal.valor_imposto_produto = produtoAdicionado.valor_imposto_produto;
            produtoOriginal.valor_imposto_total = produtoAdicionado.valor_imposto_total;

            produtoOriginal.valor_imposto_total_final = produtoOriginal.valor_imposto_total;

            produtoOriginal.valor_unitario_final = produtoAdicionado.valor_unitario_final;

            /* Fator Financeiro */

            /* Processado */

            produtoOriginal.porcentagem_fator = produtoAdicionado.porcentagem_fator;
            produtoOriginal.valor_fator_financeiro = produtoAdicionado.valor_fator_financeiro;
            produtoOriginal.valor_fator_financeiro_unitario = produtoAdicionado.valor_fator_financeiro_unitario;
            produtoOriginal.valor_fator_financeiro_produto = produtoAdicionado.valor_fator_financeiro_produto;
            produtoOriginal.valor_fator_financeiro_total = produtoAdicionado.valor_fator_financeiro_total;

            /* Pontuação */

            produtoOriginal.pontuacao_calculada = produtoAdicionado.pontuacao_calculada;

            /* Ordem */

            produtoOriginal.ordem = 0;
          } else {
            /* Produto Inicial */

            if (produtoOriginal.grupo_estoque == this.combo) {
              if (produtoOriginal.produtos_vinculados != null) {
                /* Produtos Vinculados */

                produtoOriginal.produtos_vinculados.forEach((item) => {
                  item.qtde = null;
                });
              }
            }

            produtoOriginal.qtde = null;
            produtoOriginal.valor = null;

            if (produtoOriginal.grupo_estoque == this.combo) {
              produtoOriginal.valor_total = 0;
              produtoOriginal.valor_total_produtos_vinculados = 0;
            }

            this.calcularFatorFinanceiro();
          }
        } else {
          /* Produto Selecionado p/ Produtos Original */

          let produtoOriginal = this.produtosOriginal.find(produtoOriginal => produtoOriginal.id_campanha == this.produtoCampanhaSelecionado.id_campanha);

          if (produtoOriginal != null) {
            if (produtoOriginal.produtos_vinculados != null) {
              /* Qtde Mínima */

              if (produtoOriginal.grupo_estoque == this.combo) {
                produtoOriginal.qtde_minima_atual = this.produtoCampanhaSelecionado.qtde_minima_atual;
              }

              produtoOriginal.qtde_bonificacao_multiplicavel = this.produtoCampanhaSelecionado.qtde_bonificacao_multiplicavel;

              /* Produtos Vinculados */

              produtoOriginal.produtos_vinculados = JSON.parse(JSON.stringify(this.produtoCampanhaSelecionado.produtos_vinculados));
            }

            produtoOriginal.erro_qtde = false;

            produtoOriginal.qtde = this.produtoCampanhaSelecionado.qtde;
            produtoOriginal.valor = this.produtoCampanhaSelecionado.valor;

            if (produtoOriginal.grupo_estoque == this.combo) {
              produtoOriginal.valor_total = this.produtoCampanhaSelecionado.valor_total;
              produtoOriginal.valor_total_produtos_vinculados = this.produtoCampanhaSelecionado.valor_total_produtos_vinculados;
            }

            /* Imposto */

            produtoOriginal.valor_imposto = this.produtoCampanhaSelecionado.valor_imposto;
            produtoOriginal.valor_imposto_unitario = this.produtoCampanhaSelecionado.valor_imposto_unitario;
            produtoOriginal.valor_imposto_produto = this.produtoCampanhaSelecionado.valor_imposto_produto;
            produtoOriginal.valor_imposto_total = this.produtoCampanhaSelecionado.valor_imposto_total;

            produtoOriginal.valor_imposto_total_final = produtoOriginal.valor_imposto_total;

            produtoOriginal.valor_unitario_final = this.produtoCampanhaSelecionado.valor_unitario_final;

            /* Fator Financeiro */

            /* Processado */

            produtoOriginal.porcentagem_fator = this.produtoCampanhaSelecionado.porcentagem_fator;
            produtoOriginal.valor_fator_financeiro = this.produtoCampanhaSelecionado.valor_fator_financeiro;
            produtoOriginal.valor_fator_financeiro_unitario = this.produtoCampanhaSelecionado.valor_fator_financeiro_unitario;
            produtoOriginal.valor_fator_financeiro_produto = this.produtoCampanhaSelecionado.valor_fator_financeiro_produto;
            produtoOriginal.valor_fator_financeiro_total = this.produtoCampanhaSelecionado.valor_fator_financeiro_total;

            /* Pontuação */

            produtoOriginal.pontuacao_calculada = this.produtoCampanhaSelecionado.pontuacao_calculada;

            /* Ordem */

            produtoOriginal.ordem = this.produtoCampanhaSelecionado.ordem;
          }
        }
      }

      return resolver();
    });

    return retorno;
  }

  /* Campanha (Bonificação) */

  alterarBonificacao(id_produto: string) {
    let idProduto: number = parseInt(id_produto);

    if (this.produtoCampanhaSelecionado != null) {
      if (this.produtoCampanhaSelecionado.produtos_vinculados != null) {
        /* Produtos Vinculados */

        this.produtoCampanhaSelecionado.produtos_vinculados.forEach((item) => {
          if (item.bonificacao) {
            /* Bonificação */

            if (item.id == idProduto) {
              item.bonificacao_selecionada = true;

              this.bonificacaoInvalida = false;
            } else {
              item.bonificacao_selecionada = false;
            }
          }
        });
      }
    }
  }

  /* Campanha (Qtde (Bonificação)) */

  definirQtdeBonificacaoMultiplicavel(validar: boolean) {
    if (this.produtoCampanhaSelecionado != null) {
      if (this.produtoCampanhaSelecionado.preco_bonificacao == "B") {
        /* Bonificação */

        let qtdeBonificacaoMultiplicavel: number = 0;

        if (this.produtoCampanhaSelecionado.bonificacao_multiplicavel) {
          /* Multiplicável */

          if (this.produtoCampanhaSelecionado.qtde_minima > 0) {
            qtdeBonificacaoMultiplicavel = this.produtoCampanhaSelecionado.qtde_minima_atual / this.produtoCampanhaSelecionado.qtde_minima;

            qtdeBonificacaoMultiplicavel = parseInt(qtdeBonificacaoMultiplicavel.toString()) * this.produtoCampanhaSelecionado.qtde;

            if (qtdeBonificacaoMultiplicavel < 1) {
              qtdeBonificacaoMultiplicavel = null;
            }
          } else {
            qtdeBonificacaoMultiplicavel = this.produtoCampanhaSelecionado.qtde;
          }

          this.produtoCampanhaSelecionado.qtde_bonificacao_multiplicavel = qtdeBonificacaoMultiplicavel;
        } else {
          this.produtoCampanhaSelecionado.qtde_bonificacao_multiplicavel = 1;
        }
      }

      if (validar) {
        this.validarCampanhaQtdeGeral();
      }
    }
  }

  localizarProdutoBonificado() {
    if (this.produtoCampanhaSelecionado != null) {
      if (this.produtoCampanhaSelecionado.preco_bonificacao == "B" && !this.produtoCampanhaSelecionado.bonificacao_selecionavel) {
        if (this.produtoCampanhaSelecionado.produtos_vinculados != null) {
          /* Produtos Vinculados */

          this.produtoCampanhaSelecionado.produtos_vinculados.forEach((item) => {
            item.bonificacao_selecionada = false;
          });

          let produtosVinculados = this.produtoCampanhaSelecionado.produtos_vinculados.filter(produtosVinculados => produtosVinculados.qtde > 0 && !produtosVinculados.bonificacao);

          produtosVinculados = JSON.parse(JSON.stringify(produtosVinculados));

          if (produtosVinculados.length > 0) {
            produtosVinculados.sort((a, b) => {
              const compare = (v1, v2) => v1 == null ? -1 : v1 < v2 ? -1 : v1 > v2 ? 1 : 0;

              return compare(a["price_promotional"], b["price_promotional"]);
            });

            let produtoVinculado = this.produtoCampanhaSelecionado.produtos_vinculados.find(produtoVinculado => produtoVinculado.id == produtosVinculados[0].id);

            if (produtoVinculado != null) {
              produtoVinculado.bonificacao_selecionada = true;
            }
          }
        }
      }
    }
  }

  /* Campanha (Qtde (Combo)) */

  validarQtdeMinimaCombo() {
    if (this.produtoCampanhaSelecionado != null) {
      if (this.produtoCampanhaSelecionado.grupo_estoque == this.combo) {
        let qtdeMinimaAtual: number = this.produtoCampanhaSelecionado.produtos_vinculados.filter(produtosVinculados => !produtosVinculados.bonificacao && !produtosVinculados.erro_qtde).reduce((sum, current) => (sum + current.qtde), 0);

        this.produtoCampanhaSelecionado.qtde_minima_atual = qtdeMinimaAtual;
      }
    }
  }

  /* Campanha (Totalizar) */

  /**
   * Resolve o valor unitário de uma campanha, preservando o valor calculado
   * pelo desconto quando o usuário editou a % de desconto.
   */
  private resolveValorUnitarioCampanha(produto: ProdutoPromocional): number {
    // Se o desconto foi editado e já temos um valor calculado, preservá-lo
    if (produto.valor != null && produto.valor > 0 &&
        (produto.porcentagem_desconto_temporaria != null || (produto as any).desconto_digitado != null)) {
      return produto.valor;
    }
    // Regra padrão
    if (produto.price_promotional > 0) {
      return produto.price_promotional;
    }
    return produto.price;
  }

  totalizarProdutoCampanhaSelecionado() {
    /* Totalizar */

    if (this.produtoCampanhaSelecionado.grupo_estoque == this.combo) {
      this.produtoCampanhaSelecionado.valor = this.produtoCampanhaSelecionado.valor_total_produtos_vinculados == 0 ? null : this.produtoCampanhaSelecionado.valor_total_produtos_vinculados;

      let valorTotal: number = this.produtoCampanhaSelecionado.valor_total_produtos_vinculados * this.produtoCampanhaSelecionado.qtde;

      this.produtoCampanhaSelecionado.valor_total = parseFloat(valorTotal.toFixed(2));
    } else {
      let unitario: number = this.resolveValorUnitarioCampanha(this.produtoCampanhaSelecionado);
      this.produtoCampanhaSelecionado.valor = unitario == 0 ? null : unitario;

      let valorTotal: number = unitario * this.produtoCampanhaSelecionado.qtde;

      this.produtoCampanhaSelecionado.valor_total = parseFloat(valorTotal.toFixed(2));
    }
  }

  /* Composição */

  selecionarOrigemComposicao(origem_composicao: string) {
    switch(origem_composicao) {
      case "0":
        // Produtos

        this.produtosComposicoes = JSON.parse(JSON.stringify(this.produtos));

        break;
      case "1":
        // Produtos (Adicionados)

        this.produtosComposicoes = JSON.parse(JSON.stringify(this.produtosAdicionados));

        break;
      case "2":
        // Produtos (Adicionados (Original))

        this.produtosComposicoes = JSON.parse(JSON.stringify(this.produtosAdicionadosOriginal));

        break;
      case "3":
        // Produtos (Original)

        this.produtosComposicoes = JSON.parse(JSON.stringify(this.produtosOriginal));

        break;
      case "4":
        // Produtos (Selecionado)

        this.produtosComposicoes = [];

        if (this.produtoCampanhaSelecionado != null) {
          this.produtosComposicoes.push(JSON.parse(JSON.stringify(this.produtoCampanhaSelecionado)));
        }

        break;
      default:
        this.produtosComposicoes = [];

        break;
    }

    this.produtosComposicoes.forEach((item) => {
      item.expandido = false;
    });
  }

  expandirProdutoCampanhaComposicao(id_campanha: number) {
    this.produtosComposicoes.forEach((item) => {
      if (item.id_campanha == id_campanha) {
        item.expandido = !item.expandido;
      } else {
        item.expandido = false;
      }
    });
  }

  /* Adicionar Itens (Produto) */

  decrementarQtdeProduto(id_produto: number) {
    let produto = this.produtos.find(produto => produto.id == id_produto);

    if (produto != null) {
      if (produto.id_kit_combo == null) {
        if (produto.qtde_lote == 0 || (produto.qtde_lote > 0 && produto.id_lote != null)) {
          let qtde: number = produto.qtde;

          if ((this.tiposPedidoSelecionado != null && this.tiposPedidoSelecionado.flag_considerar_pedido_como_venda) && (produto.multiplo != null && produto.multiplo != 0 && produto.multiplo != 1)) {
            /* C/ Múltiplo */

            if (qtde <= 1) {
              qtde = null;
            } else {
              let qtdeFutura: number = qtde - produto.multiplo;

              if (qtdeFutura == 0 || qtdeFutura % produto.multiplo != 0) {
                qtde = null;
              } else {
                qtde = qtdeFutura;
              }
            }
          } else {
            /* S/ Múltiplo */

            if (qtde <= 1) {
              qtde = null;
            } else {
              qtde--;
            }
          }

          produto.qtde = qtde;

          this.validarProdutoQtde(id_produto, true);
        }
      } else {
        this.toastr.warning("", "Produto originado de campanha...");
      }
    }
  }

  definirOrdemInclusao(id_produto: number, com_dados: boolean) {
    let produtoOriginal: ProdutoPromocional = this.produtosOriginal.find(produtoOriginal => produtoOriginal.id == id_produto);

    if (produtoOriginal != null) {
      if (com_dados) {
        if (produtoOriginal.ordem == 0) {
          let ordemAtual: number = Math.max(...this.produtosOriginal.map(produtoOriginal => produtoOriginal.ordem));

          produtoOriginal.ordem = ordemAtual + 1;
        }
      } else {
        produtoOriginal.ordem = 0;
      }
    }
  }

  incrementarQtdeProduto(id_produto: number) {
    let produto = this.produtos.find(produto => produto.id == id_produto);

    if (produto != null) {
      if (produto.id_kit_combo == null) {
        if (produto.qtde_lote == 0 || (produto.qtde_lote > 0 && produto.id_lote != null)) {
          let qtde: number = produto.qtde;

          if ((this.tiposPedidoSelecionado != null && this.tiposPedidoSelecionado.flag_considerar_pedido_como_venda) && (produto.multiplo != null && produto.multiplo != 0 && produto.multiplo != 1)) {
            /* C/ Múltiplo */

            if (qtde <= 0 || qtde == null) {
              qtde = produto.multiplo;
            } else {
              let qtdeFutura: number = qtde + produto.multiplo;

              if (qtdeFutura % produto.multiplo != 0) {
                qtde = produto.multiplo;
              } else {
                qtde = qtdeFutura;
              }
            }
          } else {
            /* S/ Múltiplo */

            if (qtde <= 0 || qtde == null) {
              qtde = 1;
            } else {
              qtde++;
            }
          }

          produto.qtde = qtde;

          this.validarProdutoQtde(id_produto, true);
        }
      } else {
        this.toastr.warning("", "Produto originado de campanha...");
      }
    }
  }

  definirPorcentagemDescontoTemporario(porcentagem_desconto_temporaria: number) {
    this.porcentagemDescontoTemporario = porcentagem_desconto_temporaria;
  }

  repassarDadosProduto(cancelando: boolean) {
    let retorno = new Promise<void>((resolver) => {
      this.produtos.forEach((item) => {
        if (item.categoria != this.campanhas) {
          /* Produto */

          let produtoAdicionadoOriginal = this.produtosAdicionadosOriginal.find(produtoAdicionadoOriginal => produtoAdicionadoOriginal.id == item.id);

          // Considera "com valores" somente quando o usuário inseriu uma quantidade
          // (qtde ou qtde_bonificada) OU há um lote com qtde. O campo valor é
          // auto-preenchido da tabela de preços e NÃO deve por si só acionar a
          // validação, pois causaria "Qtde inválida!" em todos os itens do grid.
          if ((item.qtde_lote > 0 && item.id_lote != null) || (item.qtde != null || item.qtde_bonificada != null)) {
            /* Com valores */

            if (cancelando) {
              if (produtoAdicionadoOriginal != null) {
                /* Produtos Adicionados p/ Produtos Original */

                let produtoOriginal = this.produtosOriginal.find(produtoOriginal => produtoOriginal.id == item.id);

                if (produtoOriginal != null) {
                  produtoOriginal.erro_lote = produtoAdicionadoOriginal.erro_lote;

                  if (this.tiposPedidoErro) {
                    produtoOriginal.erro_qtde = false;
                  } else {
                    produtoOriginal.erro_qtde = produtoAdicionadoOriginal.erro_qtde;
                  }

                  produtoOriginal.erro_valor = produtoAdicionadoOriginal.erro_valor;

                  produtoOriginal.valor_tabela = produtoAdicionadoOriginal.valor_tabela;

                  produtoOriginal.qtde = produtoAdicionadoOriginal.qtde;
                  produtoOriginal.valor = produtoAdicionadoOriginal.valor;

                  produtoOriginal.valor_total = produtoAdicionadoOriginal.valor_total;
                  produtoOriginal.porcentagem_desconto = produtoAdicionadoOriginal.porcentagem_desconto;
                  produtoOriginal.descritivo_desconto = produtoAdicionadoOriginal.descritivo_desconto;
                  produtoOriginal.observacao_item = produtoAdicionadoOriginal.observacao_item;

                  produtoOriginal.saldo_gerado = produtoAdicionadoOriginal.saldo_gerado;

                  /* Lote */

                  produtoOriginal.id_lote = produtoAdicionadoOriginal.id_lote;
                  produtoOriginal.nome_lote = produtoAdicionadoOriginal.nome_lote;
                  produtoOriginal.cod_lote = produtoAdicionadoOriginal.cod_lote;
                  produtoOriginal.estoque_lote = produtoAdicionadoOriginal.estoque_lote;
                  produtoOriginal.validade_lote = produtoAdicionadoOriginal.validade_lote;
                  produtoOriginal.preco_lote = produtoAdicionadoOriginal.preco_lote;

                  /* Ordem */

                  produtoOriginal.ordem = produtoAdicionadoOriginal.ordem;

                  /* Qtde (Bonificada) */

                  produtoOriginal.qtde_bonificada = produtoAdicionadoOriginal.qtde_bonificada;

                  /* Total Fracionado */

                  produtoOriginal.valor_unitario_fracionado = produtoAdicionadoOriginal.valor_unitario_fracionado;
                  produtoOriginal.valor_unitario_imposto_fracionado = produtoAdicionadoOriginal.valor_unitario_imposto_fracionado;

                  /* Porcentagem Desconto (Temporária) */

                  produtoOriginal.porcentagem_desconto_temporaria = produtoAdicionadoOriginal.porcentagem_desconto_temporaria;
                }
              } else {
                /* Produto Inicial */

                let produtoOriginal = this.produtosOriginal.find(produtoOriginal => produtoOriginal.id == item.id);

                if (produtoOriginal != null) {
                  produtoOriginal.erro_lote = false;
                  produtoOriginal.erro_qtde = false;
                  produtoOriginal.erro_valor = false;

                  produtoOriginal.valor_tabela = 0;
                produtoOriginal.estado_preco = null;
                produtoOriginal.preco_base_api = null;

                  produtoOriginal.qtde = null;
                  produtoOriginal.valor = null;

                  produtoOriginal.valor_total = 0;
                  produtoOriginal.porcentagem_desconto = 0;
                  produtoOriginal.descritivo_desconto = null;
                  produtoOriginal.observacao_item = null;

                  produtoOriginal.saldo_gerado = 0;

                  /* Lote */

                  produtoOriginal.id_lote = null;
                  produtoOriginal.nome_lote = null;
                  produtoOriginal.cod_lote = null;
                  produtoOriginal.estoque_lote = null;
                  produtoOriginal.validade_lote = null;
                  produtoOriginal.preco_lote = null;

                  /* Ordem */

                  produtoOriginal.ordem = 0;

                  /* Qtde (Bonificada) */

                  produtoOriginal.qtde_bonificada = null;

                  /* Total Fracionado */

                  produtoOriginal.valor_unitario_fracionado = null;
                  produtoOriginal.valor_unitario_imposto_fracionado = null;

                  /* Porcentagem Desconto (Temporária) */

                  produtoOriginal.porcentagem_desconto_temporaria = null;
                }
              }
            } else {
              /* Produtos p/ Produtos Original */

              let produtoOriginal = this.produtosOriginal.find(produtoOriginal => produtoOriginal.id == item.id);

              if (produtoOriginal != null) {
                if (item.qtde_lote > 0 && item.id_lote == null) {
                  produtoOriginal.erro_lote = true;
                  produtoOriginal.erro_qtde = false;
                  produtoOriginal.erro_valor = false;
                } else {
                  produtoOriginal.erro_lote = false;

                  if (item.qtde_bonificada == null || item.qtde_bonificada <= 0) {
                    if ((item.qtde == 0 || item.qtde == null) && (item.valor != 0 && item.valor != null)) {
                      produtoOriginal.erro_qtde = true;
                    } else {
                      produtoOriginal.erro_qtde = item.erro_qtde;
                    }
                  } else {
                    /* Qtde (Bonificada) */

                    produtoOriginal.erro_qtde = false;
                  }

                  if (item.qtde_bonificada == null || item.qtde_bonificada <= 0) {
                    if ((item.qtde != 0 && item.qtde != null) && (item.valor == 0 || item.valor == null)) {
                      produtoOriginal.erro_valor = true;
                    } else {
                      produtoOriginal.erro_valor = item.erro_valor;
                    }
                  } else {
                    /* Qtde (Bonificada) */

                    if (item.valor == 0 || item.valor == null) {
                      produtoOriginal.erro_valor = true;
                    } else {
                      produtoOriginal.erro_valor = item.erro_valor;
                    }
                  }
                }

                produtoOriginal.valor_tabela = item.valor_tabela;

                produtoOriginal.qtde = item.qtde;
                produtoOriginal.valor = item.valor;

                produtoOriginal.valor_total = item.valor_total;
                produtoOriginal.porcentagem_desconto = item.porcentagem_desconto;
                produtoOriginal.descritivo_desconto = item.descritivo_desconto;
                produtoOriginal.observacao_item = item.observacao_item;

                /* Lote */

                produtoOriginal.id_lote = item.id_lote;
                produtoOriginal.nome_lote = item.nome_lote;
                produtoOriginal.cod_lote = item.cod_lote;
                produtoOriginal.estoque_lote = item.estoque_lote;
                produtoOriginal.validade_lote = item.validade_lote;
                produtoOriginal.preco_lote = item.preco_lote;

                /* Qtde (Bonificada) */

                produtoOriginal.qtde_bonificada = item.qtde_bonificada;

                /* Total Fracionado */

                produtoOriginal.valor_unitario_fracionado = item.valor_unitario_fracionado;
                produtoOriginal.valor_unitario_imposto_fracionado = item.valor_unitario_imposto_fracionado;

                /* Porcentagem Desconto (Temporária) */

                produtoOriginal.porcentagem_desconto_temporaria = item.porcentagem_desconto_temporaria;


                this.copiarEstadoPreco(produtoOriginal, item);
              }
            }
          } else {
            /* Sem valores */

            if (produtoAdicionadoOriginal != null) {
              /* Produtos Adicionados p/ Produtos Original */

              let produtoOriginal = this.produtosOriginal.find(produtoOriginal => produtoOriginal.id == item.id);

              if (produtoOriginal != null) {
                if (cancelando) {
                  produtoOriginal.erro_lote = produtoAdicionadoOriginal.erro_lote;
                  produtoOriginal.erro_qtde = produtoAdicionadoOriginal.erro_qtde;
                  produtoOriginal.erro_valor = produtoAdicionadoOriginal.erro_valor;

                  produtoOriginal.valor_tabela = produtoAdicionadoOriginal.valor_tabela;

                  produtoOriginal.qtde = produtoAdicionadoOriginal.qtde;
                  produtoOriginal.valor = produtoAdicionadoOriginal.valor;

                  produtoOriginal.valor_total = produtoAdicionadoOriginal.valor_total;
                  produtoOriginal.porcentagem_desconto = produtoAdicionadoOriginal.porcentagem_desconto;
                  produtoOriginal.descritivo_desconto = produtoAdicionadoOriginal.descritivo_desconto;
                  produtoOriginal.observacao_item = produtoAdicionadoOriginal.observacao_item;

                  produtoOriginal.saldo_gerado = produtoAdicionadoOriginal.saldo_gerado;

                  /* Lote */

                  produtoOriginal.id_lote = produtoAdicionadoOriginal.id_lote;
                  produtoOriginal.nome_lote = produtoAdicionadoOriginal.nome_lote;
                  produtoOriginal.cod_lote = produtoAdicionadoOriginal.cod_lote;
                  produtoOriginal.estoque_lote = produtoAdicionadoOriginal.estoque_lote;
                  produtoOriginal.validade_lote = produtoAdicionadoOriginal.validade_lote;
                  produtoOriginal.preco_lote = produtoAdicionadoOriginal.preco_lote;

                  /* Ordem */

                  produtoOriginal.ordem = produtoAdicionadoOriginal.ordem;

                  /* Qtde (Bonificada) */

                  produtoOriginal.qtde_bonificada = produtoAdicionadoOriginal.qtde_bonificada;

                  /* Total Fracionado */

                  produtoOriginal.valor_unitario_fracionado = produtoAdicionadoOriginal.valor_unitario_fracionado;
                  produtoOriginal.valor_unitario_imposto_fracionado = produtoAdicionadoOriginal.valor_unitario_imposto_fracionado;

                  /* Porcentagem Desconto (Temporária) */

                  produtoOriginal.porcentagem_desconto_temporaria = produtoAdicionadoOriginal.porcentagem_desconto_temporaria;


                  this.copiarEstadoPreco(produtoOriginal, produtoAdicionadoOriginal);
                } else {
                  /* Produtos p/ Produtos Original */

                  if (item.qtde_lote > 0 && item.id_lote == null) {
                    produtoOriginal.erro_lote = true;
                    produtoOriginal.erro_qtde = false;
                    produtoOriginal.erro_valor = false;
                  } else {
                    produtoOriginal.erro_lote = false;

                    if (item.qtde_bonificada == null || item.qtde_bonificada <= 0) {
                      if (item.qtde == 0 || item.qtde == null) {
                        produtoOriginal.erro_qtde = true;
                      } else {
                        produtoOriginal.erro_qtde = item.erro_qtde;
                      }
                    } else {
                      /* Qtde (Bonificada) */

                      produtoOriginal.erro_qtde = item.erro_qtde;
                    }

                    if (item.valor == 0 || item.valor == null) {
                      produtoOriginal.erro_valor = true;
                    } else {
                      produtoOriginal.erro_valor = item.erro_valor;
                    }
                  }

                  produtoOriginal.valor_tabela = item.valor_tabela;

                  produtoOriginal.qtde = item.qtde;
                  produtoOriginal.valor = item.valor;

                  produtoOriginal.valor_total = item.valor_total;
                  produtoOriginal.porcentagem_desconto = item.porcentagem_desconto;
                  produtoOriginal.descritivo_desconto = item.descritivo_desconto;
                  produtoOriginal.observacao_item = item.observacao_item;

                  /* Lote */

                  produtoOriginal.id_lote = item.id_lote;
                  produtoOriginal.nome_lote = item.nome_lote;
                  produtoOriginal.cod_lote = item.cod_lote;
                  produtoOriginal.estoque_lote = item.estoque_lote;
                  produtoOriginal.validade_lote = item.validade_lote;
                  produtoOriginal.preco_lote = item.preco_lote;

                  /* Qtde (Bonificada) */

                  produtoOriginal.qtde_bonificada = item.qtde_bonificada;

                  /* Total Fracionado */

                  produtoOriginal.valor_unitario_fracionado = item.valor_unitario_fracionado;
                  produtoOriginal.valor_unitario_imposto_fracionado = item.valor_unitario_imposto_fracionado;

                  /* Porcentagem Desconto (Temporária) */

                  produtoOriginal.porcentagem_desconto_temporaria = item.porcentagem_desconto_temporaria;


                  this.copiarEstadoPreco(produtoOriginal, item);
                }
              }
            } else {
              /* Produto Inicial */

              let produtoOriginal = this.produtosOriginal.find(produtoOriginal => produtoOriginal.id == item.id);

              if (produtoOriginal != null) {
                produtoOriginal.erro_lote = false;
                produtoOriginal.erro_qtde = false;
                produtoOriginal.erro_valor = false;

                produtoOriginal.valor_tabela = 0;
                produtoOriginal.estado_preco = null;
                produtoOriginal.preco_base_api = null;

                produtoOriginal.qtde = null;
                produtoOriginal.valor = null;

                produtoOriginal.valor_total = 0;
                produtoOriginal.porcentagem_desconto = 0;
                produtoOriginal.descritivo_desconto = null;
                produtoOriginal.observacao_item = null;

                produtoOriginal.saldo_gerado = 0;

                /* Lote */

                produtoOriginal.id_lote = null;
                produtoOriginal.nome_lote = null;
                produtoOriginal.cod_lote = null;
                produtoOriginal.estoque_lote = null;
                produtoOriginal.validade_lote = null;
                produtoOriginal.preco_lote = null;

                /* Ordem */

                produtoOriginal.ordem = 0;

                /* Qtde (Bonificada) */

                produtoOriginal.qtde_bonificada = null;

                /* Total Fracionado */

                produtoOriginal.valor_unitario_fracionado = null;
                produtoOriginal.valor_unitario_imposto_fracionado = null;

                /* Porcentagem Desconto (Temporária) */

                produtoOriginal.porcentagem_desconto_temporaria = null;
              }
            }
          }
        }
      });

      this.calcularFatorFinanceiro();

      return resolver();
    });

    return retorno;
  }

  selecionarDescontoProduto(id_produto: number, po_desconto: number) {
    const produto = this.produtos.find(produto => produto.id == id_produto);

    if (produto == null) { return; }

    if (produto.preco_tabela_travado === true) {
      this.toastr.info("", "Desconto está travado (tabela utilizada). Remova a trava para alterar.");
      return;
    }

    if (produto.id_kit_combo != null) {
      this.toastr.warning("", "Produto originado de campanha...");
      return;
    }

    if (po_desconto > 0) {
      produto.ultima_edicao = 'desconto';
      this.garantirEstadoPreco(produto);
      this.aplicarPercentualDesconto(produto, po_desconto);

      this.calcularDescontoUnitario(id_produto, true, false);
      this.validarProdutoValor(id_produto, true);
    }
  }

  selecionarDescontoProdutoNovo(id_produto: number, po_desconto: number) {
    this.selecionarDescontoProduto(id_produto, po_desconto);
  }

  selecionarValorProduto(id_produto: number, preco_unitario: number) {
    const produto = this.obterProdutoParaSelecaoPreco(id_produto);

    if (produto == null || !(preco_unitario > 0)) { return; }

    this.fixarEstadoPreco(produto, 'tabela_normal', preco_unitario, { precoBrutoSemFator: preco_unitario });

    if (this.modalReferenciaTabelasProdutos != null) {
      this.modalReferenciaTabelasProdutos.close();
    }

    this.calcularImpostoProduto(id_produto, false);
    this.validarProdutoQtde(produto.id, true);
  }

  selecionarValorProdutoNovo(id_produto: number, preco_unitario: number) {
    this.selecionarValorProduto(id_produto, preco_unitario);
  }

  selecionarValorProdutoLote(id_produto: number, preco_lote: number) {
    const produto = this.obterProdutoParaSelecaoPreco(id_produto);

    if (produto == null || !(preco_lote > 0)) { return; }

    this.fixarEstadoPreco(produto, 'lote', preco_lote, { precoBrutoSemFator: preco_lote });

    if (this.modalReferenciaTabelasProdutos != null) {
      this.modalReferenciaTabelasProdutos.close();
    }

    this.calcularImpostoProduto(id_produto, false);
    this.validarProdutoQtde(produto.id, true);
  }

  selecionarValorProdutoComFator(id_produto: number, valorJaFatorado: number) {
    const produto = this.obterProdutoParaSelecaoPreco(id_produto);

    if (produto == null || !(valorJaFatorado > 0)) { return; }

    const fator = this.fatorFinanceiroAtual(produto);
    const bruto = fator !== 0 ? (valorJaFatorado / (1 + (fator / 100))) : valorJaFatorado;

    this.fixarEstadoPreco(produto, 'tabela_normal_fator', valorJaFatorado, { precoBrutoSemFator: bruto });

    if (this.modalReferenciaTabelasProdutos != null) {
      this.modalReferenciaTabelasProdutos.close();
    }

    this.calcularImpostoProduto(id_produto, false);
    this.validarProdutoQtde(produto.id, false);
    this.calcularFatorFinanceiroProduto(id_produto, false);
  }

  private obterProdutoParaSelecaoPreco(id_produto: number): ProdutoPromocional {
    const produto = this.produtos.find(p => p.id == id_produto);

    if (produto == null) { return null; }

    if (produto.preco_tabela_travado === true) {
      this.toastr.info("", "Preço está travado (tabela utilizada). Remova a trava para alterar.");
      return null;
    }

    if (produto.id_kit_combo != null) {
      this.toastr.warning("", "Produto originário de campanha...");
      return null;
    }

    return produto;
  }

  aplicarPrecoPromocionalETRavar(id_produto: number, preco: number, produtoTabela: any, forcarFator: boolean = false) {
    const idProdutoSelecionado = id_produto != null ? id_produto : (this.produtoTabelasSelecionado != null ? this.produtoTabelasSelecionado.id : null);
    const produto = this.produtos.find(p => p.id == idProdutoSelecionado);

    if (!produto) {
      this.toastr.error("", "Produto nÃ£o encontrado para aplicar a tabela...");
      return;
    }

    if (produto.id_kit_combo != null) {
      this.toastr.warning("", "Produto originário de campanha...");
      return;
    }

    if (!preco || preco <= 0) return;

    produto.erro_valor = false;

    /* Aplicar Fator Financeiro automaticamente */
    let precoFinal: number = preco;

    // flag_naoaplicafatorpontuacaofin: não aplica fator financeiro no preço nem no cálculo de pontuação
    const naoAplicaFatorFin: boolean = (produtoTabela != null && produtoTabela.flag_naoaplicafatorpontuacaofin === true);

    if (!naoAplicaFatorFin &&
        this.prazoPagamentoSelecionado != null &&
        this.configuracao != null &&
        !this.configuracao.prazo_pagamento_antes_itenspedido &&
        this.configuracao.utiliza_fator_financeiro &&
        produto.aplica_fator_financeiro &&
        produto.qtde_lote == 0 &&
        this.prazoPagamentoSelecionado.fator_financeiro != null &&
        this.prazoPagamentoSelecionado.fator_financeiro > 0) {

      precoFinal = preco * (1 + this.prazoPagamentoSelecionado.fator_financeiro / 100);
    } else if (!naoAplicaFatorFin &&
        forcarFator &&
        this.prazoPagamentoSelecionado != null &&
        this.prazoPagamentoSelecionado.fator_financeiro != null) {
      // Força aplicação do fator financeiro mesmo que as condições acima não sejam atendidas (usado para recalcular preço com fator ao mudar o prazo de pagamento quando já tem preço promocional aplicado)
      precoFinal = preco * (1 + this.prazoPagamentoSelecionado.fator_financeiro / 100);
    }

    if (produtoTabela != null && produtoTabela.pontuacao != null) {
      produto.pontuacao = produtoTabela.pontuacao;
    }

    const idTabela: number = produtoTabela != null ? produtoTabela.idprodutotabelaespecial : null;
    const qtdeMinima: number = (produtoTabela != null && produtoTabela.qtd_minima != null && produtoTabela.qtd_minima > 0)
      ? produtoTabela.qtd_minima
      : null;
    const travar: boolean = this.configuracao != null && this.configuracao.tabelalistaoupromocao == "L";

    this.fixarEstadoPreco(produto, 'tabela_especial', precoFinal, {
      precoBrutoSemFator: preco,
      travado: travar,
      bypassDescontoMaximo: true,
      idTabelaEspecial: idTabela,
      qtdeMinimaTabela: qtdeMinima,
      label: "Preço de tabela utilizado"
    });

    this.aplicarEmTodasAsListas(produto.id, item => {
      item.ignorar_pontuacao_por_tabela = naoAplicaFatorFin;
      item.idprodutotabelaespecial = idTabela;
    });

    if (this.modalReferenciaTabelasProdutos != null) {
      this.modalReferenciaTabelasProdutos.close();
    }

    this.calcularImpostoProduto(produto.id, false);
    this.validarProdutoQtde(produto.id, true);
    this.validarProdutoValor(produto.id, true, null, false);
  }

  private calcularValorTabelaComFator(produto: ProdutoPromocional): number {
    const price = produto != null && produto.price != null ? Number(produto.price) : 0;
    if (!isFinite(price) || price <= 0) return 0;

    if (this.configuracao != null
        && !this.configuracao.prazo_pagamento_antes_itenspedido
        && this.configuracao.utiliza_fator_financeiro
        && this.prazoPagamentoSelecionado != null
        && produto != null
        && produto.aplica_fator_financeiro) {
      const f = this.prazoPagamentoSelecionado.fator_financeiro != null ? Number(this.prazoPagamentoSelecionado.fator_financeiro) : 0;
      if (isFinite(f)) return price * (1 + (f / 100));
    }

    // fallback: sem fator
    return price;
  }

  removerTravaPrecoTabela(id_produto: number) {
    const produto = this.produtos.find(p => p.id == id_produto);
    if (produto == null) { return; }

    this.limparEstadoTabelaEspecial(produto);

    const valorTabelaComFator = this.calcularValorTabelaComFator(produto);
    const bruto = produto.price != null && produto.price > 0 ? Number(produto.price) : null;

    if (valorTabelaComFator > 0) {
      this.fixarEstadoPreco(produto, 'tabela_normal_fator', valorTabelaComFator, { precoBrutoSemFator: bruto });
    } else if (bruto != null) {
      this.fixarEstadoPreco(produto, 'tabela_normal', bruto, { precoBrutoSemFator: bruto });
    }

    this.calcularFatorFinanceiroProduto(produto.id, false);
    this.calcularImpostoProduto(produto.id, false);
    this.validarProdutoQtde(produto.id, true);
  }

  ehPrecoTravado(produto: ProdutoPromocional): boolean {
    if (produto == null) { return false; }
    if (produto.estado_preco != null) { return produto.estado_preco.travado === true; }
    return produto.preco_tabela_travado === true;
  }

  obterLabelPrecoTravado(produto: ProdutoPromocional): string {
    if (produto == null) { return 'Preço de tabela utilizado'; }
    return produto.preco_tabela_travado_label || 'Preço de tabela utilizado';
  }

  debugLog(data: any): void {
  }

  marcarUltimaEdicao(id_produto: number, adicionado: boolean, campo: 'valor' | 'desconto' | 'tabela'): void {
    const lista = adicionado ? this.produtosAdicionados : this.produtos;
    const produto = lista.find(p => p.id == id_produto);
    if (produto != null) {
      produto.ultima_edicao = campo;
    }
  }

  private fatorFinanceiroAtual(produto: ProdutoPromocional): number {
    if (produto == null || !produto.aplica_fator_financeiro) { return 0; }
    if (this.configuracao == null
        || this.configuracao.prazo_pagamento_antes_itenspedido
        || !this.configuracao.utiliza_fator_financeiro) { return 0; }
    if (this.prazoPagamentoSelecionado == null || this.prazoPagamentoSelecionado.fator_financeiro == null) { return 0; }

    const fator = Number(this.prazoPagamentoSelecionado.fator_financeiro);

    return isFinite(fator) ? fator : 0;
  }

  private mapearOrigemLegado(origem: OrigemPreco): string {
    switch (origem) {
      case 'tabela_normal': return 'tabela';
      case 'tabela_normal_fator': return 'tabela_fator';
      case 'tabela_especial': return 'promocional';
      case 'lote': return 'lote';
      default: return 'manual';
    }
  }

  private aplicarEmTodasAsListas(id_produto: number, acao: (item: ProdutoPromocional) => void): void {
    const listas: ProdutoPromocional[][] = [this.produtos, this.produtosOriginal, this.produtosAdicionados];

    listas.forEach(lista => {
      const item = (lista || []).find(p => p.id == id_produto);
      if (item != null) { acao(item); }
    });
  }

  private limparEstadoTabelaEspecial(produto: ProdutoPromocional): void {
    if (produto == null) { return; }

    this.aplicarEmTodasAsListas(produto.id, item => {
      item.preco_tabela_travado = false;
      item.preco_tabela_travado_label = null;
      item.preco_tabela_base_desconto = null;
      item.preco_tabela_especial_sem_fator = null;
      item.id_tabela_especial = null;
      item.idprodutotabelaespecial = null;
      item.qtde_minima_tabela = null;
      item.ignorar_pontuacao_por_tabela = false;
      item.bypass_desconto_maximo = false;
      item.cd_tabela_preco = null;

      if (item.estado_preco != null) {
        item.estado_preco.travado = false;
        item.estado_preco.bypassDescontoMaximo = false;
        item.estado_preco.idTabelaEspecial = null;
        item.estado_preco.qtdeMinimaTabela = null;
      }
    });
  }

  private copiarEstadoPreco(destino: ProdutoPromocional, origem: ProdutoPromocional): void {
    if (destino == null || origem == null || destino === origem) { return; }

    destino.desconto_validado_por_prazo = origem.desconto_validado_por_prazo;
    destino.requer_aprovacao_prazo = origem.requer_aprovacao_prazo;
    destino.valor_validado_prazo = origem.valor_validado_prazo;
    copiarCondicoesPrazo(destino, origem);
    destino.preco_base_api = origem.preco_base_api;
    destino.estado_preco = origem.estado_preco == null ? null : { ...origem.estado_preco };
    destino.origem_preco = origem.origem_preco;
    destino.origem_base_desconto = origem.origem_base_desconto;
    destino.base_desconto_referencia = origem.base_desconto_referencia;
    destino.bypass_desconto_maximo = origem.bypass_desconto_maximo;
    destino.preco_unitario_base_manual = origem.preco_unitario_base_manual;
    destino.valor_unitario_ja_fatorado = origem.valor_unitario_ja_fatorado;
    destino.preco_tabela_travado = origem.preco_tabela_travado;
    destino.preco_tabela_travado_label = origem.preco_tabela_travado_label;
    destino.preco_tabela_base_desconto = origem.preco_tabela_base_desconto;
    destino.preco_tabela_especial_sem_fator = origem.preco_tabela_especial_sem_fator;
    destino.id_tabela_especial = origem.id_tabela_especial;
    destino.idprodutotabelaespecial = origem.idprodutotabelaespecial;
    destino.qtde_minima_tabela = origem.qtde_minima_tabela;
    destino.ignorar_pontuacao_por_tabela = origem.ignorar_pontuacao_por_tabela;
    destino.cd_tabela_preco = origem.cd_tabela_preco;
    destino.valor_tabela = origem.valor_tabela;
  }

  private sincronizarCamposLegado(produto: ProdutoPromocional, label?: string): void {
    const estado: EstadoPreco = produto.estado_preco;
    if (estado == null) { return; }

    produto.origem_preco = this.mapearOrigemLegado(estado.origem);
    produto.origem_base_desconto = produto.origem_preco;
    produto.base_desconto_referencia = estado.baseDesconto;
    produto.bypass_desconto_maximo = estado.bypassDescontoMaximo;
    produto.valor_unitario_ja_fatorado = estado.temFator;
    produto.preco_unitario_base_manual = estado.precoBrutoSemFator != null ? estado.precoBrutoSemFator : estado.baseDesconto;

    if (estado.origem === 'tabela_especial') {
      produto.preco_tabela_travado = estado.travado;
      produto.preco_tabela_travado_label = estado.travado ? (label != null ? label : 'Preço de tabela utilizado') : null;
      produto.preco_tabela_base_desconto = estado.baseDesconto;
      produto.preco_tabela_especial_sem_fator = estado.precoBrutoSemFator;
      produto.id_tabela_especial = estado.idTabelaEspecial;
      produto.qtde_minima_tabela = estado.qtdeMinimaTabela;

      if (estado.travado) { produto.cd_tabela_preco = estado.idTabelaEspecial; }
    }

    if (estado.origem !== 'manual') {
      produto.valor_tabela = estado.precoBrutoSemFator != null ? estado.precoBrutoSemFator : estado.baseDesconto;
    } else if (!(produto.valor_tabela != null && produto.valor_tabela > 0)) {
      produto.valor_tabela = produto.preco_base_api != null && produto.preco_base_api > 0
        ? Number(produto.preco_base_api)
        : (produto.price != null && produto.price > 0 ? Number(produto.price) : 0);
    }
  }

  private fixarEstadoPreco(produto: ProdutoPromocional, origem: OrigemPreco, precoFinal: number, opts?: OpcoesEstadoPreco): void {
    if (produto == null) { return; }

    const preco = Number(precoFinal);
    if (!isFinite(preco) || preco <= 0) { return; }

    const opcoes: OpcoesEstadoPreco = opts != null ? opts : {};
    const ehEspecial: boolean = origem === 'tabela_especial';

    if (!ehEspecial) { this.limparEstadoTabelaEspecial(produto); }

    const valorFinal: number = this.formatacaoService.quatroCasasDecimais(preco);
    const bruto: number = opcoes.precoBrutoSemFator != null
      && isFinite(Number(opcoes.precoBrutoSemFator))
      && Number(opcoes.precoBrutoSemFator) > 0
      ? this.formatacaoService.quatroCasasDecimais(Number(opcoes.precoBrutoSemFator))
      : null;
    const versaoAnterior: number = produto.estado_preco != null ? produto.estado_preco.versao : 0;

    produto.estado_preco = {
      origem: origem,
      precoBrutoSemFator: bruto,
      precoFinal: valorFinal,
      baseDesconto: valorFinal,
      temFator: bruto != null && Math.abs(bruto - valorFinal) > 0.0001,
      travado: ehEspecial && opcoes.travado === true,
      bypassDescontoMaximo: ehEspecial && opcoes.bypassDescontoMaximo === true,
      idTabelaEspecial: ehEspecial && opcoes.idTabelaEspecial != null ? opcoes.idTabelaEspecial : null,
      qtdeMinimaTabela: ehEspecial && opcoes.qtdeMinimaTabela != null && opcoes.qtdeMinimaTabela > 0 ? opcoes.qtdeMinimaTabela : null,
      versao: versaoAnterior + 1
    };

    produto.valor = valorFinal;
    produto.erro_valor = false;
    produto.porcentagem_desconto_temporaria = null;
    produto.desconto_digitado = null;
    produto.editando_desconto = false;
    produto.ultima_edicao = origem === 'manual' ? 'valor' : 'tabela';
    produto.valor_ao_focar = valorFinal;

    this.sincronizarCamposLegado(produto, opcoes.label);

    this.aplicarEmTodasAsListas(produto.id, item => this.copiarEstadoPreco(item, produto));
  }

  private lerBaseDesconto(produto: ProdutoPromocional): number {
    if (produto == null) { return 0; }

    const estado: EstadoPreco = produto.estado_preco;
    if (estado != null && isFinite(estado.baseDesconto) && estado.baseDesconto > 0) {
      return estado.baseDesconto;
    }

    const valor: number = produto.valor != null ? Number(produto.valor) : 0;

    return isFinite(valor) && valor > 0 ? valor : 0;
  }

  private referenciaCatalogoBruta(produto: ProdutoPromocional): number {
    if (produto == null) { return 0; }
    if (produto.preco_base_api != null && produto.preco_base_api > 0) { return Number(produto.preco_base_api); }
    if (produto.valor_tabela != null && produto.valor_tabela > 0) { return Number(produto.valor_tabela); }
    if (produto.price != null && produto.price > 0) { return Number(produto.price); }
    return 0;
  }

  private garantirEstadoPreco(produto: ProdutoPromocional): void {
    if (produto == null || produto.estado_preco != null) { return; }

    /* Item legado travado (pedido existente que usou tabela especial): o grid
     * carrega preco_tabela_travado/valor_tabela/cd_tabela_preco, mas NÃO monta o
     * estado_preco. Sem esta reconstrução, o ramo "manual" abaixo o marcaria como
     * travado=false e os campos (valor/desconto) deixariam de travar no modal.
     * Reconstrói como tabela_especial/travado preservando os valores atuais:
     * valor = preço vendido e valor_tabela = base do saldo (conta corrente). */
    const travadoLegado: boolean = produto.preco_tabela_travado === true
      || produto.origem_preco === 'promocional';

    if (travadoLegado) {
      const valorTravado: number = produto.valor != null ? Number(produto.valor) : 0;

      if (isFinite(valorTravado) && valorTravado > 0) {
        const finalT: number = this.formatacaoService.quatroCasasDecimais(valorTravado);
        const idTabela: number = produto.id_tabela_especial != null
          ? produto.id_tabela_especial
          : (produto.cd_tabela_preco != null ? produto.cd_tabela_preco : null);

        produto.estado_preco = {
          origem: 'tabela_especial',
          precoBrutoSemFator: finalT,
          precoFinal: finalT,
          baseDesconto: finalT,
          temFator: false,
          travado: true,
          bypassDescontoMaximo: true,
          idTabelaEspecial: idTabela,
          qtdeMinimaTabela: produto.qtde_minima_tabela != null ? produto.qtde_minima_tabela : null,
          versao: 1
        };

        /* NÃO chamar sincronizarCamposLegado aqui: os campos legados já vieram
         * corretos do grid e o sync sobrescreveria valor_tabela (base do saldo)
         * com precoBrutoSemFator. Apenas reforça as flags legadas de trava. */
        produto.origem_preco = 'promocional';
        produto.bypass_desconto_maximo = true;
        produto.preco_tabela_travado = true;

        this.aplicarEmTodasAsListas(produto.id, item => this.copiarEstadoPreco(item, produto));
        return;
      }
    }

    const valor: number = produto.valor != null ? Number(produto.valor) : 0;
    const percentual: number = produto.porcentagem_desconto_temporaria;
    const temPercentual: boolean = percentual != null && isFinite(percentual) && percentual > 0 && percentual < 100;

    let bruto: number;
    let comFator: number;

    if (temPercentual && valor > 0) {
      comFator = valor / (1 - (percentual / 100));
      bruto = comFator;
    } else {
      bruto = this.referenciaCatalogoBruta(produto);
      const aplicaFator: boolean = this.fatorFinanceiroAtual(produto) !== 0;
      comFator = this.calcularValorComFator(bruto, aplicaFator);
      if (comFator <= 0) { comFator = valor; bruto = valor; }
    }

    if (!isFinite(comFator) || comFator <= 0) { return; }

    const baseFinal: number = this.formatacaoService.quatroCasasDecimais(comFator);
    const brutoFinal: number = this.formatacaoService.quatroCasasDecimais(bruto > 0 ? bruto : comFator);

    produto.estado_preco = {
      origem: 'manual',
      precoBrutoSemFator: brutoFinal,
      precoFinal: baseFinal,
      baseDesconto: baseFinal,
      temFator: Math.abs(brutoFinal - baseFinal) > 0.0001,
      travado: false,
      bypassDescontoMaximo: false,
      idTabelaEspecial: null,
      qtdeMinimaTabela: null,
      versao: 1
    };

    this.sincronizarCamposLegado(produto);
    this.aplicarEmTodasAsListas(produto.id, item => this.copiarEstadoPreco(item, produto));
  }

  private aplicarPercentualDesconto(produto: ProdutoPromocional, percentual: number): void {
    if (produto == null) { return; }

    this.garantirEstadoPreco(produto);

    const base: number = this.lerBaseDesconto(produto);
    if (base <= 0) { return; }

    const perc: number = Number(percentual);

    if (!isFinite(perc) || perc <= 0 || perc > 100) {
      produto.valor = this.formatacaoService.quatroCasasDecimais(base);
      produto.porcentagem_desconto_temporaria = null;
      produto.desconto_digitado = null;
      return;
    }

    produto.porcentagem_desconto_temporaria = perc;
    produto.desconto_digitado = perc;
    produto.valor = this.formatacaoService.quatroCasasDecimais(base * (1 - (perc / 100)));
  }

  private reajustarBasePorFator(produto: ProdutoPromocional, baseSemFator: number, baseComFator: number, temFator: boolean): void {
    const estado: EstadoPreco = produto != null ? produto.estado_preco : null;
    if (estado == null) { return; }

    const nova: number = this.formatacaoService.quatroCasasDecimais(baseComFator);
    if (!isFinite(nova) || nova <= 0) { return; }

    estado.precoBrutoSemFator = this.formatacaoService.quatroCasasDecimais(baseSemFator);
    estado.precoFinal = nova;
    estado.baseDesconto = nova;
    estado.temFator = temFator;

    produto.base_desconto_referencia = nova;
    produto.valor_unitario_ja_fatorado = temFator;
  }

  private obterBaseValidacaoDescontoMaximo(produto: ProdutoPromocional): number {
    if (produto == null) { return 0; }

    const catalogoSemFator: number = (produto.valor_tabela != null && produto.valor_tabela > 0)
      ? Number(produto.valor_tabela)
      : (produto.price != null ? Number(produto.price) : 0);

    if (!isFinite(catalogoSemFator) || catalogoSemFator <= 0) { return 0; }

    return this.calcularValorComFator(catalogoSemFator, this.fatorFinanceiroAtual(produto) !== 0);
  }

  private obterTetoPrecoTabela(produto: ProdutoPromocional): number {
    if (produto == null) { return 0; }

    if (produto.preco_base_api != null && produto.preco_base_api > 0) { return Number(produto.preco_base_api); }
    if (produto.valor_tabela != null && produto.valor_tabela > 0) { return Number(produto.valor_tabela); }

    return produto.price != null ? Number(produto.price) : 0;
  }

  iniciarEdicaoValorUnitario(id_produto: number): void {
    const produto = this.produtos.find(p => p.id == id_produto);
    if (produto == null) { return; }

    produto.ultima_edicao = 'valor';
    produto.editando_desconto = false;
    produto.valor_ao_focar = produto.valor != null ? Number(produto.valor) : null;
  }

  aoDigitarValorUnitario(id_produto: number): void {
    const produto = this.produtos.find(p => p.id == id_produto);
    if (produto == null) { return; }

    produto.ultima_edicao = 'valor';

    this.validarDescontoMaximoAoDigitar(id_produto);
  }

  private fixarPrecoManualSeDigitado(produto: ProdutoPromocional): void {
    if (produto == null || produto.ultima_edicao !== 'valor') { return; }

    const valor: number = produto.valor != null ? Number(produto.valor) : 0;
    if (!isFinite(valor) || valor <= 0) { return; }

    this.garantirEstadoPreco(produto);

    const estado: EstadoPreco = produto.estado_preco;
    if (estado == null || estado.baseDesconto <= 0) { return; }

    this.atualizarDescontoAPartirDoValor(produto);
    this.aplicarEmTodasAsListas(produto.id, item => this.copiarEstadoPreco(item, produto));
  }

  iniciarEdicaoDesconto(id_produto: number): void {
    const produto = this.produtos.find(p => p.id == id_produto);
    if (produto == null) { return; }

    produto.ultima_edicao = 'desconto';
    produto.editando_desconto = true;

    this.garantirEstadoPreco(produto);

    const atual = produto.porcentagem_desconto_temporaria;
    produto.desconto_digitado = (atual != null ? Number(atual) : null);
    produto.perc_ao_focar = (atual != null ? Number(atual) : null);
    produto.valor_ao_focar = produto.valor != null ? Number(produto.valor) : null;
  }

  finalizarEdicaoDesconto(id_produto: number, event?: any): void {
    const produto = this.produtos.find(p => p.id == id_produto);
    if (produto == null) { return; }

    produto.editando_desconto = false;

    const percAtual: number = produto.porcentagem_desconto_temporaria != null ? Number(produto.porcentagem_desconto_temporaria) : null;
    const percFoco: number = produto.perc_ao_focar != null ? Number(produto.perc_ao_focar) : null;
    const percMudou: boolean = !((percAtual == null && percFoco == null)
      || (percAtual != null && percFoco != null && Math.abs(percAtual - percFoco) <= 0.0001));

    if (percMudou) {
      this.aplicarPercentualDesconto(produto, produto.porcentagem_desconto_temporaria);
    } else if (produto.valor_ao_focar != null && produto.valor_ao_focar > 0) {
      produto.valor = this.formatacaoService.quatroCasasDecimais(produto.valor_ao_focar);
    }

    this.validarProdutoValor(id_produto, true, event, false);
  }

  /** Recalcula a % de desconto exibida quando o usuário altera o Unitário manualmente. */
  private atualizarDescontoAPartirDoValor(produto: ProdutoPromocional): void {
    if (produto == null || produto.editando_desconto === true) { return; }

    const base: number = this.lerBaseDesconto(produto);
    if (base <= 0 || produto.valor == null || produto.valor <= 0) { return; }

    const perc: number = (1 - (Number(produto.valor) / base)) * 100;
    const perc4: number = Math.round(perc * 10000) / 10000;

    produto.desconto_digitado = perc4 > 0 ? perc4 : null;
    produto.porcentagem_desconto_temporaria = perc4 > 0 ? perc4 : null;
  }

  validarDescontoMaximoAoDigitar(id_produto: number): void {
    const produto = this.produtos.find(p => p.id === id_produto);
    if (produto == null) { return; }

    produto.erro_valor = false;

    if (produto.valor == null || produto.valor <= 0) { return; }

    const porcentagemDescontoMaximo: number = this.obterDescontoMaximoProduto(produto);
    if (porcentagemDescontoMaximo == null) { return; }

    const base: number = this.obterBaseValidacaoDescontoMaximo(produto);
    if (base <= 0) { return; }

    const valorMinimo: number = base * (1 - (porcentagemDescontoMaximo / 100));

    if (produto.valor < valorMinimo - 0.001) {
      produto.erro_valor = true;
    }
  }

  // ────────────────────────────────────────────────────────────────────────────

  totalizarSaldoGerado() {
    // Parcial

    let saldoParcial: number = this.produtosOriginal.reduce((sum, current) => (sum + current.saldo_gerado), 0);

    this.saldoGeradoValorParcial = parseFloat(saldoParcial.toFixed(2));

    // Final

    let saldoFinal: number = this.produtosAdicionados.reduce((sum, current) => (sum + current.saldo_gerado), 0);

    this.saldoGeradoValorFinal = parseFloat(saldoFinal.toFixed(2));
  }

  validarColunas(produto: ProdutoPromocional): number {
    let colunas: number = 0;

    if (produto.estoque != null || produto.estoque_lote != null) {
      if (produto.qtde_lote == 0 || (produto.qtde_lote > 0 && produto.id_lote != null)) {
        colunas = 1;
      }
    }

    if (produto.fracionado && produto.estoque_fracionado != null && produto.estoque != null) {
      colunas++;
    }

    if (produto.qtde_lote > 0 && produto.id_lote != null && produto.validade_lote != null) {
      colunas++
    }

    if ((produto.qtde_lote > 0 && produto.id_lote != null)) {
      colunas++;
    }

    return colunas;
  }

  /* Validação (Adicionar Itens (Campanha)) */

  validarErrosCampanha(): boolean {
    if (this.produtoCampanhaSelecionado != null) {
      let qtdeErros = this.produtoCampanhaSelecionado.produtos_vinculados.filter(produtoAdicionado => produtoAdicionado.erro_qtde).length;

      let produtosComErro: boolean = false;
      let qtdeMinimaInvalida: boolean = false;

      if (qtdeErros > 0) {
        if (qtdeErros == 1) {
          this.toastr.error("", "Produto com erro(s)!");
        } else {
          this.toastr.error("", "Existem produtos com erro(s)!");
        }

        produtosComErro = true;
      }

      if (this.produtoCampanhaSelecionado.qtde_minima_atual < this.produtoCampanhaSelecionado.qtde_minima) {
        this.toastr.error("", "Qtde Mínima de Itens inválida!");

        qtdeMinimaInvalida = true;
      }

      if (this.produtoCampanhaSelecionado.qtde == null) {
        this.toastr.error("", "Qtde inválida!");

        this.produtoCampanhaSelecionado.erro_qtde = true;
      } else {
        if (this.configuracao != null && this.configuracao.permitir_produtos_sem_estoque == "N") {
          let existeProdutoAcimaDoEstoque: boolean = false;

          this.produtoCampanhaSelecionado.produtos_vinculados.forEach((item) => {
            if (!existeProdutoAcimaDoEstoque) {
              if (!item.bonificacao) {
                let qtdeMultiplicada: number = item.qtde * this.produtoCampanhaSelecionado.qtde;

                if (item.bonificacao_selecionada) {
                  qtdeMultiplicada = qtdeMultiplicada + this.produtoCampanhaSelecionado.qtde_bonificacao_multiplicavel;
                }

                if (qtdeMultiplicada > item.estoque) {
                  this.toastr.error("", "Qtde de produto(s) acima do estoque...");

                  this.produtoCampanhaSelecionado.erro_qtde = true;

                  existeProdutoAcimaDoEstoque = true;
                }
              }
            }
          });
        }
      }

      if (this.produtoCampanhaSelecionado.bonificacao_selecionavel) {
        /* Bonificação (Selecionável) */

        let produtoBonificado = this.produtoCampanhaSelecionado.produtos_vinculados.find(produtosVinculados => produtosVinculados.bonificacao_selecionada);

        if (produtoBonificado == null) {
          this.toastr.error("", "Bonificação inválida!");

          this.bonificacaoInvalida = true;
        } else {
          this.bonificacaoInvalida = false;
        }
      }

      if (produtosComErro || qtdeMinimaInvalida || this.produtoCampanhaSelecionado.erro_qtde || this.bonificacaoInvalida) {
        return false;
      } else {
        return true;
      }
    } else {
      return false;
    }
  }

  validarCampanhaProdutoQtde(id_produto: number) {
    if (this.produtoCampanhaSelecionado != null) {
      let produtoVinculado = this.produtoCampanhaSelecionado.produtos_vinculados.find(produtosVinculados => produtosVinculados.id == id_produto);

      if (produtoVinculado != null) {
        if (produtoVinculado.qtde_minima > 0) {
          if (produtoVinculado.qtde == null || produtoVinculado.qtde <= 0 || produtoVinculado.qtde < produtoVinculado.qtde_minima) {
            this.toastr.error("", "Qtde abaixo da qtde mínima...");

            produtoVinculado.erro_qtde = true;

            this.validarQtdeMinimaCombo();

            return;
          } else {
            produtoVinculado.erro_qtde = false;
          }
        } else {
          produtoVinculado.erro_qtde = false;
        }

        if (produtoVinculado.qtde != 0 && produtoVinculado.qtde != null) {
          if (this.configuracao != null && !this.configuracao.flag_permite_produtos_acima_do_estoque) {
            let qtdeFinal: number = produtoVinculado.qtde;

            if (produtoVinculado.bonificacao_selecionada) {
              qtdeFinal = qtdeFinal + this.produtoCampanhaSelecionado.qtde_bonificacao_multiplicavel;
            }

            let qtdeEstoque: number = 0;

            if (produtoVinculado.qtde_lote == 0) {
              qtdeEstoque = produtoVinculado.estoque
            } else {
              qtdeEstoque = produtoVinculado.estoque_lote;
            }

            if (qtdeFinal > qtdeEstoque) {
              this.toastr.error("", "Qtde acima do estoque...");

              produtoVinculado.erro_qtde = true;

              this.validarQtdeMinimaCombo();

              return;
            } else {
              produtoVinculado.erro_qtde = false;
            }
          }

          if (produtoVinculado.multiplo != null && produtoVinculado.multiplo != 0) {
            if (produtoVinculado.qtde % produtoVinculado.multiplo != 0) {
              this.toastr.error("", "Qtde somente múltipla de " + produtoVinculado.multiplo + "...");

              produtoVinculado.erro_qtde = true;

              this.validarQtdeMinimaCombo();

              return;
            }
          } else {
            produtoVinculado.erro_qtde = false;
          }

          if (produtoVinculado.qtd_maxima_venda != null && produtoVinculado.qtd_maxima_venda != 0) {
            if (produtoVinculado.qtde > produtoVinculado.qtd_maxima_venda) {
              this.toastr.error("", "Qtde acima da permitida (" + produtoVinculado.qtd_maxima_venda + ")...");

              produtoVinculado.erro_qtde = true;

              this.validarQtdeMinimaCombo();

              return;
            }
          } else {
            produtoVinculado.erro_qtde = false;
          }
        }

        this.validarQtdeMinimaCombo();

        /* Bonificação */

        this.localizarProdutoBonificado();
        this.definirQtdeBonificacaoMultiplicavel(false);

        /* Totalizar (Produtos Vinculados) */

        if (this.produtoCampanhaSelecionado.grupo_estoque == this.combo) {
          let valorTotal: number = produtoVinculado.valor * produtoVinculado.qtde;

          produtoVinculado.valor_total = parseFloat(valorTotal.toFixed(2));

          this.produtoCampanhaSelecionado.valor_total_produtos_vinculados = this.produtoCampanhaSelecionado.produtos_vinculados.reduce((sum, current) => (sum + current.valor_total), 0);
        }

        this.totalizarProdutoCampanhaSelecionado();
        this.calcularFatorFinanceiroCampanhaProduto(id_produto);
      }
    }
  }

  validarCampanhaQtde() {
    if (this.produtoCampanhaSelecionado != null) {
      if (this.produtoCampanhaSelecionado.qtde <= 0) {
        this.produtoCampanhaSelecionado.qtde = null;

        return;
      } else {
        this.produtoCampanhaSelecionado.erro_qtde = false;
      }

      if (this.configuracao != null && this.configuracao.permitir_produtos_sem_estoque == "N") {
        let existeProdutoAcimaDoEstoque: boolean = false;

        this.produtoCampanhaSelecionado.produtos_vinculados.forEach((item) => {
          if (!existeProdutoAcimaDoEstoque) {
            if (!item.bonificacao) {
              let qtdeMultiplicada: number = item.qtde * this.produtoCampanhaSelecionado.qtde;

              if (item.bonificacao_selecionada) {
                qtdeMultiplicada = qtdeMultiplicada + this.produtoCampanhaSelecionado.qtde_bonificacao_multiplicavel;
              }

              if (qtdeMultiplicada > item.estoque) {
                this.toastr.error("", "Qtde de produto(s) acima do estoque...");

                this.produtoCampanhaSelecionado.erro_qtde = true;

                existeProdutoAcimaDoEstoque = true;
              }
            }
          }
        });
      }

      if (this.produtoCampanhaSelecionado.qtde_minima_atual < this.produtoCampanhaSelecionado.qtde_minima) {
        if (this.produtoCampanhaSelecionado.qtde > 0) {
          this.toastr.error("", "Qtde Mínima de Itens inválida!");

          this.produtoCampanhaSelecionado.qtde = null;

          /* Bonificação */

          this.definirQtdeBonificacaoMultiplicavel(true);

          return;
        }
      } else {
        /* Bonificação */

        this.definirQtdeBonificacaoMultiplicavel(true);
      }

      /* Totalizar (Produtos Vinculados) */

      this.totalizarProdutoCampanhaSelecionado();
      this.calcularFatorFinanceiroCampanha();
    }
  }

  validarCampanhaQtdeGeral() {
    let retorno = new Promise<void>((resolver) => {
      if (this.produtoCampanhaSelecionado != null) {
        this.produtoCampanhaSelecionado.produtos_vinculados.forEach((item) => {
          if (item.bonificacao) {
            /* Bonificação */

            if (this.configuracao != null && !this.configuracao.flag_permite_produtos_acima_do_estoque) {
              if (this.produtoCampanhaSelecionado.bonificacao_selecionavel) {
                /* Bonificação (Selecionável) */

                if (item.qtde > item.estoque) {
                  item.exibir = false;
                } else {
                  item.exibir = true;
                }
              }
            }
          } else {
            if (this.configuracao != null && !this.configuracao.flag_permite_produtos_acima_do_estoque) {
              let qtdeFinal: number = item.qtde;

              if (item.bonificacao_selecionada) {
                qtdeFinal = qtdeFinal + this.produtoCampanhaSelecionado.qtde_bonificacao_multiplicavel;
              }

              let qtdeEstoque: number = 0;

              if (item.qtde_lote == 0) {
                qtdeEstoque = item.estoque
              } else {
                qtdeEstoque = item.estoque_lote;
              }

              if (qtdeFinal > qtdeEstoque) {
                this.toastr.error("", "Qtde acima do estoque...");

                item.erro_qtde = true;

                return;
              } else {
                item.erro_qtde = false;
              }
            }

            if (item.multiplo != null && item.multiplo != 0) {
              if (item.qtde % item.multiplo != 0) {
                this.toastr.error("", "Qtde somente múltipla de " + item.multiplo + "...");

                item.erro_qtde = true;

                return;
              } else {
                item.erro_qtde = false;
              }
            }

            if (item.qtd_maxima_venda != null && item.qtd_maxima_venda != 0) {
              if (item.qtde > item.qtd_maxima_venda) {
                this.toastr.error("", "Qtde acima da permitida (" + item.qtd_maxima_venda + ")...");

                item.erro_qtde = true;

                return;
              } else {
                item.erro_qtde = false;
              }
            }

            item.erro_qtde = false;
          }
        });

        this.validarQtdeMinimaCombo();

        return resolver();
      }
    });

    return retorno;
  }

  /* Validação/Verificação (Adicionar Itens (Produto)) */

  agruparProdutosComErro() {
    let retorno = new Promise<void>((resolver) => {
      this.produtosComErro = [];

      this.produtosOriginal.filter(produtoOriginal => produtoOriginal.erro_lote || produtoOriginal.erro_qtde || produtoOriginal.erro_valor).forEach((item) => {
        item.exibir = true;
        item.expandido = true;

        let produtoComErro: ProdutoPromocional = { ...item };

        this.produtosComErro.push(produtoComErro);
      });

      return resolver();
    });

    return retorno;
  }

  organizarProdutosAdicionados() {
    if (this.validarErrosProdutosAdicionados(false) == 0) {
      /* Total */

      this.totalizarProdutosAdicionados();

      /* Prazo de Pagamento */

      this.organizarPrazoPagamento(true, false);

      /* Simulação (Resultado) */

      this.calcularSimulacaoResultado();

      /* Saldo */

      this.totalizarSaldoGerado();
    } else {
      /* Total */

      this.valorParcialProdutosAdicionados = 0;
      this.valorTotalProdutosAdicionados = 0;
      this.valorTotalProdutosAdicionadosFatorFinanceiro = 0;
      this.valorTotalProdutosAdicionadosImposto = 0;
      this.valorTotalPontuacaoProdutosAdicionados = 0;

      /* Simulação (Resultado) */

      this.porcentagemMarkupPedido = 0;
      this.simulacaoResultado = "0%";

      /* Saldo */

      this.saldoGeradoValorParcial = 0;
      this.saldoGeradoValorFinal = 0
    }
  }

  validarErrosProduto(cancelando: boolean) {
    let retorno = new Promise<void>((resolver) => {
      const repassarDadosProduto = this.repassarDadosProduto(cancelando);

      repassarDadosProduto.then(() => {
        const agruparProdutosComErro = this.agruparProdutosComErro();

        agruparProdutosComErro.then(() => {
          if (this.produtosComErro.length > 0) {
            const identificacaoErro: string = this.produtosComErro
              .map(p => p.name || p.codigo)
              .join(', ');

            if (this.produtosComErro.length == 1) {
              this.toastr.error("", "Item com erro(s): " + identificacaoErro);
            } else {
              this.toastr.error("", "Itens com erro(s): " + identificacaoErro);
            }

            this.produtos = JSON.parse(JSON.stringify(this.produtosComErro));

            this.enviadoProduto = true;
          } else {
            this.produtosOriginal.filter(produto => ((produto.qtde != 0 && produto.qtde != null) || (produto.qtde_bonificada != 0 && produto.qtde_bonificada != null)) && (produto.valor == 0 || produto.valor == null)).forEach((item) => {
              item.qtde = null;
              item.qtde_bonificada = null;
            });

            this.produtosOriginal.filter(produto => (produto.qtde == 0 || produto.qtde == null) && (produto.qtde_bonificada == 0 || produto.qtde_bonificada == null) && (produto.valor != 0 && produto.valor != null)).forEach((item) => {
              item.valor = null;
            });
          }

          this.totalizarSaldoGerado();

          return resolver();
        });
      });
    });

    return retorno;
  }

  validarErrosProdutosAdicionados(alerta: boolean): number {
    let produtosAdicionadosComErro: number = this.produtosAdicionados.filter(produtoAdicionado => produtoAdicionado.erro_valor).length;

    if (produtosAdicionadosComErro > 0) {
      if (alerta) {
        const adicionadosComErro = this.produtosAdicionados.filter(p => p.erro_valor);

        adicionadosComErro.forEach((p) => {
          p.exibir = true;
          p.expandido = true;
        });

        const identificacaoAdicionados: string = adicionadosComErro
          .map(p => p.name || p.codigo)
          .join(', ');

        if (produtosAdicionadosComErro == 1) {
          this.toastr.error("", "Item com erro(s): " + identificacaoAdicionados);
        } else {
          this.toastr.error("", "Itens com erro(s): " + identificacaoAdicionados);
        }
      }
    }

    return produtosAdicionadosComErro;
  }

  validarProdutoFator(id_produto: number, foco?: boolean) {
    let produto: ProdutoPromocional = this.produtos.find(produto => produto.id == id_produto);

    if (produto != null) {
      if (foco) {
        this.calcularFatorFinanceiroProduto(produto.id, false);
      }
    }
  }

  validarProdutoQtde(id_produto: number, foco: boolean, event?: any) {
    /* Qtde */

    let produto: ProdutoPromocional = this.produtos.find(produto => produto.id == id_produto);

    if (produto != null) {
      if (produto.qtde_bonificada == null && produto.qtde_bonificada <= 0) {
        if (produto.qtde != null && produto.qtde <= 0) {
          produto.erro_qtde = true;
        } else if ((produto.qtde == 0 || produto.qtde == null) && (produto.qtde_lote > 0 && produto.id_lote != null)) {
          produto.erro_qtde = true;
        } else if ((produto.qtde == 0 || produto.qtde == null) && (produto.valor != 0 && produto.valor != null)) {
          produto.erro_qtde = true;
        } else if ((produto.qtde != 0 && produto.qtde != null) && (produto.valor == 0 || produto.valor == null)) {
          produto.erro_qtde = false;
          produto.erro_valor = true;
        } else if ((produto.qtde != 0 && produto.qtde != null) && (produto.valor != 0 && produto.valor != null)) {
          produto.erro_qtde = false;
          produto.erro_valor = false;
        } else {
          let produtoAdicionado = this.produtosAdicionados.find(produtoAdicionado => produtoAdicionado.id == id_produto);

          if (produtoAdicionado != null) {
            if (produto.qtde == 0 || produto.qtde == null) {
              produto.erro_qtde = true;
            } else {
              produto.erro_qtde = false;
            }

            if (produto.valor == 0 || produto.valor == null) {
              produto.erro_valor = true;
            } else {
              produto.erro_valor = false;
            }
          } else {
            produto.erro_qtde = false;
            produto.erro_valor = false;
          }
        }
      } else {
        /* Qtde (Bonificada) */

        produto.erro_qtde = false;

        if ((produto.valor != 0 && produto.valor != null)) {
          produto.erro_valor = false;
        } else {
          produto.erro_valor = true;
        }
      }

      // Mínimo de tabela especial: marcar erro em tempo real (durante digitação)
      const qtdeMinTabelaRT: number = (produto as any).qtde_minima_tabela;
      if (qtdeMinTabelaRT != null && qtdeMinTabelaRT > 0 && produto.qtde != null && produto.qtde < qtdeMinTabelaRT) {
        produto.erro_qtde = true;
      }

      if (foco) {
        this.atualizarDescontoAPartirDoValor(produto);
        this.calcularImpostoProduto(produto.id, false);
        this.verificarProdutoQtde(produto);
        this.verificarProdutoValor(produto, event, false);
      }
    }
  }

  validarProdutoValor(id_produto: number, foco?: boolean, event?: any, adicionado?: boolean) {
    /* Valor */

    let produto: ProdutoPromocional = null;

    if (adicionado) {
      produto = this.produtosAdicionados.find(produtoAdicionado => produtoAdicionado.id == id_produto);
    } else {
      produto = this.produtos.find(produto => produto.id == id_produto);
    }

    // Hardening: normalizar produto.valor em caso de string ou inválido
    if (produto != null && produto.valor != null && typeof produto.valor === 'string') {
      const v = Number(String(produto.valor).replace(',', '.'));
      produto.valor = isFinite(v) ? v : null;
    }

    if (produto != null) {
      if (produto.qtde_bonificada == null && produto.qtde_bonificada <= 0) {
        if (produto.valor != null && produto.valor <= 0) {
          produto.erro_valor = true;
        } else if ((produto.valor == 0 || produto.valor == null) && (produto.qtde_lote > 0 && produto.id_lote != null)) {
          produto.erro_valor = true;
        } else if ((produto.qtde != 0 && produto.qtde != null) && (produto.valor == 0 || produto.valor == null)) {
          produto.erro_valor = true;
        } else if ((produto.qtde == 0 || produto.qtde == null) && (produto.valor != 0 && produto.valor != null)) {
          produto.erro_qtde = true;
          produto.erro_valor = false;
        } else if ((produto.qtde != 0 && produto.qtde != null) && (produto.valor != 0 && produto.valor != null)) {
          produto.erro_qtde = false;
          produto.erro_valor = false;
        } else {
          let produtoAdicionado = this.produtosAdicionados.find(produtoAdicionado => produtoAdicionado.id == id_produto);

          if (produtoAdicionado != null) {
            if (produto.qtde == 0 || produto.qtde == null) {
              produto.erro_qtde = true;
            } else {
              produto.erro_qtde = false;
            }

            if (produto.valor == 0 || produto.valor == null) {
              produto.erro_valor = true;
            } else {
              produto.erro_valor = false;
            }
          } else {
            produto.erro_qtde = false;
            produto.erro_valor = false;
          }
        }
      } else {
        /* Qtde (Bonificada) */

        produto.erro_qtde = false;

        if ((produto.valor != 0 && produto.valor != null)) {
          produto.erro_valor = false;
        } else {
          produto.erro_valor = true;
        }
      }

      if (foco) {
        if (!adicionado) {
          this.fixarPrecoManualSeDigitado(produto);
          this.atualizarDescontoAPartirDoValor(produto);
        }
        this.calcularImpostoProduto(produto.id, adicionado);
        this.verificarProdutoQtde(produto);
        this.verificarProdutoValor(produto, event, adicionado);
      }
    }
  }

  validarProdutoValorNovo(id_produto: number, foco?: boolean, event?: any, adicionado?: boolean) {
    this.validarProdutoValor(id_produto, foco, event, adicionado);
  }

  verificarProdutoQtde(produto: ProdutoPromocional) {
    if (produto.qtde != 0 && produto.qtde != null) {
      // Quantidade mínima da tabela especial
      const qtdeMinTabela: number = (produto as any).qtde_minima_tabela;
      if (qtdeMinTabela != null && qtdeMinTabela > 0 && produto.qtde < qtdeMinTabela) {
        this.toastr.error("", "Qtde mínima da tabela: " + qtdeMinTabela + "...");
        produto.erro_qtde = true;
        return;
      }

      if (this.configuracao != null && !this.configuracao.flag_permite_produtos_acima_do_estoque) {
        let qtdeEstoque: number = 0;

        if (produto.qtde_lote == 0) {
          qtdeEstoque = produto.estoque
        } else {
          qtdeEstoque = produto.estoque_lote;
        }

        if (produto.qtde > qtdeEstoque) {
          this.toastr.error("", "Qtde acima do estoque...");

          produto.erro_qtde = true;

          return;
        }
      }

      if ((this.tiposPedidoSelecionado != null && this.tiposPedidoSelecionado.flag_considerar_pedido_como_venda) && (produto.multiplo != null && produto.multiplo != 0)) {
        if (produto.qtde % produto.multiplo != 0) {
          this.toastr.error("", "Qtde somente múltipla de " + produto.multiplo + "...");

          produto.erro_qtde = true;

          return;
        }
      }

      if (produto.qtd_maxima_venda != null && produto.qtd_maxima_venda != 0) {
        if (produto.qtde > produto.qtd_maxima_venda) {
          this.toastr.error("", "Qtde acima da permitida (" + produto.qtd_maxima_venda + ")...");

          produto.erro_qtde = true;

          return;
        }
      }
    }
  }

  private ehPrecoPromocionalTravado(produto: ProdutoPromocional): boolean {
    if (produto == null) { return false; }

    if (produto.estado_preco != null) {
      return produto.estado_preco.origem === 'tabela_especial'
        && (produto.estado_preco.travado === true || produto.estado_preco.bypassDescontoMaximo === true);
    }

    return produto.preco_tabela_travado === true
      || produto.origem_preco === 'promocional'
      || produto.bypass_desconto_maximo === true;
  }

  /**
   * Retorna true quando o desconto máximo DEVE ser validado.
   * Retorna false quando o produto veio de tabela especial (bypass) ou está travado.
   */
  private deveValidarDescontoMaximo(produto: ProdutoPromocional): boolean {
    if (produto == null) { return false; }

    if (produto.estado_preco != null) { return !produto.estado_preco.bypassDescontoMaximo && !produto.estado_preco.travado; }

    if (produto.bypass_desconto_maximo === true) { return false; }

    return !this.ehPrecoPromocionalTravado(produto);
  }

  /**
   * Retorna o desconto máximo efetivo do produto (considerando cc_flex).
   * Retorna null quando não há limite configurado.
   */
  private obterDescontoMaximoProduto(produto: ProdutoPromocional): number {
    if (!this.deveValidarDescontoMaximo(produto)) { return null; }

    let maxDesc: number = null;
    if (produto.desc_maximo != null && produto.desc_maximo != 0) {
      maxDesc = produto.desc_maximo;
    }
    if (this.configuracao != null && this.configuracao.usa_conta_corrente_flex
        && produto.cc_flex_desc_maximo != null && produto.cc_flex_desc_maximo != 0) {
      if (maxDesc == null || produto.cc_flex_desc_maximo > maxDesc) {
        maxDesc = produto.cc_flex_desc_maximo;
      }
    }
    return maxDesc;
  }

  /** Retorna o preço-base do item SEM fator financeiro.
   *  Prioridade: estado_preco.precoBrutoSemFator → preco_unitario_base_manual → price (catálogo). */
  private obterBaseSemFatorItem(item: ProdutoPromocional): number {
    if (item.desconto_validado_por_prazo && item.preco_base_api > 0) return Number(item.preco_base_api);
    if (item == null) { return 0; }

    const estado: EstadoPreco = item.estado_preco;
    if (estado != null && estado.precoBrutoSemFator != null && estado.precoBrutoSemFator > 0) {
      return Number(estado.precoBrutoSemFator);
    }

    const baseManual = item.preco_unitario_base_manual;
    if (baseManual != null && isFinite(Number(baseManual)) && Number(baseManual) > 0) {
      return Number(baseManual);
    }
    if (item.price != null && isFinite(Number(item.price)) && Number(item.price) > 0) {
      return Number(item.price);
    }
    return 0;
  }

  /** Aplica o fator financeiro do prazo selecionado sobre a base, se aplica=true. */
  private calcularValorComFator(baseSemFator: number, aplica: boolean): number {
    const base = Number(baseSemFator);
    if (!isFinite(base) || base <= 0) { return 0; }
    if (!aplica) { return base; }
    const f = this.prazoPagamentoSelecionado != null
      ? Number(this.prazoPagamentoSelecionado.fator_financeiro)
      : 0;
    if (!isFinite(f) || f === 0) { return base; }
    return base * (1 + (f / 100));
  }

  /**
   * Após mudança de prazo, re-aplica o novo fator financeiro ao valor unitário
   * de todos os itens visíveis no modal (this.produtos) e nos já confirmados
   * (this.produtosAdicionados / this.produtosOriginal).
   * Mesma lógica do pai (recalcularValorUnitarioPrazo), adaptada para o modal.
   */
  private recalcularValorUnitarioPrazo(): void {
    const usaFator = this.prazoPagamentoSelecionado != null
      && this.configuracao != null
      && !this.configuracao.prazo_pagamento_antes_itenspedido
      && this.configuracao.utiliza_fator_financeiro;

    const fPerc = usaFator
      ? Number(this.prazoPagamentoSelecionado.fator_financeiro)
      : 0;

    const recalcularItem = (item: ProdutoPromocional) => {
      if (!item) { return; }
      if (this.ehPrecoPromocionalTravado(item)) { return; }

      const itemNoPedido: boolean = (item.qtde != null && item.qtde > 0)
        || (item.qtde_bonificada != null && item.qtde_bonificada > 0);
      if (!itemNoPedido) { return; }

      const aplicaFator = usaFator && item.aplica_fator_financeiro === true;
      const baseSemFator = this.obterBaseSemFatorItem(item);
      if (baseSemFator <= 0) { return; }

      item.preco_unitario_base_manual = baseSemFator;

      const baseComFator = this.calcularValorComFator(baseSemFator, aplicaFator);

      this.reajustarBasePorFator(item, baseSemFator, baseComFator, aplicaFator);

      const desconto = item.porcentagem_desconto_temporaria;
      let novoUnitario: number;
      if (desconto != null && isFinite(desconto) && desconto > 0 && desconto <= 100) {
        novoUnitario = baseComFator * (1 - desconto / 100);
      } else {
        novoUnitario = baseComFator;
      }

      const qtde = item.qtde != null && isFinite(item.qtde) ? Number(item.qtde) : 0;

      item.valor = this.formatacaoService.quatroCasasDecimais(novoUnitario);
      item.valor_total = parseFloat((novoUnitario * qtde).toFixed(2));

      /* Atualizar total com imposto (imposto unitário não muda com fator) */
      const impostoUnit = item.valor_imposto_unitario != null && isFinite(Number(item.valor_imposto_unitario))
        ? Number(item.valor_imposto_unitario) : 0;
      item.valor_imposto_total = parseFloat(((novoUnitario + impostoUnit) * qtde).toFixed(2));
      item.valor_imposto_total_final = item.valor_imposto_total;

      item.valor_fator_financeiro_tabela = aplicaFator
        ? parseFloat(baseComFator.toFixed(2))
        : 0;

      const deltaUnit = aplicaFator
        ? this.formatacaoService.quatroCasasDecimais(baseSemFator * (fPerc / 100))
        : 0;
      item.valor_fator_financeiro_unitario = deltaUnit > 0 ? deltaUnit : null;
      item.valor_fator_financeiro_produto = this.formatacaoService.quatroCasasDecimais(deltaUnit * qtde);

      this.aplicarEmTodasAsListas(item.id, alvo => this.copiarEstadoPreco(alvo, item));
    };

    /* 1) Lista de trabalho do modal (o que o usuário vê na tela) */
    this.produtos.forEach(recalcularItem);

    /* 2) Itens já confirmados (produtosAdicionados) */
    this.produtosAdicionados.forEach(recalcularItem);

    /* 2b) Campanha: recalcular valor unitário para todos os itens de campanha */
    this.produtosAdicionados.forEach((item) => {
      if (!item || item.produtos_vinculados == null || !item.produtos_vinculados.length) { return; }
      if (this.ehPrecoPromocionalTravado(item as ProdutoPromocional)) { return; }

      let novoTotal: number = 0;

      item.produtos_vinculados.forEach((pv) => {
        if (!pv || pv.bonificacao) { return; }

        let base: number = (pv.price_promotional != null && isFinite(Number(pv.price_promotional)) && Number(pv.price_promotional) > 0)
          ? Number(pv.price_promotional) : (pv.price != null && isFinite(Number(pv.price)) ? Number(pv.price) : 0);
        if (base <= 0) { return; }

        let aplica: boolean = usaFator && pv.aplica_fator_financeiro === true;
        let baseComFator: number = aplica ? base * (1 + (fPerc / 100)) : base;
        let qtdePv: number = pv.qtde != null && isFinite(Number(pv.qtde)) && Number(pv.qtde) > 0 ? Number(pv.qtde) : 0;

        novoTotal = novoTotal + this.formatacaoService.quatroCasasDecimais(baseComFator) * qtdePv;
      });

      if (novoTotal > 0) {
        item.valor = this.formatacaoService.quatroCasasDecimais(novoTotal);
        item.valor_fator_financeiro_tabela = parseFloat(novoTotal.toFixed(2));
        let qtde: number = item.qtde != null && isFinite(Number(item.qtde)) && Number(item.qtde) > 0 ? Number(item.qtde) : 0;
        item.valor_total = parseFloat((novoTotal * qtde).toFixed(2));
      }
    });

    /* 3) produtosOriginal (fonte de verdade) — espelha o resultado */
    this.produtosOriginal.forEach((item) => {
      if (this.ehPrecoPromocionalTravado(item)) { return; }

      /* Espelhar de produtosAdicionados se está lá */
      const adicionado = this.produtosAdicionados.find(p => p.id === item.id);
      if (adicionado) {
        item.valor = adicionado.valor;
        item.valor_total = adicionado.valor_total;
        item.valor_fator_financeiro_tabela = adicionado.valor_fator_financeiro_tabela;
        item.valor_fator_financeiro_unitario = adicionado.valor_fator_financeiro_unitario;
        item.valor_fator_financeiro_produto = adicionado.valor_fator_financeiro_produto;
        (item as any).preco_unitario_base_manual = (adicionado as any).preco_unitario_base_manual;
        return;
      }
      /* Senao espelhar de this.produtos */
      const emEdicao = this.produtos.find(p => p.id === item.id);
      if (emEdicao) {
        item.valor = emEdicao.valor;
        item.valor_total = emEdicao.valor_total;
        item.valor_fator_financeiro_tabela = emEdicao.valor_fator_financeiro_tabela;
        item.valor_fator_financeiro_unitario = emEdicao.valor_fator_financeiro_unitario;
        item.valor_fator_financeiro_produto = emEdicao.valor_fator_financeiro_produto;
        (item as any).preco_unitario_base_manual = (emEdicao as any).preco_unitario_base_manual;
      }
    });

    this.totalizarProdutosAdicionados();
  }

  /**
   * Após mudança de prazo, recalcula valores de itens travados por tabela
   * usando `preco_tabela_especial_sem_fator` como base — sem consultar a API.
   * Complementa recalcularValorUnitarioPrazo (que pula itens travados).
   */
  private recalcularValoresPorMudancaPrazo(): void {
    const recalcularItemTravado = (item: ProdutoPromocional, adicionado: boolean) => {
      if (!item || !this.ehPrecoPromocionalTravado(item)) { return; }

      const estado: EstadoPreco = item.estado_preco;

      let base = Number(estado != null && estado.precoBrutoSemFator != null
        ? estado.precoBrutoSemFator
        : item.preco_tabela_especial_sem_fator);

      if (!isFinite(base) || base <= 0) {
        const fallback = Number(item.valor_tabela);
        if (!isFinite(fallback) || fallback <= 0) { return; }
        item.preco_tabela_especial_sem_fator = fallback;
        base = fallback;
      }

      const aplicaFator = item.aplica_fator_financeiro === true && !item.ignorar_pontuacao_por_tabela;
      const percentual = item.porcentagem_desconto_temporaria;
      const novaBase = this.calcularValorComFator(base, aplicaFator);

      this.reajustarBasePorFator(item, base, novaBase, aplicaFator);

      const novoValor = percentual != null && isFinite(percentual) && percentual > 0 && percentual <= 100
        ? novaBase * (1 - (percentual / 100))
        : novaBase;

      item.valor = this.formatacaoService.quatroCasasDecimais(novoValor);
      item.preco_tabela_base_desconto = this.formatacaoService.quatroCasasDecimais(novaBase);
      item.valor_fator_financeiro_tabela = item.preco_tabela_base_desconto;
      const qtde = item.qtde != null && isFinite(Number(item.qtde)) ? Number(item.qtde) : 0;
      item.valor_total = parseFloat((novoValor * qtde).toFixed(2));
      this.calcularFatorFinanceiroProduto(item.id, adicionado);
    };

    (this.produtos || []).forEach((p: ProdutoPromocional) => recalcularItemTravado(p, false));
    (this.produtosAdicionados || []).forEach((p: ProdutoPromocional) => recalcularItemTravado(p, true));

    /* Espelhar para produtosOriginal */
    (this.produtosOriginal || []).forEach((orig: ProdutoPromocional) => {
      const ad = (this.produtosAdicionados || []).find(p => p.id === orig.id);
      const fonte = (ad != null && this.ehPrecoPromocionalTravado(ad))
        ? ad
        : (this.produtos || []).find(p => p.id === orig.id);

      if (fonte == null || !this.ehPrecoPromocionalTravado(fonte)) { return; }

      orig.valor = fonte.valor;
      orig.valor_total = fonte.valor_total;
      orig.valor_fator_financeiro_tabela = fonte.valor_fator_financeiro_tabela;
      this.copiarEstadoPreco(orig, fonte);
    });

    this.totalizarProdutosAdicionados();
  }

  /**
   * Recalcula o valor unitário dos produtos vinculados da campanha selecionada
   * aplicando o fator financeiro do prazo corrente.
   * Análogo a recalcularValorUnitarioPrazo para itens de campanha.
   */
  private recalcularUnitarioCampanhaPorPrazo(): void {
    if (this.produtoCampanhaSelecionado == null
        || this.produtoCampanhaSelecionado.produtos_vinculados == null
        || !this.produtoCampanhaSelecionado.produtos_vinculados.length) return;

    const usaFator = this.configuracao != null
      && !this.configuracao.prazo_pagamento_antes_itenspedido
      && this.configuracao.utiliza_fator_financeiro
      && this.prazoPagamentoSelecionado != null;

    const fPerc = usaFator && isFinite(Number(this.prazoPagamentoSelecionado.fator_financeiro))
      ? Number(this.prazoPagamentoSelecionado.fator_financeiro)
      : 0;

    /* 1) Recalcular valor_fator_financeiro_inicial de cada produto vinculado com o prazo atual.
     *    Não altera p.valor — calcularImpostoCampanhaProduto já soma valor + fator, então
     *    mudar p.valor causaria dupla contagem do fator. */
    this.produtoCampanhaSelecionado.produtos_vinculados.forEach(p => {
      if (!p || p.bonificacao) return;
      if (this.ehPrecoPromocionalTravado(p as ProdutoPromocional)) return;

      const base = (p.price_promotional != null && Number(p.price_promotional) > 0)
        ? Number(p.price_promotional)
        : Number(p.price != null ? p.price : 0);
      if (base <= 0) return;

      const aplica = usaFator && p.aplica_fator_financeiro === true;
      p.valor_fator_financeiro_inicial = aplica && fPerc !== 0
        ? this.formatacaoService.quatroCasasDecimais(base * (fPerc / 100))
        : 0;
    });

    /* 2) Recalcular campos derivados de fator + imposto por produto */
    this.produtoCampanhaSelecionado.produtos_vinculados.forEach(p => {
      if (!p || p.bonificacao) return;
      this.calcularFatorFinanceiroCampanhaProduto(p.id);
    });

    /* 3) Totalizar campanha e re-executar fator agregado com campaign.valor_total atualizado.
     *    Para combo, calcularFatorFinanceiroCampanha usa campaign.valor_total; por isso deve
     *    ser chamado APÓS totalizarProdutoCampanhaSelecionado que atualiza esse campo. */
    this.totalizarProdutoCampanhaSelecionado();
    this.calcularFatorFinanceiroCampanha();
  }

  verificarProdutoValor(produto: ProdutoPromocional, event: any, adicionado: boolean) {
    if (((produto.qtde != 0 && produto.qtde != null) || (produto.qtde_bonificada != 0 && produto.qtde_bonificada != null)) && (produto.valor != 0 && produto.valor != null)) {
      this.calculando = true;

      let valor: number = produto.valor;
      let qtdeFinal: number = produto.qtde != 0 && produto.qtde != null ? produto.qtde : produto.qtde_bonificada;

      let produtoDesconto: ProdutoDesconto = null;

      let valorFatorFinanceiroInicial: number = parseFloat(produto.valor_fator_financeiro_inicial.toFixed(2));

      const versaoNaChamada: number = produto.estado_preco != null ? produto.estado_preco.versao : null;

      this.produtoService.getDescontoByProduto(this.clienteSelecionado.id, produto.id, valor, qtdeFinal, this.vendedorSelecionado.id, produto.id_lote, valorFatorFinanceiroInicial,
        this.configuracao?.prazo_pagamento_antes_itenspedido ? this.prazoPagamentoSelecionado?.idprazopagamento : null,
        this.configuracao?.prazo_pagamento_antes_itenspedido ? precoNegociadoSemFator(produto, this.prazoPagamentoSelecionado, this.configuracao) : null,
        this.configuracao?.prazo_pagamento_antes_itenspedido === true).subscribe(
        produtosDescontos => produtoDesconto = produtosDescontos,
        error => {
          this.calculando = false;
          if (this.configuracao?.prazo_pagamento_antes_itenspedido) {
            produto.erro_valor = true;
            this.toastr.error("", "Não foi possível validar o desconto deste item.");
          }
        },
        () => {
          if (this.configuracao?.prazo_pagamento_antes_itenspedido && !(produtoDesconto?.preco_base > 0)) {
            produto.erro_valor = true; this.calculando = false;
            this.toastr.error("", "Não foi possível determinar o preço mínimo deste item."); return;
          }

          const versaoAtual: number = produto.estado_preco != null ? produto.estado_preco.versao : null;

          if (versaoNaChamada !== versaoAtual) {
            this.calculando = false;
            return;
          }

          if (this.configuracao?.prazo_pagamento_antes_itenspedido && produtoDesconto.preco_base > 0) {
            aplicarDescontoPrazo(produto, produtoDesconto);
            produto.requer_aprovacao_prazo = false;
          }
          produto.preco_base_api = produtoDesconto.preco_base;

          if (produtoDesconto.preco_base != null && produtoDesconto.preco_base > 0
              && (produto.estado_preco == null || produto.estado_preco.origem === 'manual')) {
            produto.valor_tabela = produtoDesconto.preco_base;
          }
          produto.desconto_concedido_api = produtoDesconto.desconto_concedido;

          const pularValidacoesPorPromocao = this.ehPrecoPromocionalTravado(produto);

          produto.porcentagem_desconto = produtoDesconto.desconto_concedido;
          produto.descritivo_desconto = (produto.estado_preco == null || produto.estado_preco.origem === 'tabela_especial') ? produtoDesconto.descritivo_desconto : null;

          if (produto.editando_desconto !== true && produto.estado_preco == null) {
            if (produtoDesconto.desconto_concedido > 0.01) {
              produto.porcentagem_desconto_temporaria = this.formatacaoService.quatroCasasDecimais(produtoDesconto.desconto_concedido);
            } else {
              produto.porcentagem_desconto_temporaria = null;
            }
          }

          let porcentagemDescontoMaximo: number = null;

          if (produto.desc_maximo != null && produto.desc_maximo != 0) {
            porcentagemDescontoMaximo = produto.desc_maximo;
          }

          if (this.configuracao != null && this.configuracao.usa_conta_corrente_flex) {
            if (produto.cc_flex_desc_maximo != null && produto.cc_flex_desc_maximo != 0) {
              if (produto.cc_flex_desc_maximo > porcentagemDescontoMaximo) {
                porcentagemDescontoMaximo = produto.cc_flex_desc_maximo;
              }
            }

            if (!pularValidacoesPorPromocao && porcentagemDescontoMaximo != null) {
              let valorCalculoInicial: number = this.obterBaseValidacaoDescontoMaximo(produto);

              let valorAtual: number = this.formatacaoService.duasCasasDecimais(produto.valor);
              let valorDescontoMaximo: number = (valorCalculoInicial - ((valorCalculoInicial * porcentagemDescontoMaximo) / 100));
              let valorMaximo: number = this.formatacaoService.duasCasasDecimais((valorDescontoMaximo * 100) / 100);

              if (valorAtual < valorMaximo) {
                this.toastr.error("", "Porcentagem máxima de desconto: " + porcentagemDescontoMaximo + "%...");

                produto.erro_valor = true;

                this.calcularFatorFinanceiroProduto(produto.id, adicionado);

                if (adicionado) {
                  this.organizarProdutosAdicionados();
                }

                this.calculando = false;

                setTimeout(() => {
                  if (event != null && event.relatedTarget != null) {
                    event.relatedTarget.focus();
                  }
                }, 100);

                return;
              }
            }

            let saldoGerado: number = 0;
            const baseSaldo: number = produto.preco_base_api != null ? Number(produto.preco_base_api) : 0;

            if (produto.qtde != null && produto.qtde > 0) {
              saldoGerado = ((produto.valor - baseSaldo) * produto.qtde);

              if (this.configuracao.tipo_conta_corrente_flex == 2) {
                /* Conta Corrente (Flex) = 2 */

                if (this.tiposPedidoSelecionado != null && this.tiposPedidoSelecionado.flag_considerar_pedido_como_venda) {
                  if (produto.cc_flex_perc_credito != null && produto.cc_flex_perc_credito != 0) {
                    saldoGerado = ((((produto.valor - baseSaldo) * produto.cc_flex_perc_credito) / 100) * produto.qtde);

                    if (saldoGerado < 0) {
                      saldoGerado = 0;
                    }
                  } else {
                    saldoGerado = 0;
                  }
                } else {
                  saldoGerado = ((produto.valor * produto.qtde) * -1);
                }
              }
            }

            produto.saldo_gerado = parseFloat(saldoGerado.toFixed(2));

            /* Qtde (Bonificada) */

            if (produto.qtde_bonificada != null && produto.qtde_bonificada > 0) {
              let saldoGerado: number = (produto.saldo_gerado - (produto.valor * produto.qtde_bonificada));

              produto.saldo_gerado = parseFloat(saldoGerado.toFixed(2));
            }

            let produtoOriginal = this.produtosOriginal.find(produtoOriginal => produtoOriginal.id == produto.id);

            if (produtoOriginal != null) {
              produtoOriginal.saldo_gerado = produto.saldo_gerado;
            }

            this.totalizarSaldoGerado();
          } else {
            if (!pularValidacoesPorPromocao && porcentagemDescontoMaximo != null) {
              let valorCalculoInicial: number = this.obterBaseValidacaoDescontoMaximo(produto);

              let valorAtual: number = this.formatacaoService.duasCasasDecimais(produto.valor);
              let valorDescontoMaximo: number = (valorCalculoInicial - ((valorCalculoInicial * porcentagemDescontoMaximo) / 100));
              let valorMaximo: number = this.formatacaoService.duasCasasDecimais((valorDescontoMaximo * 100) / 100);

              if (valorAtual < valorMaximo) {
                this.toastr.error("", "Porcentagem máxima de desconto: " + porcentagemDescontoMaximo + "%...");

                produto.erro_valor = true;

                this.calcularFatorFinanceiroProduto(produto.id, adicionado);

                if (adicionado) {
                  this.organizarProdutosAdicionados();
                }

                this.calculando = false;

                setTimeout(() => {
                  if (event != null && event.relatedTarget != null) {
                    event.relatedTarget.focus();
                  }
                }, 100);

                return;
              }
            }
          }

          if (!pularValidacoesPorPromocao && this.configuracao != null && !this.configuracao.flag_permite_preco_acima_tabela) {
            const valorTabela: number = this.obterTetoPrecoTabela(produto);

            if (valorTabela > 0 && produto.valor > valorTabela) {
              this.toastr.error("", "Valor acima da tabela...");

              produto.erro_valor = true;

              this.calcularFatorFinanceiroProduto(produto.id, adicionado);

              if (adicionado) {
                this.organizarProdutosAdicionados();
              }

              this.calculando = false;

              setTimeout(() => {
                if (event != null && event.relatedTarget != null) {
                  event.relatedTarget.focus();
                }
              }, 100);

              return;
            }
          }

          let valorTotal: number = produto.valor * produto.qtde;

          produto.valor_total = parseFloat(valorTotal.toFixed(2));

          this.aplicarEmTodasAsListas(produto.id, item => this.copiarEstadoPreco(item, produto));

          this.calcularFatorFinanceiroProduto(produto.id, adicionado);

          if (!adicionado && this.tipoOrdenacaoItensPedido == 1) {
            /* Ordenar = Inclusão */

            this.definirOrdemInclusao(produto.id, true);
          }

          if (adicionado) {
            this.organizarProdutosAdicionados();
          }

          this.calculando = false;

          setTimeout(() => {
            if (event != null && event.relatedTarget != null) {
              event.relatedTarget.focus();
            }
          }, 100);
        }
      );
    } else {
      produto.valor_tabela = 0;
      produto.preco_base_api = null;

      produto.porcentagem_desconto = 0;
      produto.descritivo_desconto = null;

      /* Porcentagem Desconto Temporária */

      if (produto.valor != null && produto.valor > 0) {
        this.calcularDescontoUnitario(produto.id, false, adicionado);
      } else {
        produto.porcentagem_desconto_temporaria = null;
        produto.estado_preco = null;
      }

      if (this.configuracao != null && this.configuracao.usa_conta_corrente_flex) {
        produto.saldo_gerado = 0;

        let produtoOriginal = this.produtosOriginal.find(produtoOriginal => produtoOriginal.id == produto.id);

        if (produtoOriginal != null) {
          produtoOriginal.saldo_gerado = 0;
        }

        this.totalizarSaldoGerado();
      }

      produto.valor_total = 0;

      this.calcularFatorFinanceiroProduto(produto.id, adicionado);

      if (this.tipoOrdenacaoItensPedido == 1) {
        /* Ordenar = Inclusão */

        this.definirOrdemInclusao(produto.id, false);
      }

      if (adicionado) {
        this.organizarProdutosAdicionados();
      }

      this.calculando = false;
    }
  }

  verificarProdutoValorNovo(produto: ProdutoPromocional, event: any, adicionado: boolean) {
    this.verificarProdutoValor(produto, event, adicionado);
  }

  /* Cabeçalho */

  agruparProdutos() {
    let retorno = new Promise<void>((resolver) => {
      /* Produtos */

      let produtoPromocionalTemporario: ProdutoPromocional[] = [];

      this.produtosAdicionados.forEach((item) => {
        if (item.id != 0 && (item.qtde != 0 && item.qtde != null)) {
          produtoPromocionalTemporario.push(item);
        }

        if (item.produtos_vinculados != null) {
          /* Produtos Vinculados */

          item.produtos_vinculados.forEach((subItem) => {
            if (subItem.qtde > 0) {
              if (item.preco_bonificacao == "B") {
                /* Bonificação */

                if (subItem.bonificacao) {
                  /* Bonificação */

                  if (subItem.bonificacao_selecionada) {
                    if (item.bonificacao_multiplicavel) {
                      /* Bonificação (Multiplicável) */

                      let qtdeBonificacaoMultiplicavel: number = item.qtde_bonificacao_multiplicavel != null ? item.qtde_bonificacao_multiplicavel : 0;

                      if (item.bonificacao_selecionavel) {
                        /* Bonificação (Selecionável) */

                        subItem.qtde = subItem.qtde * qtdeBonificacaoMultiplicavel;
                      } else {
                        subItem.qtde = qtdeBonificacaoMultiplicavel;
                      }

                      produtoPromocionalTemporario.push(subItem);
                    } else {
                      produtoPromocionalTemporario.push(subItem);
                    }
                  }
                } else {
                  if (!item.bonificacao_selecionavel && subItem.bonificacao_selecionada) {
                    let produtoVinculado: ProdutoPromocional = { ...subItem };

                    /* Produto Origem */

                    subItem.bonificacao_selecionada = false;
                    subItem.qtde = subItem.qtde * item.qtde;

                    produtoPromocionalTemporario.push(subItem);

                    /* Produto Bonificado */

                    produtoVinculado.bonificacao = true;

                    if (item.bonificacao_multiplicavel) {
                      produtoVinculado.qtde = item.qtde_bonificacao_multiplicavel;
                    } else {
                      produtoVinculado.qtde = 1;
                    }

                    produtoPromocionalTemporario.push(produtoVinculado);
                  } else {
                    subItem.qtde = subItem.qtde * item.qtde;

                    produtoPromocionalTemporario.push(subItem);
                  }
                }
              } else {
                subItem.qtde = subItem.qtde * item.qtde;

                produtoPromocionalTemporario.push(subItem);
              }
            }
          });
        } else {
          /* Qtde (Bonificada) */

          if (item.qtde_bonificada != null && item.qtde_bonificada > 0) {
            let produtoPromocionalBonificado: ProdutoPromocional = { ...item };

            produtoPromocionalBonificado.bonificacao = true;
            produtoPromocionalBonificado.qtde = item.qtde_bonificada;

            produtoPromocionalTemporario.push(produtoPromocionalBonificado);
          }
        }
      });

      /* Agrega Qtde */

      let produtoPromocional: ProdutoPromocional[] = [];

      produtoPromocionalTemporario.forEach((item) => {
        let produto = produtoPromocional.find(produtoPromocional => produtoPromocional.id == item.id && produtoPromocional.bonificacao == item.bonificacao && produtoPromocional.valor == item.valor && produtoPromocional.cod_lote == item.cod_lote);

        if (produto != null) {
          produto.qtde = produto.qtde + item.qtde;
        } else {
          produtoPromocional.push(item);
        }
      });

      /* Produtos Agrupados */

      this.produtosAgrupados = [];

      produtoPromocional.forEach((item) => {
        if (this.produtosAgrupados.length == 0) {
          let produtoPromocionalAgrupado = new ProdutoPromocionalAgrupado();

          produtoPromocionalAgrupado.bonificacao = item.bonificacao;
          produtoPromocionalAgrupado.cod_lote = item.cod_lote;
          produtoPromocionalAgrupado.produtoPromocional = [];

          produtoPromocionalAgrupado.produtoPromocional.push(item);

          this.produtosAgrupados.push(produtoPromocionalAgrupado);
        } else {
          let novoAgrupamento: boolean = false;

          let produtoAdicionado: boolean = false;

          this.produtosAgrupados.forEach((subItem) => {
            if (!produtoAdicionado) {
              if (item.cod_lote != subItem.cod_lote) {
                novoAgrupamento = true;
              } else {
                if (item.bonificacao) {
                  /* Bonificação */

                  if (subItem.bonificacao) {
                    /* Bonificação */

                    let produto = subItem.produtoPromocional.find(produtoPromocional => produtoPromocional.id == item.id);

                    if (produto == null) {
                      subItem.produtoPromocional.push(item);

                      novoAgrupamento = false;
                      produtoAdicionado = true;
                    } else {
                      novoAgrupamento = true;
                    }
                  }
                } else {
                  if (!subItem.bonificacao) {
                    /* Bonificação */

                    let produto = subItem.produtoPromocional.find(produtoPromocional => produtoPromocional.id == item.id);

                    if (produto == null) {
                      subItem.produtoPromocional.push(item);

                      novoAgrupamento = false;
                      produtoAdicionado = true;
                    } else {
                      novoAgrupamento = true;
                    }
                  }
                }
              }
            }
          });

          if (novoAgrupamento || !produtoAdicionado) {
            let produtoPromocionalAgrupado = new ProdutoPromocionalAgrupado();

            produtoPromocionalAgrupado.bonificacao = item.bonificacao;
            produtoPromocionalAgrupado.cod_lote = item.cod_lote;
            produtoPromocionalAgrupado.produtoPromocional = [];

            produtoPromocionalAgrupado.produtoPromocional.push(item);

            this.produtosAgrupados.push(produtoPromocionalAgrupado);
          }
        }
      });

      this.produtosAgrupados.sort((a, b) => {
        const compare = (v1, v2) => v1 == null ? -1 : v1 < v2 ? -1 : v1 > v2 ? 1 : 0;

        return compare(a["bonificacao"], b["bonificacao"]);
      });

      return resolver();
    });

    return retorno;
  }

  /**
   * Retorna true se há itens que precisam ser validados antes de trocar o prazo.
   * Considera itens adicionados ao pedido OU itens na grade com qtde/valor preenchidos.
   */
  private temItensParaValidar(): boolean {
    if ((this.produtosAdicionados || []).length > 0) {
      return true;
    }

    return (this.produtos || []).some(p => {
      if (!p) { return false; }
      const qt = Number(p.qtde || 0);
      const qtb = Number(p.qtde_bonificada || 0);
      const val = Number(p.valor || 0);
      const travado = (p as any).preco_tabela_travado === true;
      const comLote = (p.qtde_lote > 0 && p.id_lote != null);
      return (qt > 0) || (qtb > 0) || (val > 0) || travado || comLote;
    });
  }

  revalidandoPrazo = false;

  @ViewChild("confirmarReducaoPrecoPrazo") confirmarReducaoPrecoPrazoTpl: any;

  private usaFatorFinanceiroNoPedido(): boolean {
    return this.configuracao != null && this.configuracao.utiliza_fator_financeiro === true
      && !this.configuracao.prazo_pagamento_antes_itenspedido;
  }

  /** Prazo com fator menor: com a flag ligada, pergunta antes de baixar os preços ("Não" mantém e vira a base). */
  private confirmarReducaoPrecoPrazo(prazoAnterior: PrazoPagamento, prazoNovo: PrazoPagamento,
    precos: PrecoAntesDoPrazo[], continuar: (manterPreco: boolean) => void): void {
    if (this.configuracao?.flag_confirma_reducao_preco_prazo !== true || this.confirmarReducaoPrecoPrazoTpl == null
      || !prazoReduzFator(prazoAnterior, prazoNovo) || !haPrecoParaReduzir(precos)) {
      continuar(false);
      return;
    }
    this.modalService.open(this.confirmarReducaoPrecoPrazoTpl, { backdrop: 'static', keyboard: false, centered: true })
      .result.then(resposta => continuar(resposta !== 'Reduzir'), () => continuar(true));
  }

  alterarPrazoPagamento(id_prazo_pagamento: string, cabecalho: boolean, event?: Event) {
    if (this.revalidandoPrazo) return;
    if (this.configuracao?.prazo_pagamento_antes_itenspedido &&
        [...(this.produtosOriginal || []), ...(this.produtosAdicionados || []), ...(this.produtos || [])]
          .some(p => p.qtde > 0 || p.qtde_bonificada > 0)) {
      return revalidarDescontoAoTrocarPrazo(this, Number(id_prazo_pagamento));
    }

    if (this.validarErrosProdutosAdicionados(true) > 0) {
      this.cancelarAlterarPrazoPagamento(event);

      return;
    }

    let idSelecionado: number = parseInt(id_prazo_pagamento);

    if (idSelecionado > 0) {
      // Se não há itens em edição/adicionados, pula a validação para não bloquear a troca de prazo
      const validarErrosProduto = this.temItensParaValidar()
        ? this.validarErrosProduto(false)
        : Promise.resolve<void>(undefined).then(() => { this.produtosComErro = []; });

      validarErrosProduto.then(() => {
        if (this.produtosComErro.length == 0) {
          /* Prazo Médio */

          this.prazoMedioService.getByIdPrazoPagamento(idSelecionado).subscribe(
            prazoMedio => this.prazoMedio = prazoMedio,
            error => { /* handle error silently */ },
            () => {
              if (this.configuracao != null && this.configuracao.usar_desconto_prazo_medio == "S") {
                let valorTotalPadrao = this.produtosAdicionados.reduce((sum, current) => (sum + (current.price * current.qtde)), 0);
                let valorTotalAdicionado = this.produtosAdicionados.reduce((sum, current) => (sum + (current.valor * current.qtde)), 0);

                let qtdeCampanhas = this.produtosAdicionados.filter(produtoAdicionado => produtoAdicionado.categoria == this.campanhas).length;

                if (valorTotalAdicionado >= valorTotalPadrao && qtdeCampanhas == 0) {
                  /* Prazo Médio (Desconto) */

                  this.prazoMedioService.getPrazoMedioDescontoByGuidClienteNapis(this.prazoMedio.prazomedio).subscribe(
                    prazoMedioDesconto => this.prazoMedioDesconto = prazoMedioDesconto,
                    error => { /* handle error silently */ },
                    () => {
                      this.prazoPagamentoInvalido = false;
                    }
                  );
                } else {
                  this.toastr.warning("", "Pedido fora da tabela padrão...");

                  this.prazoPagamentoInvalido = false;
                }
              } else {
                this.prazoPagamentoInvalido = false;
              }

              const prazoAnterior = this.prazoPagamentoSelecionado;
              const prazoNovo = this.prazosPagamentoOriginal.find(prazoPagamento => prazoPagamento.idprazopagamento == idSelecionado);
              const precosAntes = this.usaFatorFinanceiroNoPedido()
                ? capturarPrecosAntesDoPrazo([this.produtosAdicionados, this.produtosOriginal, this.produtos], p => this.ehPrecoPromocionalTravado(p))
                : [];

              this.confirmarReducaoPrecoPrazo(prazoAnterior, prazoNovo, precosAntes, manterPreco => {
                this.prazoPagamentoSelecionado = prazoNovo;

                if (cabecalho) {
                  this.carregarDadosPorCliente(false);
                }

                this.calcularFatorFinanceiro();
                /* Reaplica desconto ao novo valor de tabela (fator alterado) */
                this.recalcularValorUnitarioPrazo();
                this.recalcularUnitarioCampanhaPorPrazo();
                /* Recalcula preço de itens travados por tabela com novo fator */
                this.recalcularValoresPorMudancaPrazo();

                /* Preço digitado/mantido pelo vendedor é a base do fator, não a tabela */
                aplicarPrecoNegociadoNoPrazo(precosAntes, prazoAnterior, prazoNovo, manterPreco,
                  valor => this.formatacaoService.quatroCasasDecimais(valor));
                this.totalizarProdutosAdicionados();

                if (this.exibirPontuacao) {
                  this.produtosAdicionados.forEach((item) => {
                    this.calcularPontuacaoProduto(item.id, true);
                  });

                  /* Recalcular pontuação dos produtos na modal também */
                  this.produtos.forEach((item) => {
                    this.calcularPontuacaoProduto(item.id, false);
                  });

                  this.totalizarProdutosAdicionados();
                }
              });
            }
          );
        } else {
          this.cancelarAlterarPrazoPagamento(event);
        }
      });
    } else {
      const prazoAnterior = this.prazoPagamentoSelecionado;
      const precosAntes = this.usaFatorFinanceiroNoPedido()
        ? capturarPrecosAntesDoPrazo([this.produtosAdicionados, this.produtosOriginal, this.produtos], p => this.ehPrecoPromocionalTravado(p))
        : [];

      this.prazoPagamentoSelecionado = null;
      this.prazoMedio = null;
      this.prazoMedioDesconto = null;

      this.calcularFatorFinanceiro();
      /* Reaplica desconto ao novo valor de tabela (fator alterado) */
      this.recalcularValorUnitarioPrazo();
      this.recalcularUnitarioCampanhaPorPrazo();
      /* Recalcula preço de itens travados por tabela com novo fator */
      this.recalcularValoresPorMudancaPrazo();

      /* Preço digitado pelo vendedor é a base do fator, não a tabela */
      aplicarPrecoNegociadoNoPrazo(precosAntes, prazoAnterior, null, false,
        valor => this.formatacaoService.quatroCasasDecimais(valor));
      this.totalizarProdutosAdicionados();

      if (this.exibirPontuacao) {
        this.produtosAdicionados.forEach((item) => {
          this.calcularPontuacaoProduto(item.id, true);
        });

        /* Recalcular pontuação dos produtos na modal também */
        this.produtos.forEach((item) => {
          this.calcularPontuacaoProduto(item.id, false);
        });

        this.totalizarProdutosAdicionados();
      }
    }
  }

  cancelarAlterarPrazoPagamento(event?: Event) {
    if (event != null) {
      let target = event.target as HTMLSelectElement;

      if (this.prazoPagamentoSelecionado != null) {
        target.value = this.prazoPagamentoSelecionado.idprazopagamento.toString();
      } else {
        target.value = null;
      }

      event.preventDefault();
    }

    this.reiniciarFiltroProduto();
  }

  organizarPrazoPagamento(parcial: boolean, inicial: boolean) {
    let prazoPagamentoAnterior: PrazoPagamento = null;

    if (this.prazoPagamentoSelecionado != null) {
      prazoPagamentoAnterior = this.prazoPagamentoSelecionado;
    }

    if (this.configuracao != null && !this.configuracao.prazo_pagamento_antes_itenspedido) {
      if (this.configuracao != null && this.configuracao.prazo_flex) {
        this.prazosPagamentoOriginal.forEach((item) => {
          if (this.valorTotalProdutosAdicionados < item.valorinicial) {
            if (item.id_prazo_pagamento_cliente == null) {
              let valorFaltante: number = item.valorinicial - this.valorTotalProdutosAdicionados;

              item.descricao = item.descricao_inicial + " (" + this.currencyPipe.transform(item.fator_financeiro, "", "") + "%)" + " - FALTAM: " + this.currencyPipe.transform(valorFaltante, "", "R$");
              item.prazo_especial = "S";
            } else {
              item.descricao = item.descricao_inicial + " (" + this.currencyPipe.transform(item.fator_financeiro, "", "") + "%)";
            }
          } else {
            item.descricao = item.descricao_inicial + " (" + this.currencyPipe.transform(item.fator_financeiro, "", "") + "%)";

            if (!item.especial_cliente) {
              item.prazo_especial = item.prazo_especial_inicial;
            }
          }
        });

        this.prazosPagamentoIniciais = this.prazosPagamentoOriginal.filter(prazoPagamento => prazoPagamento.prazo_especial == "N");

        if (this.prazosPagamentoOriginal.some(prazoPagamento => prazoPagamento.id_prazo_pagamento_cliente != null)) {
          this.prazosPagamentoEspeciais = [];
        } else {
          this.prazosPagamentoEspeciais = this.prazosPagamentoOriginal.filter(prazoPagamento => prazoPagamento.prazo_especial == "S");
        }
      } else {
        this.prazosPagamentoIniciais = this.prazosPagamentoOriginal.filter(prazoPagamento => prazoPagamento.prazo_especial == "N" && this.valorTotalProdutosAdicionados >= prazoPagamento.valorinicial);

        if (this.configuracao != null && this.configuracao.flag_usa_prazo_vinculado_cliente) {
          this.prazosPagamentoEspeciais = [];
        } else {
          this.prazosPagamentoEspeciais = this.prazosPagamentoOriginal.filter(prazoPagamento => prazoPagamento.prazo_especial == "S" && this.valorTotalProdutosAdicionados >= prazoPagamento.valorinicial);
        }
      }
    } else {
      this.prazosPagamentoIniciais = this.prazosPagamentoOriginal.filter(prazoPagamento => prazoPagamento.prazo_especial == "N");

      if (this.configuracao != null && this.configuracao.flag_usa_prazo_vinculado_cliente) {
        this.prazosPagamentoEspeciais = [];
      } else {
        this.prazosPagamentoEspeciais = this.prazosPagamentoOriginal.filter(prazoPagamento => prazoPagamento.prazo_especial == "S");
      }
    }

    if (prazoPagamentoAnterior != null) {
      let prazoPagamentoDisponivel: PrazoPagamento = this.prazosPagamentoIniciais.find(prazoPagamento => prazoPagamento.idprazopagamento == prazoPagamentoAnterior.idprazopagamento);

      if (prazoPagamentoDisponivel == null) {
        prazoPagamentoDisponivel = this.prazosPagamentoEspeciais.find(prazoPagamento => prazoPagamento.idprazopagamento == prazoPagamentoAnterior.idprazopagamento);

        if (prazoPagamentoDisponivel == null) {
          this.prazoPagamentoSelecionado = null;
          this.prazoMedio = null;
          this.prazoMedioDesconto = null;
        }
      }
    } else {
      this.prazoPagamentoSelecionado = null;
      this.prazoMedio = null;
      this.prazoMedioDesconto = null;
    }

    if (inicial) {
      if (this.clienteSelecionado.id_prazo_pagamento != null) {
        let prazoPagamento: PrazoPagamento = this.prazosPagamentoIniciais.find(prazoPagamento => prazoPagamento.idprazopagamento == this.clienteSelecionado.id_prazo_pagamento);

        if (prazoPagamento != null) {
          this.prazoPagamentoSelecionado = prazoPagamento;
        } else {
          prazoPagamento = this.prazosPagamentoEspeciais.find(prazoPagamento => prazoPagamento.idprazopagamento == this.clienteSelecionado.id_prazo_pagamento);

          if (prazoPagamento != null) {
            this.prazoPagamentoSelecionado = prazoPagamento;
          }
        }
      }
    }

    if (!parcial) {
      this.calcularFatorFinanceiro();
    }
  }

  /* Filtro (Clientes) */

  filtrarProduto() {
    // Só valida erros quando há itens realmente preenchidos/adicionados.
    // Mesmo que haja erros, a pesquisa prossegue para não travar o usuário.
    // Os erros permanecem sinalizados em produtosOriginal e serão pegos no confirm.
    const doValidate = this.temItensParaValidar()
      ? this.validarErrosProduto(false)
      : Promise.resolve<void>(undefined).then(() => { this.produtosComErro = []; });

    doValidate.then(() => {
      {
        this.enviadoProduto = true;

        if (this.formFiltroProduto.invalid) {
          if (this.formFiltroProduto.controls["status"].value == "2" || this.somentePromocoes) {
            /* Item Reposição */

            if (this.formFiltroProduto.controls["filtro"].value == "1") {
              /* Código */

              this.formFiltroProduto.controls["codigo"].setErrors(null);
            } else if (this.formFiltroProduto.controls["filtro"].value == "2") {
              /* Descrição */

              this.formFiltroProduto.controls["descricao"].setErrors(null);
            } else if (this.formFiltroProduto.controls["filtro"].value == "3") {
              /* Marca */

              this.formFiltroProduto.controls["marca"].setErrors(null);
            } else if (this.formFiltroProduto.controls["filtro"].value == "4") {
              /* Referência */

              this.formFiltroProduto.controls["referencia"].setErrors(null);
            }

            this.formFiltroProduto.updateValueAndValidity();
          } else {
            return;
          }
        }

        // PART C: usar produtosOriginal como base, não uma cópia antiga
        const filtro = String(this.formFiltroProduto.controls["filtro"].value);
        const status = String(this.formFiltroProduto.controls["status"].value || '0');

        const termoCodigo = String(this.formFiltroProduto.controls["codigo"].value || '').trim();
        const termoDesc = String(this.formFiltroProduto.controls["descricao"].value || '').trim().toUpperCase();
        const termoMarca = String(this.formFiltroProduto.controls["marca"].value || '').trim().toUpperCase();
        const termoRef = String(this.formFiltroProduto.controls["referencia"].value || '').trim().toUpperCase();

        // Sempre parte de produtosOriginal (base) e não de produtos já filtrado
        const base = (this.produtosOriginal || []).filter(p => p != null && (!this.somentePromocoes || Number(p.promocao) === 1));

        let filtrou: boolean = false;
        let produtosProcessados = base.map(p => {
          const clone: any = { ...p };
          clone.exibir = true;
          return clone;
        });

        if (filtro === '0') {
          /* Campanha */
          const clienteIdFiltro: number = (this.clienteSelecionado != null ? this.clienteSelecionado.id : null);
          const vendedorIdFiltro: number = (this.vendedorSelecionado != null ? this.vendedorSelecionado.id : null);

          produtosProcessados.forEach((item) => {
            if (item.categoria == this.campanhas) {
              const temClienteVinculado: boolean = (item.clientesVinculados != null && item.clientesVinculados.length > 0);
              const temVendedorVinculado: boolean = (item.vendedoresVinculados != null && item.vendedoresVinculados.length > 0);

              if (!temClienteVinculado && !temVendedorVinculado) {
                /* Sem restrições — exibir para todos */
                item.exibir = true;
              } else {
                /* OR: exibir se o cliente ou o vendedor estiver na lista */
                const clienteMatch: boolean = (temClienteVinculado && clienteIdFiltro != null && item.clientesVinculados.indexOf(clienteIdFiltro) !== -1);
                const vendedorMatch: boolean = (temVendedorVinculado && vendedorIdFiltro != null && item.vendedoresVinculados.indexOf(vendedorIdFiltro) !== -1);
                item.exibir = clienteMatch || vendedorMatch;
              }
            } else {
              item.exibir = false;
            }
          });
        } else if (filtro === '1') {
          /* Código */
          if (termoCodigo !== '') {
            produtosProcessados.forEach((item) => {
              const cod = this.obterCodigoProduto(item);
              item.exibir = cod === termoCodigo;
            });
            filtrou = true;
          }
        } else if (filtro === '2') {
          /* Descrição */
          if (termoDesc !== '') {
            let palavras: string[] = termoDesc.split(" ");

            produtosProcessados.forEach((item) => {
              let qtdePalavrasEncontradasProduto: number = 0;

              palavras.forEach((subItem) => {
                if (item.name != null && item.name != "") {
                  if (item.name.toLowerCase().indexOf(subItem.toLowerCase()) !== -1) {
                    qtdePalavrasEncontradasProduto++;
                  }
                }
              });

              if (qtdePalavrasEncontradasProduto == palavras.length) {
                item.exibir = true;
              } else {
                item.exibir = false;
              }

              /* Produtos Vinculados */

              if (!item.exibir) {
                if (item.produtos_vinculados != null) {
                  let porProdutoVinculado: ProdutoPromocional[] = item.produtos_vinculados.filter(produtosVinculados => {
                    let qtdePalavrasEncontradasCampanha: number = 0;

                    palavras.forEach((subItem) => {
                      if (produtosVinculados.name.toLowerCase().indexOf(subItem.toLowerCase()) !== -1 && !produtosVinculados.bonificacao) {
                        qtdePalavrasEncontradasCampanha++;
                      }
                    });

                    return qtdePalavrasEncontradasCampanha == palavras.length;
                  });

                  if (porProdutoVinculado.length > 0) {
                    item.exibir = true;
                  }
                }
              }
            });

            filtrou = true;
          }
        } else if (filtro === '3') {
          /* Marca */
          if (termoMarca !== '') {
            produtosProcessados.forEach((item) => {
              if (item.grupo_estoque == null) {
                item.exibir = false;
              } else if (item.grupo_estoque.toLowerCase().indexOf(termoMarca.toLowerCase()) !== -1) {
                item.exibir = true;
              }
            });

            filtrou = true;
          }
        } else if (filtro === '4') {
          /* Referência */
          if (termoRef !== '') {
            produtosProcessados.forEach((item) => {
              if (item.referencia_cliente == null) {
                item.exibir = false;
              } else if (item.referencia_cliente.toLowerCase().indexOf(termoRef.toLowerCase()) !== -1) {
                item.exibir = true;
              }
            });

            filtrou = true;
          }
        }

        let produtosFiltrados = produtosProcessados.filter(produto => produto.exibir);

        if (filtro !== '0') {
          /* Status */

          if (status === '0') {
            /* Todos */

          } else if (status === '1') {
            /* Novo Item */

            if (produtosFiltrados.length > 0 || filtrou) {
              produtosFiltrados.forEach((item) => {
                if (item.ultima_compra != null) {
                  item.exibir = false;
                } else {
                  item.exibir = true;
                }
              });

              produtosFiltrados = produtosFiltrados.filter(produto => produto.exibir);
            } else {
              produtosProcessados.forEach((item) => {
                if (item.ultima_compra != null) {
                  item.exibir = false;
                } else {
                  item.exibir = true;
                }
              });

              produtosFiltrados = produtosProcessados.filter(produto => produto.exibir);
            }
          } else if (status === '2') {
            /* Item Reposição */

            if (produtosFiltrados.length > 0 || filtrou) {
              produtosFiltrados.forEach((item) => {
                if (item.ultima_compra == null) {
                  item.exibir = false;
                } else {
                  item.exibir = true;
                }
              });

              produtosFiltrados = produtosFiltrados.filter(produto => produto.exibir);
            } else {
              produtosProcessados.forEach((item) => {
                if (item.ultima_compra == null) {
                  item.exibir = false;
                } else {
                  item.exibir = true;
                }
              });

              produtosFiltrados = produtosProcessados.filter(produto => produto.exibir);
            }
          }
        }

        if (produtosFiltrados.length == 0) {
          this.toastr.error("", "Nenhum produto localizado!");

          this.saldoGeradoErro = false;
          this.filtrandoProduto = false;
        } else {
          produtosProcessados.forEach((item) => {
            if (!item.exibir) {
              let produtosSimilaresFiltrados = this.produtosSimilares.filter(produtoSimilar => produtoSimilar.product_similar == item.id);

              produtosSimilaresFiltrados.forEach((subItem) => {
                let produtoSimilar = produtosProcessados.find(produto => produto.id == subItem.product_id);

                if (produtoSimilar != null && produtoSimilar.exibir) {
                  item.exibir = true;
                }
              });
            }
          });

          this.produtos = produtosProcessados.filter(produto => produto.exibir);

          this.produtos.forEach((produto) => {
            if (((produto.qtde != 0 && produto.qtde != null) || (produto.qtde_bonificada != 0 && produto.qtde_bonificada != null)) && (produto.valor != 0 && produto.valor != null)) {
              produto.expandido = true;
            } else {
              produto.expandido = false;
            }
          });

          if (status === '2') {
            /* Item Reposição */

            this.produtos = [...this.produtos].sort((a, b) => {
              const compare = (v1, v2) => v1 == null ? -1 : v1 < v2 ? -1 : v1 > v2 ? 1 : 0;

              return compare(a["ultima_compra"], b["ultima_compra"]) * -1; /* Decrescente */
            });
          } else {
            this.produtos = [...this.produtos].sort((a, b) => {
              const compare = (v1, v2) => v1 == null ? -1 : v1 < v2 ? -1 : v1 > v2 ? 1 : 0;

              return compare(a["categoria"], b["categoria"]);
            });

            this.produtos = [...this.produtos].sort((a, b) => {
              const compare = (v1, v2) => v1 == null ? -1 : v1 < v2 ? -1 : v1 > v2 ? 1 : 0;

              return compare(a["name"], b["name"]);
            });
          }



          this.filtrandoProduto = true;

          // Forçar change detection para renderizar viewport
          this.changeDetectorRef.markForCheck();

        }

        // debug específico do código citado
        if (filtro === '1' && termoCodigo !== '') {
          const achou = this.produtos.some(p => this.obterCodigoProduto(p) === termoCodigo && p.exibir);
        }

        setTimeout(() => {
          try {


            // Forçar novo markForCheck
            this.changeDetectorRef.markForCheck();


            if (this.adicionarItensProdutos) {

              this.adicionarItensProdutos.checkViewportSize();

              this.adicionarItensProdutos.scrollToIndex(0);

            } else {

            }
          } catch (e) {

          }
        }, 0);
      }

      this.ajustarElementos();
    });
  }

  organizarFiltroProduto() {
    if (this.formFiltroProduto.controls["filtro"].value == "0") {
      /* Campanha */

      this.formFiltroProduto.get("codigo").disable();
      this.formFiltroProduto.get("descricao").disable();
      this.formFiltroProduto.get("marca").disable();
      this.formFiltroProduto.get("referencia").disable();
    } else if (this.formFiltroProduto.controls["filtro"].value == "1") {
      /* Código */

      this.formFiltroProduto.get("codigo").enable();
      this.formFiltroProduto.get("descricao").disable();
      this.formFiltroProduto.get("marca").disable();
      this.formFiltroProduto.get("referencia").disable();
    } else if (this.formFiltroProduto.controls["filtro"].value == "2") {
      /* Descrição */

      this.formFiltroProduto.get("codigo").disable();
      this.formFiltroProduto.get("descricao").enable();
      this.formFiltroProduto.get("marca").disable();
      this.formFiltroProduto.get("referencia").disable();
    } else if (this.formFiltroProduto.controls["filtro"].value == "3") {
      /* Marca */

      this.formFiltroProduto.get("codigo").disable();
      this.formFiltroProduto.get("descricao").disable();
      this.formFiltroProduto.get("marca").enable();
      this.formFiltroProduto.get("referencia").disable();
    } else if (this.formFiltroProduto.controls["filtro"].value == "4") {
      /* Referência */

      this.formFiltroProduto.get("codigo").disable();
      this.formFiltroProduto.get("descricao").disable();
      this.formFiltroProduto.get("marca").disable();
      this.formFiltroProduto.get("referencia").enable();
    }
  }

  reiniciarFiltroProduto() {
    let filtroInicial: string = "2";

    this.formFiltroProduto.reset();

    this.formFiltroProduto.controls["filtro"].setValue(filtroInicial);
    this.formFiltroProduto.controls["status"].setValue("0");

    this.filtroProdutoSelecionado = filtroInicial;

    this.organizarFiltroProduto();

    this.enviadoProduto = false;
    this.filtrandoProduto = false;

    this.reiniciarProdutosDoModal('reiniciarFiltroProduto');
  }

  private aplicarFiltroPorPromocao(): void {
    this.produtos = this.produtos.filter(p => Number(p.promocao) === 1);
    this.filtrandoProduto = true;
    if (this.produtos.length > 0) {
      this.filtrandoProduto = true;
      setTimeout(() => {
        try {
          if (this.adicionarItensProdutos) {
            this.adicionarItensProdutos.checkViewportSize();
            this.adicionarItensProdutos.scrollToIndex(0);
          }
        } catch (e) { }
      }, 0);
    }
  }

  toggleSomentePromocoes(): void {
    this.somentePromocoes = !this.somentePromocoes;
    this.reiniciarFiltroProduto();
    this.filtrandoProduto = true;
  }

  /* Método para alterarFiltroProduto - cancelar/mudar filtro */

  alterarFiltroProduto(_valor: any): void {
    this.enviadoProduto = false;
    this.filtrandoProduto = false;

    // Se um valor foi passado, atualizar o filtro
    if (_valor != null) {
      this.formFiltroProduto.patchValue({
        filtro: String(_valor),
        codigo: '',
        descricao: '',
        marca: '',
        referencia: '',
        status: '0'
      });
      this.filtroProdutoSelecionado = String(_valor);
    } else {
      // Caso contrário, apenas resetar os campos de busca
      this.formFiltroProduto.patchValue({
        codigo: '',
        descricao: '',
        marca: '',
        referencia: '',
        status: '0'
      });
    }

    this.organizarFiltroProduto();
    this.reiniciarProdutosDoModal('alterarFiltroProduto');
  }

  /* Filtro (Produtos (Campanhas)) */

  alterarFiltroProdutoCampanha() {
    this.reiniciarDadosProdutoCampanha(true);

    this.formFiltroProdutoCampanha.reset();

    this.enviadoProdutoCampanha = false;
    this.filtrandoProdutoCampanha = false;
  }

  filtrarProdutoCampanha() {
    this.enviadoProdutoCampanha = true;

    if (this.formFiltroProdutoCampanha.invalid) {
      return;
    }

    this.reiniciarDadosProdutoCampanha(false);

    /* Descrição */

    if (this.formFiltroProdutoCampanha.controls["descricao"].value != "" && this.formFiltroProdutoCampanha.controls["descricao"].value != null) {
      let palavras: string[] = this.formFiltroProdutoCampanha.controls["descricao"].value.toString().split(" ");

      this.produtoCampanhaSelecionado.produtos_vinculados.forEach((item) => {
        if (!item.bonificacao) {
          let qtdePalavrasEncontradasProdutoCampanha: number = 0;

          palavras.forEach((subItem) => {
            if (item.name.toLowerCase().indexOf(subItem.toLowerCase()) !== -1) {
              qtdePalavrasEncontradasProdutoCampanha++;
            }
          });

          if (qtdePalavrasEncontradasProdutoCampanha == palavras.length) {
            item.exibir = true;
          }
        }
      });

      this.filtrandoProdutoCampanha = true;
    }
  }

  reiniciarDadosProdutoCampanha(exibir: boolean) {
    this.produtoCampanhaSelecionado.produtos_vinculados.forEach((item) => {
      if (!item.bonificacao) {
        item.exibir = exibir;
      }
    });
  }

  /* Formatação */

  formatarValoresQuatroCasasDecimais(valor: number, porcentagem?: boolean, zero?: boolean): string {
    if (valor != null) {
      if (porcentagem) {
        return (valor).toLocaleString("pt-BR", {
          minimumFractionDigits: 4,
          maximumFractionDigits: 4
        });
      } else {
        return (valor).toLocaleString("pt-BR", {
          style: "currency",
          currency: "BRL",
          minimumFractionDigits: 4,
          maximumFractionDigits: 4
        });
      }
    } else {
      if (zero) {
        return (0).toLocaleString("pt-BR", {
          style: "currency",
          currency: "BRL",
          minimumFractionDigits: 4,
          maximumFractionDigits: 4
        });
      }

      return null;
    }
  }
  removerLoteProduto(id_produto: number) {
    let produto = this.produtos.find(produto => produto.id == id_produto);

    if (produto != null) {
      produto.erro_lote = false;
      produto.erro_qtde = false;
      produto.erro_valor = false;

      produto.valor_tabela = 0;

      produto.qtde = null;
      produto.valor = null;

      produto.valor_total = 0;
      produto.porcentagem_desconto = 0;
      produto.descritivo_desconto = null;
      produto.observacao_item = null;

      produto.saldo_gerado = 0;

      /* Lote */

      produto.id_lote = null;
      produto.nome_lote = null;
      produto.cod_lote = null;
      produto.estoque_lote = null;
      produto.validade_lote = null;
      produto.preco_lote = null;

      /* Imposto */

      produto.valor_imposto = 0;
      produto.valor_imposto_unitario = 0;
      produto.valor_imposto_produto = null;
      produto.valor_imposto_total = 0;

      produto.valor_imposto_total_final = 0;

      produto.valor_unitario_final = 0;

      /* Ordem */

      produto.ordem = 0;

      /* Qtde (Bonificada) */

      produto.qtde_bonificada = null;

      /* Total Fracionado */

      produto.valor_unitario_fracionado = null;
      produto.valor_unitario_imposto_fracionado = null;

      /* Porcentagem Desconto Temporária */

      produto.porcentagem_desconto_temporaria = null;
      produto.desconto_digitado = null;


      produto.estado_preco = null;
      produto.preco_base_api = null;
      this.limparEstadoTabelaEspecial(produto);
    }
  }

  selecionarLoteProduto(id_lote: number) {
    if (this.produtoLotesSelecionado != null) {
      let produto = this.produtos.find(produto => produto.id == this.produtoLotesSelecionado.id);

      if (produto != null) {
        let produtoLote = this.produtoLotes.find(produtoLote => produtoLote.id == id_lote);

        if (produtoLote != null) {
          produto.erro_lote = false;

          this.limparEstadoTabelaEspecial(produto);

          produto.estado_preco = null;
          produto.preco_base_api = null;
          produto.valor_tabela = produtoLote.preco;

          produto.valor = null;

          /* Lote */

          produto.id_lote = produtoLote.id;
          produto.nome_lote = produtoLote.nomelote;
          produto.cod_lote = produtoLote.codlote;
          produto.estoque_lote = produtoLote.estoque;
          produto.validade_lote = produtoLote.validade;
          produto.preco_lote = produtoLote.preco;

          this.validarProdutoQtde(produto.id, true);
          this.validarProdutoValor(produto.id, true);
        }

        this.produtoLotesSelecionado = produto;
      }
    }

    this.modalReferenciaSelecionarLote.close();
  }

  /* Modal */
  modalAdicionarItensCampanha(content: any, id_campanha: number) {
    if (id_campanha != 0) {
      let produtoCampanhaSelecionado: ProdutoPromocional = this.produtos.find(produto => produto.id_campanha == id_campanha);

      this.produtoCampanhaSelecionado = JSON.parse(JSON.stringify(produtoCampanhaSelecionado));

      let produtoAdicionado: ProdutoPromocional = this.produtosAdicionados.find(produtoAdicionado => produtoAdicionado.id_campanha == id_campanha);

      console.log("Campanha selecionada: " + produtoCampanhaSelecionado[1]);
      if (produtoAdicionado == null) {
        /* Bonificação */

        this.localizarProdutoBonificado();
        this.definirQtdeBonificacaoMultiplicavel(false);
      } else {
        this.validarCampanhaQtdeGeral();
      }

      /* Bonificação */

      this.bonificacaoInvalida = false;

      this.calcularImpostoCampanhaProduto();
      this.recalcularUnitarioCampanhaPorPrazo();
    }

    this.modalService.open(content, {
      ariaLabelledBy: "titulo-adicionar-itens-campanha",
      size: "xl",
      backdrop: "static"
    }).result.then((acao) => {
      if (acao == "Salvar") {
        if (this.validarErrosCampanha()) {
          this.definirOrdemInclusao(this.produtoCampanhaSelecionado.id, true);

          const repassarDadosCampanha = this.repassarDadosCampanha(false);

          repassarDadosCampanha.then(() => {
            /* Produtos Original p/ Produtos Adicionados */

            this.produtosAdicionados = JSON.parse(JSON.stringify(this.produtosOriginal.filter(produtoOriginal => produtoOriginal.qtde > 0 && produtoOriginal.valor > 0)));

            /* Totalizar */

            this.totalizarProdutoCampanhaSelecionado();

            this.atualizarDadosCampanha(this.produtoCampanhaSelecionado.id_campanha);

            this.produtoCampanhaSelecionado = null;
          });
        } else {
          this.modalAdicionarItensCampanha(content, 0);
        }
      } else {
        this.alterarFiltroProdutoCampanha();
        this.repassarDadosCampanha(true);

        this.produtoCampanhaSelecionado = null;
      }
    }, () => {
      this.alterarFiltroProdutoCampanha();
      this.repassarDadosCampanha(true);

      this.produtoCampanhaSelecionado = null;
    });
  }

  modalAdicionarItensEstoqueLocal(content: any, id_produto: number) {
    this.produtoLocais = null;

    /* Produto (Lotes) */

    this.produtoService.getProdutoLocalByIdProduto(id_produto).subscribe(
      produtoLocal => this.produtoLocais = produtoLocal,
      error => { /* handle error silently */ },
      () => {
        if (this.produtoLocais.length > 0) {
          this.modalService.open(content, {
            ariaLabelledBy: "titulo-adicionar-itens-estoque-local",
            size: "lg",
            backdrop: "static"
          });
        } else {
          this.toastr.error("", "Nenhum estoque local encontrado!");
        }
      }
    );
  }

  modalAdicionarItensFotos(content: any, id_produto: number) {
    this.produtoFotosSelecionado = null;

    /* Produto (Fotos) */

    this.produtoService.getProdutoFotosByIdProduto(id_produto).subscribe(
      produtoFoto => this.produtoFotos = produtoFoto,
      error => { /* handle error silently */ },
      () => {
        if (this.produtoFotos.length > 0) {
          this.produtoFotos.forEach((item) => {
            item.imagem = "data:image/png;base64," + item.imagem;
          });

          this.produtoFotosSelecionado = this.produtos.find(produto => produto.id == id_produto);

          this.modalService.open(content, {
            ariaLabelledBy: "titulo-adicionar-itens-fotos",
            size: "lg",
            backdrop: "static"
          });
        } else {
          this.toastr.error("", "Nenhuma foto encontrada!");
        }
      }
    );
  }

  modalAdicionarItensInformacoes(content: any, id_produto: number) {
    this.produtoInformacoesSelecionado = null;

    /* Produto (Ficha Técnica) */

    this.produtoService.getFichaTecnicaByIdProduto(id_produto).subscribe(
      produtosFichasTecnicas => this.produtoFichasTecnicas = produtosFichasTecnicas,
      error => { /* handle error silently */ },
      () => {
        this.produtoInformacoesSelecionado = this.produtos.find(produto => produto.id == id_produto);

        if (this.produtoFichasTecnicas.length > 0 || (this.produtoInformacoesSelecionado.ficha_tecnica != null && this.produtoInformacoesSelecionado.ficha_tecnica != "")) {
          this.modalService.open(content, {
            ariaLabelledBy: "titulo-adicionar-itens-informacoes",
            size: "lg",
            backdrop: "static"
          });
        } else {
          this.toastr.error("", "Nenhuma informação encontrada!");
        }
      }
    );
  }

  modalAdicionarItensLotes(content: any, id_produto: number) {
    this.produtoLotesSelecionado = null;

    /* Produto (Lotes) */

    this.produtoService.getProdutoLoteByIdProduto(id_produto, this.obs_gerais, this.clienteSelecionado.id, this.formaPagamentoSelecionada.id).subscribe(
      produtoLote => this.produtoLotes = produtoLote,
      error => { /* handle error silently */ },
      () => {
        if (this.produtoLotes.length > 0) {
          this.produtoLotesSelecionado = this.produtos.find(produto => produto.id == id_produto);

          this.modalReferenciaSelecionarLote = this.modalService.open(content, {
            ariaLabelledBy: "titulo-adicionar-itens-lotes",
            size: "lg",
            backdrop: "static"
          });
        } else {
          this.toastr.error("", "Nenhum lote encontrado!");
        }
      }
    );
  }

  modalAdicionarItensTabelas(content: any, id_produto: number, id_lote: number) {
    this.produtoTabelasSelecionado = null;

    let produto = this.produtos.find(produto => produto.id == id_produto);

    if (produto != null) {
      if (produto.qtde_lote > 0 && produto.id_lote == null) {
        this.toastr.error("", "Nenhum lote selecionado!");

        return;
      }

      /* Produto (Tabelas) */

      let idPrazoPagamento: number = null;

      if (this.prazoPagamentoSelecionado != null && this.configuracao != null && this.configuracao.prazo_pagamento_antes_itenspedido) {
        idPrazoPagamento = this.prazoPagamentoSelecionado.idprazopagamento;
      }

      this.produtoService.getTabelaByProduto(this.clienteSelecionado.id, this.vendedorSelecionado.id, id_produto, id_lote, idPrazoPagamento).subscribe(
        produtoTabela => this.produtoTabelas = produtoTabela,
        error => {
          this.produtoTabelas = [];
          this.toastr.error("", "Erro ao buscar tabelas promocionais...");
        },
        () => {
          if (this.produtoTabelas.length > 0) {
            this.produtoTabelasSelecionado = produto;

            this.produtoTabelas.forEach((item) => {
              if (produto.valorunidade != null && produto.valorunidade > 0) {
                item.preco_fracionado = item.preco / produto.valorunidade;
              } else {
                item.preco_fracionado = item.preco;
              }
            });

            this.modalReferenciaTabelasProdutos = this.modalService.open(content, {
              ariaLabelledBy: "titulo-adicionar-itens-tabelas",
              size: "lg",
              backdrop: "static"
            });
          } else {
            this.toastr.error("", "Nenhuma tabela encontrada!");
          }
        }
      );
    }
  }

  calcularDescontoUnitario(id_produto: number, alterar: boolean, adicionado: boolean) {
    const produto: ProdutoPromocional = adicionado
      ? this.produtosAdicionados.find(produtoAdicionado => produtoAdicionado.id == id_produto)
      : this.produtos.find(produto => produto.id == id_produto);

    if (produto == null) { return; }

    this.garantirEstadoPreco(produto);

    const qtde: number = produto.qtde != null && produto.qtde > 0 ? produto.qtde : 0;
    const base: number = this.lerBaseDesconto(produto);
    const percentual: number = produto.porcentagem_desconto_temporaria;

    if (alterar && percentual != null && !isNaN(percentual) && isFinite(percentual)) {
      if (percentual > 0 && percentual <= 100) {
        this.aplicarPercentualDesconto(produto, percentual);

        if (produto.valor != null && produto.valor > 0) {
          produto.valor_total = parseFloat((produto.valor * qtde).toFixed(2));

          if (produto.qtde != null && produto.qtde > 0) { produto.erro_valor = false; }
        }

        const descontoMaximo: number = this.obterDescontoMaximoProduto(produto);
        if (descontoMaximo != null && percentual > descontoMaximo) { produto.erro_valor = true; }
      } else {
        produto.porcentagem_desconto_temporaria = null;
        produto.desconto_digitado = null;
      }
    } else if (this.porcentagemDescontoTemporario != null && (percentual == null || percentual == 0)) {
      produto.valor = this.formatacaoService.quatroCasasDecimais(base);
      produto.valor_total = parseFloat((base * qtde).toFixed(2));
    } else {
      this.atualizarDescontoAPartirDoValor(produto);
    }

    this.calcularFatorFinanceiroProduto(id_produto, adicionado);
  }

  calcularDescontoUnitarioNovo(id_produto: number, alterar: boolean, adicionado: boolean) {
    this.calcularDescontoUnitario(id_produto, alterar, adicionado);
  }

  /* Fator Financeiro */

  calcularFatorFinanceiro() {
    this.exibirFatorFinanceiro = false;

    if (this.prazoPagamentoSelecionado != null && this.configuracao != null && !this.configuracao.prazo_pagamento_antes_itenspedido && this.configuracao.utiliza_fator_financeiro) {
      /* Produtos Original */

      this.produtosOriginal.forEach((item) => {
        if (item.produtos_vinculados != null) {
          /* Produtos Vinculados */

          item.produtos_vinculados.forEach((subItem) => {
            let qtde: number = subItem.qtde != null && subItem.qtde > 0 ? subItem.qtde : 0;
            let valorCalculoInicial: number = subItem.price_promotional != null && subItem.price_promotional > 0 ? subItem.price_promotional : subItem.price;

            if (subItem.aplica_fator_financeiro) {
              /* C/ Fator */

              /* Inicial */

              subItem.porcentagem_fator_inicial = this.prazoPagamentoSelecionado.fator_financeiro;

              let valorFatorFinanceiroTabela: number = (valorCalculoInicial + ((valorCalculoInicial * this.prazoPagamentoSelecionado.fator_financeiro) / 100));

              subItem.valor_fator_financeiro_tabela = parseFloat(valorFatorFinanceiroTabela.toFixed(2));

              let valorFatorFinanceiroInicial: number = subItem.valor_fator_financeiro_tabela - valorCalculoInicial;

              subItem.valor_fator_financeiro_inicial = this.formatacaoService.quatroCasasDecimais(valorFatorFinanceiroInicial);

              subItem.valor_fator_financeiro_tabela_fracionado = !subItem.fracionado ? 0 : (subItem.valor_fator_financeiro_tabela > 0 && subItem.valorunidade > 0) ? (subItem.valor_fator_financeiro_tabela / subItem.valorunidade) : 0;

              /* Processado */

              if (qtde > 0) {
                let valorFatorFinanceiro: number = subItem.valor_fator_financeiro_inicial * qtde;

                subItem.valor_fator_financeiro = this.formatacaoService.quatroCasasDecimais(valorFatorFinanceiro);
              } else {
                subItem.valor_fator_financeiro = 0;
              }

              if (subItem.valor_fator_financeiro_inicial > 0) {
                subItem.valor_fator_financeiro_unitario = this.formatacaoService.quatroCasasDecimais(subItem.valor_fator_financeiro_inicial);
              } else {
                subItem.valor_fator_financeiro_unitario = null;
              }

              let valorFatorFinanceiroProduto: number = valorCalculoInicial + subItem.valor_fator_financeiro_inicial;

              subItem.valor_fator_financeiro_produto = this.formatacaoService.quatroCasasDecimais(valorFatorFinanceiroProduto);

              let valorFatorFinanceiroTotal: number = valorFatorFinanceiroProduto * qtde;

              subItem.valor_fator_financeiro_total = parseFloat(valorFatorFinanceiroTotal.toFixed(2));

              if (subItem.valor_fator_financeiro != 0) {
                this.exibirFatorFinanceiro = true;
              }
            } else {
              /* S/ Fator */

              /* Inicial */

              subItem.porcentagem_fator_inicial = 0;
              subItem.valor_fator_financeiro_tabela = 0;
              subItem.valor_fator_financeiro_inicial = 0;
              subItem.valor_fator_financeiro_tabela_fracionado = 0;

              /* Processado */

              subItem.valor_fator_financeiro = 0;
              subItem.valor_fator_financeiro_unitario = null;
              subItem.valor_fator_financeiro_produto = this.formatacaoService.quatroCasasDecimais(valorCalculoInicial);

              let valorFatorFinanceiroTotal: number = valorCalculoInicial * qtde;

              subItem.valor_fator_financeiro_total = parseFloat(valorFatorFinanceiroTotal.toFixed(2));
            }

            /* Pontuação */

            if (this.exibirPontuacao) {
              const produtoBaseSubItem = this.produtosOriginal.find((p) => p.id == subItem.id && p.categoria != this.campanhas);

              if (produtoBaseSubItem != null) {
                subItem.pontuacao = produtoBaseSubItem.pontuacao;
                subItem.valor_litragem = produtoBaseSubItem.valor_litragem;
              }

              const pontuacaoSubItem: number = subItem.pontuacao != null ? subItem.pontuacao : 0;
              const litragemSubItem: number = subItem.valor_litragem != null ? subItem.valor_litragem : 0;
              const fatorPontuacaoSubItem: number = this.prazoPagamentoSelecionado != null && this.prazoPagamentoSelecionado.fator_pontuacao != null ? this.prazoPagamentoSelecionado.fator_pontuacao : 0;

              if (pontuacaoSubItem > 0 && litragemSubItem > 0 && qtde > 0) {
                const pontuacaoFinalSubItem: number = qtde * pontuacaoSubItem * litragemSubItem * (1 + (fatorPontuacaoSubItem / 100));
                subItem.pontuacao_calculada = Math.round(pontuacaoFinalSubItem > 0 ? pontuacaoFinalSubItem : 0);
              } else {
                subItem.pontuacao_calculada = 0;
              }
            }
          });

          /* Produtos (Produtos Vinculados) */

          let qtde: number = item.qtde != null && item.qtde > 0 ? item.qtde : 0;
          let valorCalculoInicialParcial: number = item.produtos_vinculados.filter(produtosVinculados => !produtosVinculados.bonificacao && produtosVinculados.aplica_fator_financeiro).reduce((sum, current) => (sum + current.valor_total), 0);
          let valorCalculoInicialTotal: number = item.produtos_vinculados.filter(produtosVinculados => !produtosVinculados.bonificacao).reduce((sum, current) => (sum + current.valor_total), 0);

          /* Inicial */

          if (item.grupo_estoque == this.combo && qtde == 0) {
            item.porcentagem_fator_inicial = 0;
            item.valor_fator_financeiro_tabela = 0;
            item.valor_fator_financeiro_inicial = 0;
            item.valor_fator_financeiro_tabela_fracionado = 0;
          } else {
            item.porcentagem_fator_inicial = this.prazoPagamentoSelecionado.fator_financeiro;

            let valorFatorFinanceiroTabela: number = (valorCalculoInicialTotal + ((valorCalculoInicialParcial * this.prazoPagamentoSelecionado.fator_financeiro) / 100));

            item.valor_fator_financeiro_tabela = parseFloat(valorFatorFinanceiroTabela.toFixed(2));

            let valorFatorFinanceiroInicial: number = item.valor_fator_financeiro_tabela - valorCalculoInicialTotal;

            item.valor_fator_financeiro_inicial = this.formatacaoService.quatroCasasDecimais(valorFatorFinanceiroInicial);

            item.valor_fator_financeiro_tabela_fracionado = !item.fracionado ? 0 : (item.valor_fator_financeiro_tabela > 0 && item.valorunidade > 0) ? (item.valor_fator_financeiro_tabela / item.valorunidade) : 0;
          }

          /* Processado */

          let valorFatorFinanceiroUnitario: number = item.produtos_vinculados.filter(produtosVinculados => !produtosVinculados.bonificacao).reduce((sum, current) => (sum + current.valor_fator_financeiro), 0);
          let valorFatorFinanceiroTotal: number = item.produtos_vinculados.filter(produtosVinculados => !produtosVinculados.bonificacao).reduce((sum, current) => (sum + current.valor_fator_financeiro_total), 0);
          let valorFatorFinanceiro: number = valorFatorFinanceiroUnitario * qtde;

          item.valor_fator_financeiro = this.formatacaoService.quatroCasasDecimais(valorFatorFinanceiro);

          if (valorFatorFinanceiroUnitario > 0) {
            item.valor_fator_financeiro_unitario = this.formatacaoService.quatroCasasDecimais(valorFatorFinanceiroUnitario);
          } else {
            item.valor_fator_financeiro_unitario = null;
          }

          item.valor_fator_financeiro_produto = this.formatacaoService.quatroCasasDecimais(valorFatorFinanceiroTotal);

          let valorFatorFinanceiroTotalCampanha: number = 0;

          if (item.grupo_estoque == this.combo) {
            valorFatorFinanceiroTotalCampanha = item.valor_total;
          } else {
            qtde = qtde > 0 ? qtde : 1;

            valorFatorFinanceiroTotalCampanha = valorFatorFinanceiroTotal * qtde;
          }

          item.valor_fator_financeiro_total = parseFloat(valorFatorFinanceiroTotalCampanha.toFixed(2));

          /* Pontuação (Campanha - Total) */

          if (this.exibirPontuacao) {
            const campanhaQtdePon: number = item.qtde != null && item.qtde > 0 ? item.qtde : 0;
            const pontuacaoSubItensTotal: number = item.produtos_vinculados
              .filter((pv) => !pv.bonificacao)
              .reduce((sum, pv) => sum + (pv.pontuacao_calculada != null ? pv.pontuacao_calculada : 0), 0);
            item.pontuacao_calculada = pontuacaoSubItensTotal * campanhaQtdePon;
          }
        } else {
          /* Produtos */

          let qtde: number = item.qtde != null && item.qtde > 0 ? item.qtde : 0;
          let valor: number = item.valor != null ? item.valor : 0;

          if (item.aplica_fator_financeiro && item.qtde_lote == 0) {
            /* C/ Fator */

            /* Inicial */

            let valorCalculoInicial: number;

            const precoBase: number = item.preco_base_calculo_fator != null && item.preco_base_calculo_fator > 0
              ? item.preco_base_calculo_fator
              : item.price;
            const baseSemFatorItem: number = item.estado_preco != null ? this.obterBaseSemFatorItem(item) : 0;

            if (!this.ehPrecoPromocionalTravado(item) && baseSemFatorItem > 0) {
              valorCalculoInicial = baseSemFatorItem;
            } else {
              valorCalculoInicial = item.valor_tabela != null && item.valor_tabela > 0 ? item.valor_tabela : precoBase;
            }

            item.porcentagem_fator_inicial = this.prazoPagamentoSelecionado.fator_financeiro;

            let valorFatorFinanceiroTabela: number = (valorCalculoInicial + ((valorCalculoInicial * this.prazoPagamentoSelecionado.fator_financeiro) / 100));

            item.valor_fator_financeiro_tabela = parseFloat(valorFatorFinanceiroTabela.toFixed(2));

            let valorFatorFinanceiroInicial: number = item.valor_fator_financeiro_tabela - valorCalculoInicial;

            item.valor_fator_financeiro_inicial = this.formatacaoService.quatroCasasDecimais(valorFatorFinanceiroInicial);

            item.valor_fator_financeiro_tabela_fracionado = !item.fracionado ? 0 : (item.valor_fator_financeiro_tabela > 0 && item.valorunidade > 0) ? (item.valor_fator_financeiro_tabela / item.valorunidade) : 0;

            /* Processado */

            let valorAtualizado: number = this.calcularValorProdutoOriginal(item);

            if (valorAtualizado != null) {
              let valorTotal: number = valorAtualizado * qtde;

              item.valor_total = parseFloat(valorTotal.toFixed(2));

              valor = valorAtualizado;
            }

            item.valor = valorAtualizado; /* Atualiza valor */

            let valorFatorFinanceiro: number = (((valor * qtde) * item.porcentagem_fator_inicial) / 100);

            item.valor_fator_financeiro = this.formatacaoService.quatroCasasDecimais(valorFatorFinanceiro);

            let valorFatorFinanceiroUnitario: number = 0;

            if (qtde != null && qtde > 0) {
               valorFatorFinanceiroUnitario = valorFatorFinanceiro / qtde;
            }

            if (valorFatorFinanceiroUnitario > 0) {
              item.valor_fator_financeiro_unitario = this.formatacaoService.quatroCasasDecimais(valorFatorFinanceiroUnitario);
            } else {
              item.valor_fator_financeiro_unitario = null;
            }

            item.valor_fator_financeiro_produto = this.formatacaoService.quatroCasasDecimais(valor);

            let valorFatorFinanceiroTotal: number = valor * qtde;

            item.valor_fator_financeiro_total = parseFloat(valorFatorFinanceiroTotal.toFixed(2));

            if (item.valor_fator_financeiro != 0) {
              this.exibirFatorFinanceiro = true;
            }
          } else {
            /* S/ Fator */

            /* Inicial */

            item.porcentagem_fator_inicial = 0;
            item.valor_fator_financeiro_tabela = 0;
            item.valor_fator_financeiro_inicial = 0;
            item.valor_fator_financeiro_tabela_fracionado = 0;

            /* Processado */

            let valorAtualizado: number = this.calcularValorProdutoOriginal(item);

            if (valorAtualizado != null) {
              let valorTotal: number = valorAtualizado * qtde;

              item.valor_total = parseFloat(valorTotal.toFixed(2));

              valor = valorAtualizado;
            }

            item.valor_fator_financeiro = 0;
            item.valor_fator_financeiro_unitario = null;
            item.valor_fator_financeiro_produto = this.formatacaoService.quatroCasasDecimais(valor);

            let valorFatorFinanceiroTotal: number = valor * qtde;

            item.valor_fator_financeiro_total = parseFloat(valorFatorFinanceiroTotal.toFixed(2));
          }
        }

        /* Produtos Original p/ Produtos */

        if (item.categoria == this.campanhas) {
          /* Campanha */

          let produto: ProdutoPromocional = this.produtos.find(produtoOriginal => produtoOriginal.id_campanha == item.id_campanha);

          if (produto != null) {
            if (produto.produtos_vinculados != null) {
              /* Produtos Vinculados */

              produto.produtos_vinculados.forEach((subItem) => {
                let produtoVinculado: ProdutoPromocional = item.produtos_vinculados.find(produtoVinculado => produtoVinculado.id == subItem.id);

                if (produtoVinculado != null) {
                  /* Inicial */

                  subItem.porcentagem_fator_inicial = produtoVinculado.porcentagem_fator_inicial;
                  subItem.valor_fator_financeiro_tabela = produtoVinculado.valor_fator_financeiro_tabela;
                  subItem.valor_fator_financeiro_inicial = produtoVinculado.valor_fator_financeiro_inicial;
                  subItem.valor_fator_financeiro_tabela_fracionado = produtoVinculado.valor_fator_financeiro_tabela_fracionado;

                  /* Processado */

                  subItem.valor_fator_financeiro = produtoVinculado.valor_fator_financeiro;
                  subItem.valor_fator_financeiro_unitario = produtoVinculado.valor_fator_financeiro_unitario;
                  subItem.valor_fator_financeiro_produto = produtoVinculado.valor_fator_financeiro_produto;
                  subItem.valor_fator_financeiro_total = produtoVinculado.valor_fator_financeiro_total;
                }
              });

              /* Produtos (Produtos Vinculados) */

              /* Inicial */

              produto.porcentagem_fator_inicial = item.porcentagem_fator_inicial;
              produto.valor_fator_financeiro_tabela = item.valor_fator_financeiro_tabela;
              produto.valor_fator_financeiro_inicial = item.valor_fator_financeiro_inicial;
              produto.valor_fator_financeiro_tabela_fracionado = item.valor_fator_financeiro_tabela_fracionado;

              /* Processado */

              produto.valor_fator_financeiro = item.valor_fator_financeiro;
              produto.valor_fator_financeiro_unitario = item.valor_fator_financeiro_unitario;
              produto.valor_fator_financeiro_produto = item.valor_fator_financeiro_produto;
              produto.valor_fator_financeiro_total = item.valor_fator_financeiro_total;
            }
          }
        } else {
          /* Produtos */

          let produto: ProdutoPromocional = this.produtos.find(produtoOriginal => produtoOriginal.id == item.id);

          if (produto != null) {
            /* Inicial */

            produto.porcentagem_fator_inicial = item.porcentagem_fator_inicial;
            produto.valor_fator_financeiro_tabela = item.valor_fator_financeiro_tabela;
            produto.valor_fator_financeiro_inicial = item.valor_fator_financeiro_inicial;
            produto.valor_fator_financeiro_tabela_fracionado = item.valor_fator_financeiro_tabela_fracionado;

            /* Processado */

            produto.valor_fator_financeiro = item.valor_fator_financeiro;
            produto.valor_fator_financeiro_unitario = item.valor_fator_financeiro_unitario;

            produto.valor = item.valor; /* Atualiza valor */
            produto.valor_total = item.valor_total; /* Atualiza valor */

            produto.valor_fator_financeiro_produto = item.valor_fator_financeiro_produto;
            produto.valor_fator_financeiro_total = item.valor_fator_financeiro_total;
          }
        }
      });

      if (!this.exibirFatorFinanceiro && this.configuracao != null && this.configuracao.utiliza_fator_financeiro) {
        this.exibirFatorFinanceiro = true;
      }
    } else {
      /* S/ Fator */

      /* Produtos Original */

      this.produtosOriginal.forEach((item) => {
        if (item.produtos_vinculados != null) {
          /* Produtos Vinculados */

          item.produtos_vinculados.forEach((subItem) => {
            let qtde: number = subItem.qtde != null && subItem.qtde > 0 ? subItem.qtde : 0;
            let valorCalculoInicial: number = subItem.price_promotional != null && subItem.price_promotional > 0 ? subItem.price_promotional : subItem.price;

            /* Inicial */

            subItem.porcentagem_fator_inicial = 0;
            subItem.valor_fator_financeiro_tabela = 0;
            subItem.valor_fator_financeiro_inicial = 0;
            subItem.valor_fator_financeiro_tabela_fracionado = 0;

            /* Processado */

            subItem.valor_fator_financeiro = 0;
            subItem.valor_fator_financeiro_unitario = null;
            subItem.valor_fator_financeiro_produto = this.formatacaoService.quatroCasasDecimais(valorCalculoInicial);

            let valorFatorFinanceiroProduto: number = valorCalculoInicial * qtde;

            subItem.valor_fator_financeiro_total = parseFloat(valorFatorFinanceiroProduto.toFixed(2));
          });

          /* Produtos (Produtos Vinculados) */

          /* Inicial */

          item.porcentagem_fator_inicial = 0;
          item.valor_fator_financeiro_tabela = 0;
          item.valor_fator_financeiro_inicial = 0;
          item.valor_fator_financeiro_tabela_fracionado = 0;

          /* Processado */

          item.valor_fator_financeiro = 0;
          item.valor_fator_financeiro_unitario = null;

          let valorFatorFinanceiroProduto: number = item.price_promotional != null && item.price_promotional > 0 ? item.price_promotional : item.price;

          if (item.grupo_estoque == this.combo) {
            valorFatorFinanceiroProduto = item.valor != null ? item.valor : 0;

            item.valor_fator_financeiro_produto = this.formatacaoService.quatroCasasDecimais(valorFatorFinanceiroProduto);
          } else {
            item.valor_fator_financeiro_produto = this.formatacaoService.quatroCasasDecimais(valorFatorFinanceiroProduto);
          }

          let valorFatorFinanceiroTotal: number = 0;

          if (item.grupo_estoque == this.combo) {
            valorFatorFinanceiroTotal = item.valor_total;
          } else {
            let qtde: number = item.qtde != null && item.qtde > 0 ? item.qtde : 1;

            valorFatorFinanceiroTotal = valorFatorFinanceiroProduto * qtde;
          }

          item.valor_fator_financeiro_total = parseFloat(valorFatorFinanceiroTotal.toFixed(2));
        } else {
          /* Produtos */

          /* Inicial */

          item.porcentagem_fator_inicial = 0;
          item.valor_fator_financeiro_tabela = 0;
          item.valor_fator_financeiro_inicial = 0;
          item.valor_fator_financeiro_tabela_fracionado = 0;

          /* Processado */

          item.valor_fator_financeiro = 0;
          item.valor_fator_financeiro_unitario = null;

          let valorFatorFinanceiroProduto: number = item.valor != null ? item.valor : 0;

          item.valor_fator_financeiro_produto = this.formatacaoService.quatroCasasDecimais(valorFatorFinanceiroProduto);
          item.valor_fator_financeiro_total = parseFloat(item.valor_total.toFixed(2));
        }

        /* Produtos Original p/ Produtos */

        if (item.categoria == this.campanhas) {
          /* Campanha */

          let produto: ProdutoPromocional = this.produtos.find(produtoOriginal => produtoOriginal.id_campanha == item.id_campanha);

          if (produto != null) {
            if (produto.produtos_vinculados != null) {
              /* Produtos Vinculados */

              produto.produtos_vinculados.forEach((subItem) => {
                let produtoVinculado: ProdutoPromocional = item.produtos_vinculados.find(produtoVinculado => produtoVinculado.id == subItem.id);

                if (produtoVinculado != null) {
                  /* Inicial */

                  subItem.porcentagem_fator_inicial = produtoVinculado.porcentagem_fator_inicial;
                  subItem.valor_fator_financeiro_tabela = produtoVinculado.valor_fator_financeiro_tabela;
                  subItem.valor_fator_financeiro_inicial = produtoVinculado.valor_fator_financeiro_inicial;
                  subItem.valor_fator_financeiro_tabela_fracionado = produtoVinculado.valor_fator_financeiro_tabela_fracionado;

                  /* Processado */

                  subItem.valor_fator_financeiro = produtoVinculado.valor_fator_financeiro;
                  subItem.valor_fator_financeiro_unitario = produtoVinculado.valor_fator_financeiro_unitario;
                  subItem.valor_fator_financeiro_produto = produtoVinculado.valor_fator_financeiro_produto;
                  subItem.valor_fator_financeiro_total = produtoVinculado.valor_fator_financeiro_total;
                }
              });

              /* Produto (Produtos Vinculados) */

              /* Inicial */

              produto.porcentagem_fator_inicial = item.porcentagem_fator_inicial;
              produto.valor_fator_financeiro_tabela = item.valor_fator_financeiro_tabela;
              produto.valor_fator_financeiro_inicial = item.valor_fator_financeiro_inicial;
              produto.valor_fator_financeiro_tabela_fracionado = item.valor_fator_financeiro_tabela_fracionado;

              /* Processado */

              produto.valor_fator_financeiro = item.valor_fator_financeiro;
              produto.valor_fator_financeiro_unitario = item.valor_fator_financeiro_unitario;
              produto.valor_fator_financeiro_produto = item.valor_fator_financeiro_produto;
              produto.valor_fator_financeiro_total = item.valor_fator_financeiro_total;
            }
          }
        } else {
          /* Produto */

          let produto: ProdutoPromocional = this.produtos.find(produtoOriginal => produtoOriginal.id == item.id);

          if (produto != null) {
            /* Inicial */

            produto.porcentagem_fator_inicial = item.porcentagem_fator_inicial;
            produto.valor_fator_financeiro_tabela = item.valor_fator_financeiro_tabela;
            produto.valor_fator_financeiro_inicial = item.valor_fator_financeiro_inicial;
            produto.valor_fator_financeiro_tabela_fracionado = item.valor_fator_financeiro_tabela_fracionado;

            /* Processado */

            produto.valor_fator_financeiro = item.valor_fator_financeiro;
            produto.valor_fator_financeiro_unitario = item.valor_fator_financeiro_unitario;
            produto.valor_fator_financeiro_produto = item.valor_fator_financeiro_produto;
            produto.valor_fator_financeiro_total = item.valor_fator_financeiro_total;
          }
        }
      });
    }

    /* Produtos Original p/ Produtos Adicionados */

    this.produtosOriginal.forEach((item) => {
      if (item.categoria == this.campanhas) {
        /* Campanha */

        let produto: ProdutoPromocional = this.produtosAdicionados.find(produtoOriginal => produtoOriginal.id_campanha == item.id_campanha);

        if (produto != null) {
          if (produto.produtos_vinculados != null) {
            /* Produtos Vinculados */

            produto.produtos_vinculados.forEach((subItem) => {
              let produtoVinculado: ProdutoPromocional = item.produtos_vinculados.find(produtoVinculado => produtoVinculado.id == subItem.id);

              if (produtoVinculado != null) {
                /* Inicial */

                subItem.porcentagem_fator_inicial = produtoVinculado.porcentagem_fator_inicial;
                subItem.valor_fator_financeiro_tabela = produtoVinculado.valor_fator_financeiro_tabela;
                subItem.valor_fator_financeiro_inicial = produtoVinculado.valor_fator_financeiro_inicial;
                subItem.valor_fator_financeiro_tabela_fracionado = produtoVinculado.valor_fator_financeiro_tabela_fracionado;

                /* Processado */

                subItem.valor_fator_financeiro = produtoVinculado.valor_fator_financeiro;
                subItem.valor_fator_financeiro_unitario = produtoVinculado.valor_fator_financeiro_unitario;
                subItem.valor_fator_financeiro_produto = produtoVinculado.valor_fator_financeiro_produto;
                subItem.valor_fator_financeiro_total = produtoVinculado.valor_fator_financeiro_total;
              }
            });

            /* Produto (Produtos Vinculados) */

            /* Inicial */

            produto.porcentagem_fator_inicial = item.porcentagem_fator_inicial;
            produto.valor_fator_financeiro_tabela = item.valor_fator_financeiro_tabela;
            produto.valor_fator_financeiro_inicial = item.valor_fator_financeiro_inicial;
            produto.valor_fator_financeiro_tabela_fracionado = item.valor_fator_financeiro_tabela_fracionado;

            /* Processado */

            produto.valor_fator_financeiro = item.valor_fator_financeiro;
            produto.valor_fator_financeiro_unitario = item.valor_fator_financeiro_unitario;
            produto.valor_fator_financeiro_produto = item.valor_fator_financeiro_produto;
            produto.valor_fator_financeiro_total = item.valor_fator_financeiro_total;
          }
        }
      } else {
        /* Produto */

        let produto: ProdutoPromocional = this.produtosAdicionados.find(produtoOriginal => produtoOriginal.id == item.id);

        if (produto != null) {
          /* Inicial */

          produto.porcentagem_fator_inicial = item.porcentagem_fator_inicial;
          produto.valor_fator_financeiro_tabela = item.valor_fator_financeiro_tabela;
          produto.valor_fator_financeiro_inicial = item.valor_fator_financeiro_inicial;
          produto.valor_fator_financeiro_tabela_fracionado = item.valor_fator_financeiro_tabela_fracionado;

          /* Processado */

          produto.valor_fator_financeiro = item.valor_fator_financeiro;
          produto.valor_fator_financeiro_unitario = item.valor_fator_financeiro_unitario;

          produto.valor = item.valor; /* Atualiza valor */
          produto.valor_total = item.valor_total; /* Atualiza valor */

          produto.valor_fator_financeiro_produto = item.valor_fator_financeiro_produto;
          produto.valor_fator_financeiro_total = item.valor_fator_financeiro_total;
        }
      }
    });

    this.calcularImpostoProdutosOriginal();
  }

  /* Fator / Campanha */

  calcularFatorFinanceiroCampanha() {
    if (this.produtoCampanhaSelecionado != null) {
      /* Processado */

      let qtde: number = this.produtoCampanhaSelecionado.qtde != null && this.produtoCampanhaSelecionado.qtde > 0 ? this.produtoCampanhaSelecionado.qtde : 0;
      let valorFatorFinanceiroUnitario: number = this.produtoCampanhaSelecionado.produtos_vinculados.filter(produtosVinculados => !produtosVinculados.bonificacao).reduce((sum, current) => (sum + current.valor_fator_financeiro), 0);
      let valorFatorFinanceiroTotal: number = this.produtoCampanhaSelecionado.produtos_vinculados.filter(produtosVinculados => !produtosVinculados.bonificacao).reduce((sum, current) => (sum + current.valor_fator_financeiro_total), 0);
      let valorFatorFinanceiro: number = valorFatorFinanceiroUnitario * qtde;

      this.produtoCampanhaSelecionado.valor_fator_financeiro = this.formatacaoService.quatroCasasDecimais(valorFatorFinanceiro);

      if (valorFatorFinanceiroUnitario > 0) {
        this.produtoCampanhaSelecionado.valor_fator_financeiro_unitario = this.formatacaoService.quatroCasasDecimais(valorFatorFinanceiroUnitario);
      } else {
        this.produtoCampanhaSelecionado.valor_fator_financeiro_unitario = null;
      }

      this.produtoCampanhaSelecionado.valor_fator_financeiro_produto = this.formatacaoService.quatroCasasDecimais(valorFatorFinanceiroTotal);

      let valorFatorFinanceiroTotalCampanha: number = 0;

      if (this.produtoCampanhaSelecionado.grupo_estoque == this.combo) {
        valorFatorFinanceiroTotalCampanha = this.produtoCampanhaSelecionado.valor_total;
      } else {
        qtde = qtde > 0 ? qtde : 1;

        valorFatorFinanceiroTotalCampanha = valorFatorFinanceiroTotal * qtde;
      }

      this.produtoCampanhaSelecionado.valor_fator_financeiro_total = parseFloat(valorFatorFinanceiroTotalCampanha.toFixed(2));
    }

    /* Pontuação (Campanha Selecionada) */

    if (this.exibirPontuacao && this.produtoCampanhaSelecionado != null) {
      const campanhaQtdeFin: number = this.produtoCampanhaSelecionado.qtde != null && this.produtoCampanhaSelecionado.qtde > 0 ? this.produtoCampanhaSelecionado.qtde : 0;
      this.produtoCampanhaSelecionado.pontuacao_calculada =
        this.produtoCampanhaSelecionado.produtos_vinculados
          .filter((pv) => !pv.bonificacao)
          .reduce((sum, pv) => sum + (pv.pontuacao_calculada != null ? pv.pontuacao_calculada : 0), 0) * campanhaQtdeFin;
    }

    this.calcularImpostoCampanha();
  }

  /* Fator / Campanha / Produto */

  calcularFatorFinanceiroCampanhaProduto(id_produto: number) {
    if (this.produtoCampanhaSelecionado != null) {

      let produtoVinculado = this.produtoCampanhaSelecionado.produtos_vinculados.find(produtosVinculados => produtosVinculados.id == id_produto);

      if (produtoVinculado != null) {
        let qtde: number = produtoVinculado.qtde != null && produtoVinculado.qtde > 0 ? produtoVinculado.qtde : 0;
        let valorCalculoInicial: number = produtoVinculado.price_promotional != null && produtoVinculado.price_promotional > 0 ? produtoVinculado.price_promotional : produtoVinculado.price;

        /* Processado */

        if (qtde > 0) {
          let valorFatorFinanceiro: number = produtoVinculado.valor_fator_financeiro_inicial * qtde;

          produtoVinculado.valor_fator_financeiro = this.formatacaoService.quatroCasasDecimais(valorFatorFinanceiro);
        } else {
          produtoVinculado.valor_fator_financeiro = 0;
        }

        if (produtoVinculado.valor_fator_financeiro_inicial > 0) {
          produtoVinculado.valor_fator_financeiro_unitario = this.formatacaoService.quatroCasasDecimais(produtoVinculado.valor_fator_financeiro_inicial);
        } else {
          produtoVinculado.valor_fator_financeiro_unitario = null;
        }

        let valorFatorFinanceiroProduto: number = valorCalculoInicial + produtoVinculado.valor_fator_financeiro_inicial;

        produtoVinculado.valor_fator_financeiro_produto = this.formatacaoService.quatroCasasDecimais(valorFatorFinanceiroProduto);

        let valorFatorFinanceiroTotal: number = valorFatorFinanceiroProduto * qtde;

        produtoVinculado.valor_fator_financeiro_total = parseFloat(valorFatorFinanceiroTotal.toFixed(2));

        /* Igual aos produtos normais: valor unitário inclui o fator financeiro */
        produtoVinculado.valor = this.formatacaoService.quatroCasasDecimais(valorFatorFinanceiroProduto);
        produtoVinculado.valor_total = produtoVinculado.valor_fator_financeiro_total;

        /* Manter valor_total_produtos_vinculados sincronizado */
        this.produtoCampanhaSelecionado.valor_total_produtos_vinculados =
          this.produtoCampanhaSelecionado.produtos_vinculados
            .filter(pv => !pv.bonificacao)
            .reduce((sum, pv) => sum + (pv.valor_total != null ? pv.valor_total : 0), 0);

        /* Para COMBO: manter o valor unitário da campanha em sincronia */
        if (this.produtoCampanhaSelecionado.grupo_estoque == this.combo) {
          this.produtoCampanhaSelecionado.valor = this.produtoCampanhaSelecionado.valor_total_produtos_vinculados > 0
            ? this.produtoCampanhaSelecionado.valor_total_produtos_vinculados
            : null;
        }

        if (produtoVinculado.valor_fator_financeiro != 0) {
          this.exibirFatorFinanceiro = true;
        }

        /* Pontuação */

        if (this.exibirPontuacao) {
          const produtoBaseVinculado = this.produtosOriginal.find((p) => p.id == id_produto && p.categoria != this.campanhas);

          if (produtoBaseVinculado != null) {
            produtoVinculado.pontuacao = produtoBaseVinculado.pontuacao;
            produtoVinculado.valor_litragem = produtoBaseVinculado.valor_litragem;
          }

          const pontuacaoVinculado: number = produtoVinculado.pontuacao != null ? produtoVinculado.pontuacao : 0;
          const litragemVinculado: number = produtoVinculado.valor_litragem != null ? produtoVinculado.valor_litragem : 0;
          const fatorPontuacaoVinculado: number = this.prazoPagamentoSelecionado != null && this.prazoPagamentoSelecionado.fator_pontuacao != null ? this.prazoPagamentoSelecionado.fator_pontuacao : 0;

          if (pontuacaoVinculado > 0 && litragemVinculado > 0 && qtde > 0) {
            const pontuacaoFinalVinculado: number = qtde * pontuacaoVinculado * litragemVinculado * (1 + (fatorPontuacaoVinculado / 100));
            produtoVinculado.pontuacao_calculada = Math.round(pontuacaoFinalVinculado > 0 ? pontuacaoFinalVinculado : 0);
          } else {
            produtoVinculado.pontuacao_calculada = 0;
          }

          /* Atualizar pontuação total da campanha */
          const campanhaQtdeVin: number = this.produtoCampanhaSelecionado.qtde != null && this.produtoCampanhaSelecionado.qtde > 0 ? this.produtoCampanhaSelecionado.qtde : 0;
          this.produtoCampanhaSelecionado.pontuacao_calculada =
            this.produtoCampanhaSelecionado.produtos_vinculados
              .filter((pv) => !pv.bonificacao)
              .reduce((sum, pv) => sum + (pv.pontuacao_calculada != null ? pv.pontuacao_calculada : 0), 0) * campanhaQtdeVin;
        }
      }
    }

    this.calcularImpostoCampanhaProduto(id_produto);
  }

  /* Fator / Produto */

  calcularFatorFinanceiroProduto(id_produto: number, adicionado: boolean) {
    let produto: ProdutoPromocional = null;

    if (adicionado) {
      produto = this.produtosAdicionados.find(produtoAdicionado => produtoAdicionado.id == id_produto);
    } else {
      produto = this.produtos.find(produto => produto.id == id_produto);
    }

    if (produto != null) {
      if (this.configuracao != null && !this.configuracao.prazo_pagamento_antes_itenspedido && this.configuracao.utiliza_fator_financeiro) {
        const price = produto.price != null ? Number(produto.price) : 0;
        const qtde = produto.qtde != null && produto.qtde > 0 ? Number(produto.qtde) : 0;

        if (!isFinite(price) || price <= 0) {
          produto.valor_fator_financeiro_unitario = 0;
          produto.valor_fator_financeiro = 0;
          produto.valor_fator_financeiro_produto = this.formatacaoService.quatroCasasDecimais(produto.valor != null ? produto.valor : 0);
          produto.valor_fator_financeiro_total = parseFloat((produto.valor_total != null ? produto.valor_total : 0).toFixed(2));
          this.calcularImpostoProduto(produto.id, adicionado);
          return;
        }

        if (produto.aplica_fator_financeiro && produto.qtde_lote == 0) {
          /* C/ Fator */

          // fator % (pode ser negativo)
          let fPerc = 0;
          if (this.prazoPagamentoSelecionado != null) {
            fPerc = this.prazoPagamentoSelecionado.fator_financeiro != null ? Number(this.prazoPagamentoSelecionado.fator_financeiro) : 0;
          }

          if (!isFinite(fPerc)) fPerc = 0;

          // valor unitário final (já com desconto aplicado)
          const valorUnitarioFinal = produto.valor != null ? Number(produto.valor) : price;

          // delta unitário em R$ (fator sobre valor com desconto)
          const deltaUnit = valorUnitarioFinal * (fPerc / 100);
          produto.valor_fator_financeiro_unitario = this.formatacaoService.quatroCasasDecimais(deltaUnit);

          // delta total do item (deltaUnit * qtde)
          const deltaTotal = (isFinite(qtde) && qtde > 0) ? (deltaUnit * qtde) : 0;
          produto.valor_fator_financeiro = this.formatacaoService.quatroCasasDecimais(deltaTotal);

          // valor com fator (unitário)
          const unitarioComFator = valorUnitarioFinal + deltaUnit;
          produto.valor_fator_financeiro_produto = this.formatacaoService.quatroCasasDecimais(unitarioComFator);

          // total com fator
          const totalComFator = (isFinite(qtde) && qtde > 0) ? (unitarioComFator * qtde) : unitarioComFator;
          produto.valor_fator_financeiro_total = parseFloat(totalComFator.toFixed(2));
        } else {
          /* S/ Fator */

          produto.valor_fator_financeiro_unitario = 0;
          produto.valor_fator_financeiro = 0;
          produto.valor_fator_financeiro_produto = this.formatacaoService.quatroCasasDecimais(price);
          produto.valor_fator_financeiro_total = parseFloat((price * qtde).toFixed(2));
        }
      } else {
        /* S/ Fator */

        produto.valor_fator_financeiro_unitario = 0;
        produto.valor_fator_financeiro = 0;
        produto.valor_fator_financeiro_produto = this.formatacaoService.quatroCasasDecimais(produto.valor != null ? produto.valor : 0);
        produto.valor_fator_financeiro_total = parseFloat((produto.valor_total != null ? produto.valor_total : 0).toFixed(2));
      }

      this.calcularImpostoProduto(produto.id, adicionado);
    }
  }

  /* Fracionado / Produto */

  calcularFracionadoProduto(produto: ProdutoPromocional): ProdutoPromocional {
    if (produto.valor != null && produto.valor > 0) {
      const litragem: number = produto.valor_litragem != null && produto.valor_litragem > 0 ? Number(produto.valor_litragem) : 0;

      const valorImpostoProduto: number = produto.valor_imposto_produto != null ? produto.valor_imposto_produto : 0;

      const valorUnitarioFracionado: number = litragem > 0 ? produto.valor / litragem : produto.valor;
      const valorUnitarioImpostoFracionado: number = litragem > 0 ? valorImpostoProduto / litragem : valorImpostoProduto;

      produto.valor_unitario_fracionado = this.formatacaoService.quatroCasasDecimais(valorUnitarioFracionado);

      if (produto.qtde != null && produto.qtde > 0) {
        produto.valor_unitario_imposto_fracionado = this.formatacaoService.quatroCasasDecimais(valorUnitarioImpostoFracionado);
      } else {
        produto.valor_unitario_imposto_fracionado = null;
      }
    } else {
      produto.valor_unitario_fracionado = null;
      produto.valor_unitario_imposto_fracionado = null;
    }

    return produto;
  }

  private litragemProduto(produto: ProdutoPromocional): number {
    return produto != null && produto.valor_litragem != null && produto.valor_litragem > 0 ? Number(produto.valor_litragem) : 0;
  }

  private valorProdutoParaFracionado(produto: ProdutoPromocional): number {
    if (produto == null) { return 0; }
    if (produto.price != null && produto.price > 0) { return Number(produto.price); }
    if (produto.valor != null && produto.valor > 0) { return Number(produto.valor); }
    if (produto.valor_tabela != null && produto.valor_tabela > 0) { return Number(produto.valor_tabela); }
    return 0;
  }

  precoFracionadoReferencia(produto: ProdutoPromocional): number {
    if (produto == null) { return 0; }
    const base: number = this.valorProdutoParaFracionado(produto);
    if (base <= 0) { return 0; }
    const litragem: number = this.litragemProduto(produto);
    return litragem > 0 ? base / litragem : base;
  }

  precoFracionadoComFatorReferencia(produto: ProdutoPromocional): number {
    if (produto == null) { return 0; }
    let base: number = produto.valor_fator_financeiro_tabela != null && produto.valor_fator_financeiro_tabela > 0 ? Number(produto.valor_fator_financeiro_tabela) : 0;
    if (base <= 0) {
      const bruto: number = this.valorProdutoParaFracionado(produto);
      const fator: number = this.fatorFinanceiroAtual(produto);
      base = fator !== 0 ? bruto * (1 + (fator / 100)) : bruto;
    }
    if (base <= 0) { return 0; }
    const litragem: number = this.litragemProduto(produto);
    return litragem > 0 ? base / litragem : base;
  }

  /* Imposto */

  calcularImposto(produto: ProdutoPromocional): number {
    if (produto != null) {
      if (produto.qtde != null && produto.qtde > 0) {
        let valorProduto: number = 0;

        if (produto.id_campanha != null) {
          valorProduto = produto.valor_fator_financeiro_produto;
        } else {
          valorProduto = produto.valor;
        }

        /* ST */

        let valorST: number = 0;

        if (produto.pauta_icmssub > 0 && produto.icms_destino > 0 && produto.icms_interno) {
          valorST = ((produto.qtde * produto.pauta_icmssub) * (produto.icms_destino / 100) - (produto.qtde * valorProduto) * (produto.icms_interno / 100));
        }

        /* IPI */

        let valorIPI: number = 0;

        if (produto.ipi_tipoindice == 1 && produto.ipi_indice > 0) {
          valorIPI = (produto.qtde * valorProduto * (produto.ipi_indice / 100));
        }

        /* IVA */

        let valorIVA: number = 0;

        if (produto.iva > 0 && produto.icms_destino && produto.icms_interno > 0) {
          let produtoIPI: number = ((valorProduto * produto.qtde) + valorIPI);

          valorIVA = ((produtoIPI * (1 + (produto.iva / 100))) * (produto.icms_destino / 100)) - (valorProduto * produto.qtde * (produto.icms_interno / 100));
        }

        return valorST + valorIPI + valorIVA;
      } else {
        return 0;
      }
    } else {
      return 0;
    }
  }

  /* Imposto / Campanha */

  calcularImpostoCampanha() {
    if (this.produtoCampanhaSelecionado != null) {
      let qtde: number = this.produtoCampanhaSelecionado.qtde != null && this.produtoCampanhaSelecionado.qtde > 0 ? this.produtoCampanhaSelecionado.qtde : 0;
      let valorCampanhaImpostoUnitario: number = this.produtoCampanhaSelecionado.produtos_vinculados.filter(produtosVinculados => !produtosVinculados.bonificacao).reduce((sum, current) => (sum + current.valor_imposto), 0);
      let valorCampanhaImpostoTotal: number = this.produtoCampanhaSelecionado.produtos_vinculados.filter(produtosVinculados => !produtosVinculados.bonificacao).reduce((sum, current) => (sum + current.valor_imposto_total), 0);

      /* Imposto */

      this.produtoCampanhaSelecionado.valor_imposto = this.formatacaoService.quatroCasasDecimais(valorCampanhaImpostoUnitario * qtde);
      this.produtoCampanhaSelecionado.valor_imposto_unitario = this.formatacaoService.quatroCasasDecimais(valorCampanhaImpostoUnitario);

      if (valorCampanhaImpostoTotal > 0) {
        this.produtoCampanhaSelecionado.valor_imposto_produto = this.formatacaoService.quatroCasasDecimais(valorCampanhaImpostoTotal);
      } else {
        this.produtoCampanhaSelecionado.valor_imposto_produto = null;
      }

      let valorImpostoTotal: number = valorCampanhaImpostoTotal * qtde;

      this.produtoCampanhaSelecionado.valor_imposto_total = parseFloat(valorImpostoTotal.toFixed(2));

      this.produtoCampanhaSelecionado.valor_imposto_total_final = this.produtoCampanhaSelecionado.valor_imposto_total;

      if (qtde > 0) {
        this.produtoCampanhaSelecionado.valor_unitario_final = this.formatacaoService.quatroCasasDecimais(valorCampanhaImpostoTotal);
      } else {
        this.produtoCampanhaSelecionado.valor_unitario_final = 0;
      }
    }
  }

  /* Imposto / Campanha / Produto */

  calcularImpostoCampanhaProduto(id_produto?: number) {
    if (this.produtoCampanhaSelecionado != null) {
      if (this.configuracao != null && this.configuracao.flag_exibir_imposto_produto) {
        /* C/ Imposto */

        if (this.produtoCampanhaSelecionado.produtos_vinculados != null) {
          /* Produtos Vinculados */

          this.produtoCampanhaSelecionado.produtos_vinculados.forEach((item) => {
            if (id_produto == null || id_produto == item.id) {
              let qtde: number = item.qtde != null && item.qtde > 0 ? item.qtde : 0;
              let valor: number = item.valor != null ? item.valor : 0;

              /* Igual aos produtos normais: valor já inclui o fator financeiro */
              let valorCalculo: number = valor;

              /* Imposto */

              let valorImposto: number = this.calcularImposto(item);
              let valorImpostoUnitario: number = valorImposto / (qtde < 1 ? 1 : qtde);
              let valorImpostoProduto: number = valorCalculo + valorImpostoUnitario;
              let valorImpostoTotal: number = ((valorCalculo * qtde) + valorImposto);

              item.valor_imposto = this.formatacaoService.quatroCasasDecimais(valorImposto);
              item.valor_imposto_unitario = this.formatacaoService.quatroCasasDecimais(valorImpostoUnitario);

              if (valorImpostoProduto > 0) {
                item.valor_imposto_produto = this.formatacaoService.quatroCasasDecimais(valorImpostoProduto);
              } else {
                item.valor_imposto_produto = null;
              }

              item.valor_imposto_total = parseFloat(valorImpostoTotal.toFixed(2));

              item.valor_imposto_total_final = item.valor_imposto_total;

              if (item.bonificacao) {
                /* Bonificação */

                item.valor_unitario_final = 0;
              } else {
                if (qtde > 0) {
                  let valorUnitarioFinal: number = item.valor + item.valor_imposto_unitario;

                  item.valor_unitario_final = this.formatacaoService.quatroCasasDecimais(valorUnitarioFinal);
                } else {
                  item.valor_unitario_final = 0;
                }
              }
            }
          });
        }
      } else {
        /* S/ Imposto */

        if (this.produtoCampanhaSelecionado.produtos_vinculados != null) {
          /* Produtos Vinculados */

          this.produtoCampanhaSelecionado.produtos_vinculados.forEach((item) => {
            if (id_produto == null || id_produto == item.id) {
              /* Imposto */

              item.valor_imposto = 0;
              item.valor_imposto_unitario = 0;
              item.valor_imposto_produto = null;
              item.valor_imposto_total = parseFloat(item.valor_fator_financeiro_total.toFixed(2));

              item.valor_imposto_total_final = item.valor_imposto_total;

              let valorUnitarioFinal: number = item.valor + item.valor_imposto_unitario;

              item.valor_unitario_final = this.formatacaoService.quatroCasasDecimais(valorUnitarioFinal);
            }
          });
        }
      }

      this.calcularFatorFinanceiroCampanha();
    }
  }

  /* Imposto / Produto */

  calcularImpostoProduto(id_produto: number, adicionado: boolean) {
    let produto: ProdutoPromocional = null;

    if (adicionado) {
      produto = this.produtosAdicionados.find(produtoAdicionado => produtoAdicionado.id == id_produto);
    } else {
      produto = this.produtos.find(produto => produto.id == id_produto);
    }

    if (produto != null) {
      if (!produto.erro_qtde && !produto.erro_valor) {
        if ((produto.qtde != null && produto.qtde != 0) && (produto.valor != null && produto.valor != 0)) {
          let qtde: number = produto.qtde;

          if (this.configuracao != null && this.configuracao.flag_exibir_imposto_produto) {
            if (produto.multiplo == null || (qtde % produto.multiplo == 0)) {
              /* C/ Imposto */

              let valorImposto: number = this.calcularImposto(produto);
              let valorImpostoUnitario: number = this.formatacaoService.quatroCasasDecimais(valorImposto / qtde);
              let valorImpostoProduto: number = produto.valor + valorImpostoUnitario;
              let valorImpostoTotal: number = ((produto.valor * qtde) + valorImposto);

              produto.valor_imposto = this.formatacaoService.quatroCasasDecimais(valorImposto);
              produto.valor_imposto_unitario = this.formatacaoService.quatroCasasDecimais(valorImpostoUnitario);
              produto.valor_imposto_produto = this.formatacaoService.quatroCasasDecimais(valorImpostoProduto);
              produto.valor_imposto_total = parseFloat(valorImpostoTotal.toFixed(2));
            } else {
              /* Imposto */

              produto.valor_imposto = 0;
              produto.valor_imposto_unitario = 0;
              produto.valor_imposto_produto = null;
              produto.valor_imposto_total = 0;

              /* Total Fracionado */

              produto.valor_unitario_fracionado = null;
              produto.valor_unitario_imposto_fracionado = null;
            }
          } else {
            /* S/ Imposto */

            produto.valor_imposto = 0;
            produto.valor_imposto_unitario = 0;
            produto.valor_imposto_produto = null;

            let valorImpostoTotal: number = produto.valor * qtde;

            produto.valor_imposto_total = parseFloat(valorImpostoTotal.toFixed(2));
          }
        } else {
          /* Qtde (Bonificada) */

          /* S/ Imposto */

          /* Imposto */

          produto.valor_imposto = 0;
          produto.valor_imposto_unitario = 0;
          produto.valor_imposto_produto = null;
          produto.valor_imposto_total = 0;

          produto.valor_imposto_total_final = 0;

          let valorUnitarioFinal: number = produto.valor != null ? produto.valor : 0;

          produto.valor_unitario_final = this.formatacaoService.quatroCasasDecimais(valorUnitarioFinal);
        }

        /* Total Fracionado */

        if (produto.fracionado && (produto.qtde != null && produto.qtde != 0) && (produto.valor != null && produto.valor != 0)) {
          produto = this.calcularFracionadoProduto(produto);
        }
      } else {
        /* Imposto */

        produto.valor_imposto = 0;
        produto.valor_imposto_unitario = 0;
        produto.valor_imposto_produto = null;
        produto.valor_imposto_total = 0;

        /* Total Fracionado */

        produto.valor_unitario_fracionado = null;
        produto.valor_unitario_imposto_fracionado = null;
      }

      produto.valor_imposto_total_final = produto.valor_imposto_total;

      if (produto.qtde > 0) {
        let valorUnitarioFinal: number = produto.valor + produto.valor_imposto_unitario;

        produto.valor_unitario_final = this.formatacaoService.quatroCasasDecimais(valorUnitarioFinal);
      } else {
        produto.valor_unitario_final = 0;
      }

      if (this.exibirPontuacao) {
        this.calcularPontuacaoProduto(id_produto, adicionado);
      }
    }
  }

  /* Pontuação / Produto */

  calcularPontuacaoProduto(id_produto: number, adicionado: boolean) {
    let produto: ProdutoPromocional = null;
    if (adicionado) {
      produto = this.produtosAdicionados.find(function(p) { return p.id == id_produto; });
    } else {
      produto = this.produtos.find(function(p) { return p.id == id_produto; });
    }

    if (produto == null) { return; }

    if (produto.pontuacao == null || produto.pontuacao <= 0) {
      produto.pontuacao_calculada = 0;
      if (!adicionado) {
        this.sincronizarPontuacaoAdicionados(id_produto, 0);
      } else {
        /* Mesmo com pontuação zero, recalcular total para não zerar os demais */
        this.valorTotalPontuacaoProdutosAdicionados = this.produtosAdicionados
          .reduce(function(sum, current) { return sum + (current.pontuacao_calculada != null ? current.pontuacao_calculada : 0); }, 0);
      }
      return;
    }

    let qtde: number = produto.qtde != null && produto.qtde > 0 ? produto.qtde : 0;
    let price: number = produto.price != null && produto.price > 0 ? produto.price : 0;
    let valor: number = produto.valor != null ? produto.valor : 0;
    let valorLitragem: number = produto.valor_litragem != null ? produto.valor_litragem : 0;

    if (price <= 0 || qtde <= 0 || valorLitragem <= 0) {
      produto.pontuacao_calculada = 0;
      if (!adicionado) {
        this.sincronizarPontuacaoAdicionados(id_produto, 0);
      } else {
        /* Mesmo com dados insuficientes, recalcular total para não zerar os demais */
        this.valorTotalPontuacaoProdutosAdicionados = this.produtosAdicionados
          .reduce(function(sum, current) { return sum + (current.pontuacao_calculada != null ? current.pontuacao_calculada : 0); }, 0);
      }
      return;
    }

    /* Desconto usado sobre o price (%) */

    let descUsado: number = produto.desconto_digitado != null ? produto.desconto_digitado : 0;

    if (descUsado < 0) { descUsado = 0; }

    /* % Redução da pontuação pelo desconto = (24 × desc_usado) / 6
       Desconto 0% → redução 0% → fator 1.0 (pontuação plena)
       Desconto aumenta → redução aumenta → pontuação diminui */

    let percDescontoPontuacao: number = this.usaPontuacaoCliente ? 0 : (24 * descUsado) / 6;

    /* Fator pontuação do prazo (%) — ignorado quando flag_naoaplicafatorpontuacaofin está ativo */

    let fatorPontuacao: number = 0;

    if (!(produto as any).ignorar_pontuacao_por_tabela && this.prazoPagamentoSelecionado != null && this.prazoPagamentoSelecionado.fator_pontuacao != null) {
      fatorPontuacao = this.prazoPagamentoSelecionado.fator_pontuacao;    }

    /* Pontuação Final = Qtd × Pontuação × Litragem × (1 + fator_pontuacao / 100) × (1 - perc_desconto_pontuacao / 100) */

    let pontuacaoFinal: number = qtde * produto.pontuacao * valorLitragem * (1 + (fatorPontuacao / 100)) * (1 - percDescontoPontuacao / 100);

    produto.pontuacao_calculada = Math.round(pontuacaoFinal > 0 ? pontuacaoFinal : 0);

    /* Sincronizar com produtosAdicionados e atualizar total em tempo real (modal aberto) */
    if (!adicionado) {
      this.sincronizarPontuacaoAdicionados(id_produto, produto.pontuacao_calculada);
    } else {
      /* produto já é de produtosAdicionados — só recalcula o total */
      this.valorTotalPontuacaoProdutosAdicionados = this.produtosAdicionados
        .reduce(function(sum, current) { return sum + (current.pontuacao_calculada != null ? current.pontuacao_calculada : 0); }, 0);
    }
  }

  private sincronizarPontuacaoAdicionados(id_produto: number, pontuacao_calculada: number) {
    let produtoAdicionado = this.produtosAdicionados.find(function(p) { return p.id == id_produto; });
    if (produtoAdicionado != null) {
      produtoAdicionado.pontuacao_calculada = pontuacao_calculada;
    }

    /* Total dos produtos já confirmados */
    let total = this.produtosAdicionados
      .reduce(function(sum, current) { return sum + (current.pontuacao_calculada != null ? current.pontuacao_calculada : 0); }, 0);

    /* Inclui pontuação de produtos novos no modal (ainda não em produtosAdicionados) */
    if (this.produtos != null) {
      this.produtos.forEach((p) => {
        const jaAdicionado = this.produtosAdicionados.find(function(a) { return a.id == p.id; });
        if (jaAdicionado == null && p.pontuacao_calculada != null && p.pontuacao_calculada > 0) {
          total += p.pontuacao_calculada;
        }
      });
    }

    this.valorTotalPontuacaoProdutosAdicionados = total;
  }

  /* Imposto / Produtos (Original) */

  calcularImpostoProdutosOriginal() {
    this.produtosOriginal.forEach((item) => {
      if (item.produtos_vinculados != null) {
        /* Produtos Vinculados */

        item.produtos_vinculados.forEach((subItem) => {
          if (this.configuracao != null && this.configuracao.flag_exibir_imposto_produto) {
            /* C/ Imposto */

            let qtde: number = subItem.qtde != null && subItem.qtde > 0 ? subItem.qtde : 0;
            let valor: number = subItem.valor != null ? subItem.valor : 0;

            let valorFatorFinanceiroUnitario: number = subItem.valor_fator_financeiro_unitario != null ? subItem.valor_fator_financeiro_unitario : 0;
            let valorCalculo: number = valor + valorFatorFinanceiroUnitario;

            /* Imposto */

            let valorImposto: number = this.calcularImposto(subItem);
            let valorImpostoUnitario: number = valorImposto / (qtde < 1 ? 1 : qtde);
            let valorImpostoProduto: number = valorCalculo + valorImpostoUnitario;
            let valorImpostoTotal: number = ((valorCalculo * qtde) + valorImposto);

            subItem.valor_imposto = this.formatacaoService.quatroCasasDecimais(valorImposto);
            subItem.valor_imposto_unitario = this.formatacaoService.quatroCasasDecimais(valorImpostoUnitario);

            if (valorImpostoProduto > 0) {
              subItem.valor_imposto_produto = this.formatacaoService.quatroCasasDecimais(valorImpostoProduto);
            } else {
              subItem.valor_imposto_produto = null;
            }

            subItem.valor_imposto_total = parseFloat(valorImpostoTotal.toFixed(2));

            subItem.valor_imposto_total_final = subItem.valor_imposto_total;

            if (subItem.bonificacao) {
              /* Bonificação */

              subItem.valor_unitario_final = 0;
            } else {
              if (qtde > 0) {
                let valorFatorFinanceiroUnitario: number = subItem.valor_fator_financeiro_unitario != null ? subItem.valor_fator_financeiro_unitario : 0;
                let valorUnitarioFinal: number = valor + valorFatorFinanceiroUnitario + subItem.valor_imposto_unitario;

                subItem.valor_unitario_final = this.formatacaoService.quatroCasasDecimais(valorUnitarioFinal);
              } else {
                subItem.valor_unitario_final = 0;
              }
            }
          } else {
            /* S/ Imposto */

            /* Imposto */

            item.valor_imposto = 0;
            item.valor_imposto_unitario = 0;
            item.valor_imposto_produto = null;
            item.valor_imposto_total = parseFloat(item.valor_fator_financeiro_total.toFixed(2));

            item.valor_imposto_total_final = item.valor_imposto_total;

            let valorFatorFinanceiroUnitario: number = item.valor_fator_financeiro_unitario != null ? item.valor_fator_financeiro_unitario : 0;
            let valorUnitarioFinal: number = item.valor + valorFatorFinanceiroUnitario + item.valor_imposto_unitario;

            item.valor_unitario_final = this.formatacaoService.quatroCasasDecimais(valorUnitarioFinal);
          }
        });

        /* Produtos (Produtos Vinculados) */

        let qtde: number = item.qtde != null && item.qtde > 0 ? item.qtde : 0;
        let valorCampanhaImpostoUnitario: number = item.produtos_vinculados.filter(produtosVinculados => !produtosVinculados.bonificacao).reduce((sum, current) => (sum + current.valor_imposto), 0);
        let valorCampanhaImpostoTotal: number = item.produtos_vinculados.filter(produtosVinculados => !produtosVinculados.bonificacao).reduce((sum, current) => (sum + current.valor_imposto_total), 0);

        /* Imposto */

        item.valor_imposto = this.formatacaoService.quatroCasasDecimais(valorCampanhaImpostoUnitario * qtde);
        item.valor_imposto_unitario = this.formatacaoService.quatroCasasDecimais(valorCampanhaImpostoUnitario);

        if (valorCampanhaImpostoTotal > 0) {
          item.valor_imposto_produto = this.formatacaoService.quatroCasasDecimais(valorCampanhaImpostoTotal);
        } else {
          item.valor_imposto_produto = null;
        }

        let valorImpostoTotal: number = valorCampanhaImpostoTotal * qtde;

        item.valor_imposto_total = parseFloat(valorImpostoTotal.toFixed(2));

        item.valor_imposto_total_final = item.valor_imposto_total;

        if (qtde > 0) {
          item.valor_unitario_final = this.formatacaoService.quatroCasasDecimais(valorCampanhaImpostoTotal);
        } else {
          item.valor_unitario_final = 0;
        }
      } else {
        /* Produtos */

        let qtde: number = item.qtde != null && item.qtde > 0 ? item.qtde : 0;
        let valor: number = item.valor != null ? item.valor : 0;

        if (this.configuracao != null && this.configuracao.flag_exibir_imposto_produto) {
          /* C/ Imposto */

          /* Imposto */

          if (item.multiplo == null || (qtde % item.multiplo == 0)) {
            let valorImposto: number = this.calcularImposto(item);
            let valorImpostoUnitario: number = valorImposto / (qtde < 1 ? 1 : qtde);
            let valorImpostoProduto: number = valor + valorImpostoUnitario;
            let valorImpostoTotal: number = ((valor * qtde) + valorImposto);

            item.valor_imposto = this.formatacaoService.quatroCasasDecimais(valorImposto);
            item.valor_imposto_unitario = this.formatacaoService.quatroCasasDecimais(valorImpostoUnitario);

            if (qtde > 0) {
              item.valor_imposto_produto = this.formatacaoService.quatroCasasDecimais(valorImpostoProduto);
            } else {
              item.valor_imposto_produto = null;
            }

            item.valor_imposto_total = parseFloat(valorImpostoTotal.toFixed(2));

            item.valor_imposto_total_final = item.valor_imposto_total;

            if (qtde > 0) {
              let valorUnitarioFinal: number = valor + item.valor_imposto_unitario;

              item.valor_unitario_final = this.formatacaoService.quatroCasasDecimais(valorUnitarioFinal);
            } else {
              item.valor_unitario_final = 0;
            }
          } else {
            /* Imposto */

            item.valor_imposto = 0;
            item.valor_imposto_unitario = 0;
            item.valor_imposto_produto = null;
            item.valor_imposto_total = 0;

            item.valor_imposto_total_final = item.valor_imposto_total;

            item.valor_unitario_final = 0;
          }

          /* Total Fracionado */

          if (item.fracionado && (item.qtde != null && item.qtde != 0) && (item.valor != null && item.valor != 0)) {
            item = this.calcularFracionadoProduto(item);
          }
        } else {
          /* S/ Imposto */

          /* Imposto */

          item.valor_imposto = 0;
          item.valor_imposto_unitario = 0;
          item.valor_imposto_produto = null;

          let valorImpostoTotal: number = valor * qtde;

          item.valor_imposto_total = parseFloat(valorImpostoTotal.toFixed(2));

          item.valor_imposto_total_final = item.valor_imposto_total;

          if (item.qtde > 0) {
            let valorUnitarioFinal: number = item.valor + item.valor_imposto_unitario;

            item.valor_unitario_final = this.formatacaoService.quatroCasasDecimais(valorUnitarioFinal);
          } else {
            item.valor_unitario_final = 0;
          }
        }
      }

      /* Produtos Original p/ Produtos */

      if (item.categoria == this.campanhas) {
        /* Campanha */

        let produto: ProdutoPromocional = this.produtos.find(produtoOriginal => produtoOriginal.id_campanha == item.id_campanha);

        if (produto != null) {
          if (produto.produtos_vinculados != null) {
            /* Produtos Vinculados */

            produto.produtos_vinculados.forEach((subItem) => {
              let produtoVinculado: ProdutoPromocional = item.produtos_vinculados.find(produtoVinculado => produtoVinculado.id == subItem.id);

              if (produtoVinculado != null) {
                /* Imposto */

                subItem.valor_imposto = produtoVinculado.valor_imposto;
                subItem.valor_imposto_unitario = produtoVinculado.valor_imposto_unitario;
                subItem.valor_imposto_produto = produtoVinculado.valor_imposto_produto;
                subItem.valor_imposto_total = produtoVinculado.valor_imposto_total;

                subItem.valor_imposto_total_final = produtoVinculado.valor_imposto_total_final;

                subItem.valor_unitario_final = produtoVinculado.valor_unitario_final;
              }
            });

            /* Produtos (Produtos Vinculados) */

            /* Imposto */

            produto.valor_imposto = item.valor_imposto;
            produto.valor_imposto_unitario = item.valor_imposto_unitario;
            produto.valor_imposto_produto = item.valor_imposto_produto;
            produto.valor_imposto_total = item.valor_imposto_total;

            produto.valor_imposto_total_final = item.valor_imposto_total_final;

            produto.valor_unitario_final = item.valor_unitario_final;
          }
        }
      } else {
        /* Produtos */

        let produto: ProdutoPromocional = this.produtos.find(produtoOriginal => produtoOriginal.id == item.id);

        if (produto != null) {
          /* Imposto */

          produto.valor_imposto = item.valor_imposto;
          produto.valor_imposto_unitario = item.valor_imposto_unitario;
          produto.valor_imposto_produto = item.valor_imposto_produto;
          produto.valor_imposto_total = item.valor_imposto_total;

          produto.valor_imposto_total_final = item.valor_imposto_total_final;

          produto.valor_unitario_final = item.valor_unitario_final;

          /* Total Fracionado */

          produto.valor_unitario_fracionado = item.valor_unitario_fracionado;
          produto.valor_unitario_imposto_fracionado = item.valor_unitario_imposto_fracionado;
        }
      }
    });

    /* Produtos Original p/ Produtos Adicionados */

    this.produtosOriginal.forEach((item) => {
      if (item.categoria == this.campanhas) {
        /* Campanha */

        let produto: ProdutoPromocional = this.produtosAdicionados.find(produtoOriginal => produtoOriginal.id_campanha == item.id_campanha);

        if (produto != null) {
          if (produto.produtos_vinculados != null) {
            /* Produtos Vinculados */

            produto.produtos_vinculados.forEach((subItem) => {
              let produtoVinculado: ProdutoPromocional = item.produtos_vinculados.find(produtoVinculado => produtoVinculado.id == subItem.id);

              if (produtoVinculado != null) {
                /* Imposto */

                subItem.valor_imposto = produtoVinculado.valor_imposto;
                subItem.valor_imposto_unitario = produtoVinculado.valor_imposto_unitario;
                subItem.valor_imposto_produto = produtoVinculado.valor_imposto_produto;
                subItem.valor_imposto_total = produtoVinculado.valor_imposto_total;

                subItem.valor_imposto_total_final = produtoVinculado.valor_imposto_total_final;

                subItem.valor_unitario_final = produtoVinculado.valor_unitario_final;
              }
            });

            /* Produto (Produtos Vinculados) */

            /* Imposto */

            produto.valor_imposto = item.valor_imposto;
            produto.valor_imposto_unitario = item.valor_imposto_unitario;
            produto.valor_imposto_produto = item.valor_imposto_produto;
            produto.valor_imposto_total = item.valor_imposto_total;

            produto.valor_imposto_total_final = item.valor_imposto_total_final;

            produto.valor_unitario_final = item.valor_unitario_final;
          }
        }
      } else {
        /* Produto */

        let produto: ProdutoPromocional = this.produtosAdicionados.find(produtoOriginal => produtoOriginal.id == item.id);

        if (produto != null) {
          /* Imposto */

          produto.valor_imposto = item.valor_imposto;
          produto.valor_imposto_unitario = item.valor_imposto_unitario;
          produto.valor_imposto_produto = item.valor_imposto_produto;
          produto.valor_imposto_total = item.valor_imposto_total;

          produto.valor_imposto_total_final = item.valor_imposto_total_final;

          produto.valor_unitario_final = item.valor_unitario_final;

          /* Total Fracionado */

          produto.valor_unitario_fracionado = item.valor_unitario_fracionado;
          produto.valor_unitario_imposto_fracionado = item.valor_unitario_imposto_fracionado;
        }
      }
    });

    this.totalizarProdutosAdicionados();
  }

  /* Valor / Produto (Original) */

  calcularValorProdutoOriginal(produto: ProdutoPromocional): number {
    if (produto != null) {
      let valorCalculoInicial: number = 0;

      if (produto.estado_preco != null) {
        valorCalculoInicial = this.lerBaseDesconto(produto);
      } else if (produto.aplica_fator_financeiro) {
        /* C/ Fator */

        valorCalculoInicial = produto.valor_fator_financeiro_tabela != null ? produto.valor_fator_financeiro_tabela : 0;
      } else {
        /* S/ Fator */

        valorCalculoInicial = produto.valor_tabela != null && produto.valor_tabela > 0 ? produto.valor_tabela : produto.price;
      }

      if (produto.porcentagem_desconto_temporaria != null && !isNaN(produto.porcentagem_desconto_temporaria) && isFinite(produto.porcentagem_desconto_temporaria)) {
        if (produto.porcentagem_desconto_temporaria > 0 && produto.porcentagem_desconto_temporaria <= 100) {
          let valorDesconto: number = ((valorCalculoInicial * produto.porcentagem_desconto_temporaria) / 100);
          let valorCalculado: number = valorCalculoInicial - valorDesconto;

          if (valorCalculado >= 0) {
            return this.formatacaoService.quatroCasasDecimais(valorCalculado);
          }
        }
      } else if (produto.valor != null) {
        /* Respeitar o valor digitádo manualmente pelo usuário.
         * Antes retornava valorCalculoInicial (preço de tabela/promo),
         * sobrescrevendo o Unitário informado na tela. */
        return produto.valor;
      }

      return produto.valor;
    }
  }
}
